var _defs, _path, _g, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g3, _path11, _g4, _g5, _g6, _g7, _path12, _path13, _path14, _path15, _path16, _g8, _path17, _path18, _path19, _path20, _g9, _path21, _path22, _path23, _g10, _path24, _path25, _g11, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _g12, _g13, _g14, _g15, _path38, _path39, _path40, _g16, _path41, _g17, _path42, _g18, _g19, _g20, _g21, _path43, _path44, _path45, _g22, _g23, _g24, _path46, _path47, _g25, _path48, _path49, _path50, _path51, _path52, _path53, _g26, _path54, _g27, _g28, _g29, _path55, _path56, _path57, _path58, _path59, _path60, _g30, _path61, _g31, _path62, _path63, _g32, _g33, _path64, _path65, _path66, _path67, _path68, _g34, _g35, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _g36, _path82, _path83, _path84, _g37, _g38, _path85, _path86, _path87, _g39, _path88, _g40, _path89, _g41, _path90, _path91, _path92, _path93, _g42, _g43, _path94, _path95, _path96, _path97, _g44, _g45, _path98, _path99, _path100, _path101, _g46, _path102, _path103, _path104, _g47, _path105, _path106, _path107, _g48, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _g49, _g50, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _g51, _g52, _g53, _path135, _path136, _path137, _g54, _path138, _g55, _g56, _path139, _g57, _g58, _g59, _path140, _g60, _path141, _path142, _g61, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _g62, _path159, _path160, _path161, _g63, _g64, _g65, _path162, _g66, _g67, _path163, _path164, _path165, _g68, _path166, _path167, _g69, _g70, _g71, _path168, _path169, _path170, _path171, _path172, _path173, _g72, _g73, _path174, _path175, _g74, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _g75, _path186, _path187, _path188, _g76, _path189, _g77, _path190, _path191, _path192, _path193, _g78, _path194, _path195, _path196, _g79, _path197, _g80, _g81, _g82, _g83, _path198, _g84, _g85, _g86, _path199, _path200, _path201, _path202, _g87, _path203, _path204, _path205, _path206, _g88, _path207, _path208, _path209, _g89, _path210, _path211, _path212, _path213, _g90, _path214, _path215, _path216, _g91, _g92, _path217, _g93, _g94, _g95, _path218, _path219, _g96, _path220, _path221, _path222, _path223, _g97, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _g98, _g99, _g100, _path231, _g101, _g102, _g103, _path232, _path233, _g104, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _g105, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _g106, _g107, _path257, _path258, _path259, _path260, _g108, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _g109, _path274, _path275, _path276, _g110, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _g111, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _g112, _g113, _path297, _g114, _g115, _path298, _path299, _path300, _g116, _g117, _g118, _g119, _g120, _g121, _g122, _g123, _g124, _g125, _path301, _g126, _path302, _path303, _path304, _path305, _path306, _path307, _g127, _g128, _g129, _g130, _g131, _g132, _g133, _g134, _g135, _g136, _path308, _g137, _g138, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _g139, _path318, _g140, _g141, _g142, _g143, _g144, _g145, _g146, _g147, _g148, _g149, _g150, _path319, _path320, _g151, _g152, _g153, _path321, _path322, _path323, _path324, _g154, _g155, _g156, _g157, _g158, _g159, _g160, _g161, _g162, _g163, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _text, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _g164;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_231_1",
    "data-name": "Component 231 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 696.216,
    height: 738.829,
    viewBox: "0 0 696.216 738.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -17.88,
    y1: 3.297,
    x2: -19.554,
    y2: 5.447,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e6afa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.858,
    stopColor: "#0a0940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    stopColor: "#97b4fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cddbfd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -25.794,
    y1: 2.212,
    x2: -27.194,
    y2: 2.212,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#eebe2d",
    stopOpacity: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e48a20"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2071",
    "data-name": "Path 2071",
    d: "M442.214,181.695a2.946,2.946,0,0,1,4.03-.364q-1.5-5.158-2.989-10.32l-.395-1.364a2.941,2.941,0,0,0-4.03.364,2.724,2.724,0,0,0-.591,2.566l3.382,11.687A2.731,2.731,0,0,1,442.214,181.695Z",
    transform: "translate(-438.133 -169.012)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2075",
    "data-name": "Path 2075",
    d: "M439.716,170.519l3.382,11.687a2.67,2.67,0,0,0,.88,1.324l-3.384-11.687A2.665,2.665,0,0,1,439.716,170.519Z",
    transform: "translate(-439.716 -170.519)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2077",
    "data-name": "Path 2077",
    d: "M429.052,183.006q-1.692-5.842-3.382-11.684a4.914,4.914,0,0,0-6.742.608,4.571,4.571,0,0,0-1,4.3l3.384,11.687a4.573,4.573,0,0,1,1-4.3A4.915,4.915,0,0,1,429.052,183.006Z",
    transform: "translate(-417.755 -170.257)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2081",
    "data-name": "Path 2081",
    d: "M420.406,172.783l3.382,11.687a4.455,4.455,0,0,0,1.471,2.213L421.877,175A4.451,4.451,0,0,1,420.406,172.783Z",
    transform: "translate(-420.406 -172.783)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2083",
    "data-name": "Path 2083",
    d: "M449.172,195.526a8.822,8.822,0,0,1,12.094-1.083q-1.5-5.161-2.989-10.32l-.395-1.367a8.582,8.582,0,0,0-6.224-1.871q1.688,5.842,3.382,11.684c-.118-.411-.277-.955-.395-1.367l-.419-1.445c-.13-.452-.305-1.052-.435-1.5l-.442-1.53-.442-1.528c-.132-.452-.3-1.052-.435-1.5s-.293-1.014-.419-1.447l-.395-1.365a8.85,8.85,0,0,0-5.867,2.956C446.8,187.347,448.157,192.022,449.172,195.526Z",
    transform: "translate(-445.79 -180.85)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2086",
    "data-name": "Path 2086",
    d: "M446.028,183.895l3.384,11.684a7.935,7.935,0,0,1,10.883-.974l-3.382-11.687A7.936,7.936,0,0,0,446.028,183.895Z",
    transform: "translate(-446.028 -181.199)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2092",
    "data-name": "Path 2092",
    d: "M452.45,191.236l3.382,11.684a8.226,8.226,0,0,1,1.764-7.726l-3.382-11.684A8.217,8.217,0,0,0,452.45,191.236Z",
    transform: "translate(-452.131 -183.51)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2094",
    "data-name": "Path 2094",
    d: "M452.144,190.69l3.384,11.684a7.4,7.4,0,0,1,1.587-6.957l-3.384-11.684A7.409,7.409,0,0,0,452.144,190.69Z",
    transform: "translate(-451.857 -183.733)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2098",
    "data-name": "Path 2098",
    d: "M429.474,190.516a2.657,2.657,0,0,1,.873,1.315l-3.384-11.684a2.637,2.637,0,0,0-.873-1.317C427.1,182.336,427.464,187.47,429.474,190.516Z",
    transform: "translate(-426.09 -178.829)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2103",
    "data-name": "Path 2103",
    d: "M454.965,198.361a7.152,7.152,0,0,0,2.239,3.467l-3.382-11.687a7.158,7.158,0,0,1-2.242-3.467C452.6,190.181,453.951,194.854,454.965,198.361Z",
    transform: "translate(-451.581 -186.674)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2105",
    "data-name": "Path 2105",
    d: "M434.046,191.073l-3.384-11.687a2.731,2.731,0,0,1-.591,2.571,2.933,2.933,0,0,1-4.025.367l3.384,11.687a2.933,2.933,0,0,0,4.022-.367A2.734,2.734,0,0,0,434.046,191.073Z",
    transform: "translate(-426.046 -179.386)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2110",
    "data-name": "Path 2110",
    d: "M451.823,186.777l3.382,11.684a7.952,7.952,0,0,0,2.493,3.855l-3.382-11.687A7.94,7.94,0,0,1,451.823,186.777Z",
    transform: "translate(-451.823 -186.777)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2113",
    "data-name": "Path 2113",
    d: "M426.527,198.634a7.546,7.546,0,0,1,10.344-.932l-2.987-10.322-.395-1.364a7.345,7.345,0,0,0-5.323-1.6q1.688,5.842,3.382,11.684l-.395-1.365-.419-1.447c-.13-.449-.305-1.05-.435-1.5s-.31-1.069-.442-1.528l-.442-1.53c-.132-.449-.305-1.05-.435-1.5l-.419-1.445-.395-1.367h0a7.58,7.58,0,0,0-5.021,2.53Z",
    transform: "translate(-423.145 -184.386)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2115",
    "data-name": "Path 2115",
    d: "M423.382,187l3.382,11.684a6.663,6.663,0,0,1,9.138-.821l-3.382-11.687A6.665,6.665,0,0,0,423.382,187Z",
    transform: "translate(-423.382 -184.736)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2118",
    "data-name": "Path 2118",
    d: "M428.761,193.169l3.384,11.687a7.008,7.008,0,0,1,1.521-6.6l-3.384-11.687A7.015,7.015,0,0,0,428.761,193.169Z",
    transform: "translate(-428.491 -186.574)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2120",
    "data-name": "Path 2120",
    d: "M428.456,192.622l3.384,11.684a6.19,6.19,0,0,1,1.343-5.824L429.8,186.8A6.19,6.19,0,0,0,428.456,192.622Z",
    transform: "translate(-428.218 -186.798)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2122",
    "data-name": "Path 2122",
    d: "M423.14,191.423l3.384,11.684a2.727,2.727,0,0,1,.594-2.566,2.938,2.938,0,0,1,4.03-.362l-3.382-11.687a2.938,2.938,0,0,0-4.03.364A2.726,2.726,0,0,0,423.14,191.423Z",
    transform: "translate(-423.035 -187.857)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2126",
    "data-name": "Path 2126",
    d: "M427.945,189.261l3.384,11.684a6.02,6.02,0,0,0,1.989,3l-3.382-11.684A6.035,6.035,0,0,1,427.945,189.261Z",
    transform: "translate(-427.945 -189.261)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2130",
    "data-name": "Path 2130",
    d: "M428.182,189.363l3.384,11.687a6.826,6.826,0,0,0,2.251,3.4l-3.382-11.684A6.846,6.846,0,0,1,428.182,189.363Z",
    transform: "translate(-428.182 -189.363)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2134",
    "data-name": "Path 2134",
    d: "M424.618,189.365,428,201.049a2.662,2.662,0,0,0,.88,1.327L425.5,190.689A2.659,2.659,0,0,1,424.618,189.365Z",
    transform: "translate(-424.618 -189.365)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2142",
    "data-name": "Path 2142",
    d: "M419.847,204.881a2.649,2.649,0,0,1,.877,1.324l-3.382-11.687a2.668,2.668,0,0,0-.877-1.322Z",
    transform: "translate(-416.465 -193.197)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2145",
    "data-name": "Path 2145",
    d: "M424.423,205.443l-3.382-11.687a2.732,2.732,0,0,1-.594,2.571,2.933,2.933,0,0,1-4.027.362l3.382,11.684a2.934,2.934,0,0,0,4.03-.362A2.727,2.727,0,0,0,424.423,205.443Z",
    transform: "translate(-416.42 -193.756)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2148",
    "data-name": "Path 2148",
    d: "M461.124,218.921q-1.692-5.842-3.382-11.684a5.589,5.589,0,0,0-7.669.686,5.2,5.2,0,0,0-1.13,4.888l3.384,11.687a5.2,5.2,0,0,1,1.13-4.89A5.588,5.588,0,0,1,461.124,218.921Z",
    transform: "translate(-448.743 -206.023)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2156",
    "data-name": "Path 2156",
    d: "M451.756,208.893l3.382,11.684a5.082,5.082,0,0,0,1.674,2.523l-3.382-11.687A5.058,5.058,0,0,1,451.756,208.893Z",
    transform: "translate(-451.756 -208.893)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2161",
    "data-name": "Path 2161",
    d: "M457,212.749h0v0h0l2.135,7.371q-.415-1.433-.83-2.868-.337-1.164-.676-2.332l-.258-.894-.248-.858A2.481,2.481,0,0,0,457,212.749Z",
    transform: "translate(-456.994 -212.747)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2163",
    "data-name": "Path 2163",
    d: "M458.844,225.006a2.935,2.935,0,0,1,4.027-.362l-3.382-11.684a2.939,2.939,0,0,0-4.03.362,2.729,2.729,0,0,0-.591,2.568l3.382,11.684a2.726,2.726,0,0,1,.594-2.566l-.147-.5-.149-.516-.151-.525-.156-.539-.158-.546-.161-.556-.163-.563-.163-.568-.277-.955c-.083-.286-.194-.669-.277-.958l-.277-.955c-.083-.284-.194-.662-.274-.946s-.189-.65-.27-.929-.185-.636-.263-.908-.177-.615-.255-.877l-.244-.842h0v0l.244.842.253.877.263.906.27.932q1.174,4.062,2.353,8.125Z",
    transform: "translate(-454.763 -212.324)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2168",
    "data-name": "Path 2168",
    d: "M456.346,213.832l3.384,11.684a2.645,2.645,0,0,0,.877,1.324l-3.382-11.684A2.67,2.67,0,0,1,456.346,213.832Z",
    transform: "translate(-456.346 -213.832)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2172",
    "data-name": "Path 2172",
    d: "M391.31,206.28a4.463,4.463,0,0,1,1.473,2.221L389.4,196.817a4.458,4.458,0,0,0-1.473-2.221Q389.62,200.438,391.31,206.28Z",
    transform: "translate(-387.928 -194.596)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2175",
    "data-name": "Path 2175",
    d: "M398.977,207.219,395.6,195.535a4.57,4.57,0,0,1-.991,4.294,4.919,4.919,0,0,1-6.751.608l3.382,11.687a4.922,4.922,0,0,0,6.751-.608A4.567,4.567,0,0,0,398.977,207.219Z",
    transform: "translate(-387.853 -195.535)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2182",
    "data-name": "Path 2182",
    d: "M406.341,217.733l-3.384-11.684a6.841,6.841,0,0,0-2.251-3.4l3.382,11.687A6.83,6.83,0,0,1,406.341,217.733Z",
    transform: "translate(-400.706 -202.65)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2186",
    "data-name": "Path 2186",
    d: "M406.429,217.605l-3.384-11.684a6.03,6.03,0,0,0-1.991-3l3.384,11.687A6.044,6.044,0,0,1,406.429,217.605Z",
    transform: "translate(-401.054 -202.92)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2189",
    "data-name": "Path 2189",
    d: "M405.681,215.876,402.3,204.189a6.193,6.193,0,0,1-1.343,5.825l3.382,11.687A6.2,6.2,0,0,0,405.681,215.876Z",
    transform: "translate(-400.953 -204.189)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2192",
    "data-name": "Path 2192",
    d: "M405.5,215.771l-3.384-11.684a7.009,7.009,0,0,1-1.521,6.6l3.384,11.684A7.014,7.014,0,0,0,405.5,215.771Z",
    transform: "translate(-400.592 -204.087)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2194",
    "data-name": "Path 2194",
    d: "M398.807,217.2a2.946,2.946,0,0,1,4.03-.364l-2.987-10.32-.395-1.365a2.943,2.943,0,0,0-4.03.362q1.692,5.842,3.382,11.684-1.692-5.842-3.382-11.684a2.731,2.731,0,0,0-.594,2.568l3.384,11.687A2.727,2.727,0,0,1,398.807,217.2Z",
    transform: "translate(-394.727 -204.518)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2198",
    "data-name": "Path 2198",
    d: "M407.853,219.792a6.49,6.49,0,0,0,4.7,1.412c-.118-.409-.274-.955-.395-1.364-.125-.433-.293-1.012-.419-1.447s-.3-1.05-.435-1.5-.31-1.069-.442-1.528-.31-1.071-.442-1.53-.305-1.052-.435-1.5-.293-1.012-.419-1.447l-.395-1.364a6.477,6.477,0,0,1-4.7-1.414C405.486,211.612,406.838,216.285,407.853,219.792Z",
    transform: "translate(-404.471 -208.105)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2200",
    "data-name": "Path 2200",
    d: "M405.977,221.679a6.7,6.7,0,0,0,4.436-2.235l-3.382-11.687a6.7,6.7,0,0,1-4.436,2.237Q404.287,215.836,405.977,221.679Z",
    transform: "translate(-402.595 -207.757)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2204",
    "data-name": "Path 2204",
    d: "M396.31,206.025l3.384,11.684a2.645,2.645,0,0,0,.877,1.324l-3.382-11.684A2.671,2.671,0,0,1,396.31,206.025Z",
    transform: "translate(-396.31 -206.025)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2208",
    "data-name": "Path 2208",
    d: "M402.322,208.913,405.7,220.6a7.546,7.546,0,0,0,10.344-.932l-3.382-11.684A7.546,7.546,0,0,1,402.322,208.913Z",
    transform: "translate(-402.322 -207.981)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    d: "M470.546,237.36l3.384,11.685a5.2,5.2,0,0,1,1.13-4.888,5.588,5.588,0,0,1,7.667-.686l-3.382-11.684a5.586,5.586,0,0,0-7.667.686A5.192,5.192,0,0,0,470.546,237.36Z",
    transform: "translate(-470.346 -230.573)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2214",
    "data-name": "Path 2214",
    d: "M473.359,233.443l3.384,11.685a5.07,5.07,0,0,0,1.672,2.523l-3.382-11.687A5.059,5.059,0,0,1,473.359,233.443Z",
    transform: "translate(-473.359 -233.443)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    "data-name": "Path 2216",
    d: "M447.3,230.276l3.382,11.684a2.721,2.721,0,0,1,.6-2.566,2.928,2.928,0,0,1,4.023-.357l-3.382-11.684a2.931,2.931,0,0,0-4.025.357A2.724,2.724,0,0,0,447.3,230.276Z",
    transform: "translate(-447.192 -226.715)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    "data-name": "Path 2220",
    d: "M448.773,228.221l3.382,11.684a2.67,2.67,0,0,0,.88,1.327l-3.382-11.687A2.654,2.654,0,0,1,448.773,228.221Z",
    transform: "translate(-448.773 -228.221)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2222",
    "data-name": "Path 2222",
    d: "M476.471,240.44l3.382,11.684a2.726,2.726,0,0,1,.594-2.566,2.936,2.936,0,0,1,4.027-.364l-3.382-11.684a2.939,2.939,0,0,0-4.03.362A2.729,2.729,0,0,0,476.471,240.44Z",
    transform: "translate(-476.366 -236.874)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2226",
    "data-name": "Path 2226",
    d: "M477.949,238.382l3.384,11.687a2.651,2.651,0,0,0,.877,1.322l-3.382-11.684A2.67,2.67,0,0,1,477.949,238.382Z",
    transform: "translate(-477.949 -238.382)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2231",
    "data-name": "Path 2231",
    d: "M429.2,236.389a5.075,5.075,0,0,1,1.674,2.523L427.5,227.228a5.066,5.066,0,0,0-1.674-2.523q1.493,5.158,2.987,10.32A5.338,5.338,0,0,0,429.2,236.389Z",
    transform: "translate(-425.823 -224.705)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2237",
    "data-name": "Path 2237",
    d: "M386.066,226.019a2.638,2.638,0,0,1,.873,1.317l-3.382-11.684a2.653,2.653,0,0,0-.873-1.317Z",
    transform: "translate(-382.684 -214.335)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2240",
    "data-name": "Path 2240",
    d: "M437.92,237.456l-3.382-11.684a5.193,5.193,0,0,1-1.128,4.881,5.591,5.591,0,0,1-7.671.693l3.382,11.684a5.59,5.59,0,0,0,7.672-.691A5.192,5.192,0,0,0,437.92,237.456Z",
    transform: "translate(-425.738 -225.772)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    "data-name": "Path 2243",
    d: "M390.637,226.579l-3.382-11.687a2.733,2.733,0,0,1-.594,2.571,2.93,2.93,0,0,1-4.023.367l3.382,11.687a2.93,2.93,0,0,0,4.022-.369A2.723,2.723,0,0,0,390.637,226.579Z",
    transform: "translate(-382.639 -214.892)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2248",
    "data-name": "Path 2248",
    d: "M434.335,243.451a2.655,2.655,0,0,1,.88,1.324l-3.382-11.685a2.67,2.67,0,0,0-.88-1.327l2.987,10.322A5.342,5.342,0,0,0,434.335,243.451Z",
    transform: "translate(-430.953 -231.764)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    "data-name": "Path 2250",
    d: "M403.955,235.626a5.273,5.273,0,0,1,.889-.388l-.395-1.364c-.125-.435-.293-1.012-.419-1.447l-.435-1.5-.442-1.53c-.132-.459-.31-1.069-.442-1.528s-.3-1.052-.435-1.5-.293-1.015-.419-1.447l-.395-1.365a5.1,5.1,0,0,0-.889.385Q402.265,229.785,403.955,235.626Z",
    transform: "translate(-400.573 -223.554)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2254",
    "data-name": "Path 2254",
    d: "M402.774,235.386a5.124,5.124,0,0,1,2.793-.114l-.395-1.364c-.125-.435-.293-1.015-.419-1.447-.13-.452-.305-1.052-.435-1.5l-.442-1.53-.442-1.53c-.13-.449-.305-1.05-.435-1.5l-.419-1.445-.395-1.365a5.1,5.1,0,0,0-2.793.114Q401.08,229.544,402.774,235.386Z",
    transform: "translate(-399.392 -223.446)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2256",
    "data-name": "Path 2256",
    d: "M401.956,231.585l-.161-.551-.158-.549-.159-.544-.156-.539-.151-.527-.149-.513-.144-.5-.139-.482-.128-.435-.135-.463-.137-.48-.142-.49-.142-.489-.14-.48-.135-.464-.125-.437c-.151-.052-.3-.1-.456-.135q1.692,5.846,3.382,11.687c.154.038.307.083.456.135l-.123-.43-.13-.445-.132-.456-.135-.468-.137-.478-.142-.485-.14-.487Z",
    transform: "translate(-399.199 -223.505)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2258",
    "data-name": "Path 2258",
    d: "M402.385,235.249a4.888,4.888,0,0,1,.464.187c-.121-.409-.277-.955-.4-1.364l-.419-1.447-.435-1.5-.442-1.53c-.132-.459-.31-1.069-.442-1.528s-.3-1.052-.435-1.5l-.419-1.447-.4-1.365a4.855,4.855,0,0,0-.461-.189Q400.695,229.408,402.385,235.249Z",
    transform: "translate(-399.003 -223.562)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2260",
    "data-name": "Path 2260",
    d: "M406.177,235.4l-.085-.3-.092-.317-.1-.331-.1-.336-.1-.336-.095-.329-.092-.319-.088-.3-.307-1.066c-.1-.338-.229-.79-.326-1.128s-.239-.821-.34-1.173-.241-.835-.345-1.194l-.345-1.192-.338-1.173c-.1-.338-.229-.79-.329-1.128l-.307-1.064a5.023,5.023,0,0,0-1.343,1.078,4.77,4.77,0,0,0-.5.686q1.688,5.842,3.382,11.684a5.1,5.1,0,0,1,.506-.683A5.023,5.023,0,0,1,406.177,235.4Z",
    transform: "translate(-400.949 -223.718)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2264",
    "data-name": "Path 2264",
    d: "M402.851,235.96c.1.078.187.158.274.241l-.395-1.365c-.125-.435-.293-1.015-.419-1.447-.132-.452-.305-1.052-.435-1.5s-.31-1.071-.445-1.53l-.442-1.53c-.13-.449-.3-1.05-.435-1.5l-.419-1.445-.395-1.365a3.291,3.291,0,0,0-.272-.241q1.692,5.842,3.382,11.682-1.692-5.842-3.382-11.684a4.849,4.849,0,0,0-1.007-.631l3.384,11.684A4.784,4.784,0,0,1,402.851,235.96Z",
    transform: "translate(-398.462 -223.642)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2266",
    "data-name": "Path 2266",
    d: "M404.386,226.23l3.384,11.684a.424.424,0,0,1,.378-.461l-3.382-11.687A.426.426,0,0,0,404.386,226.23Z",
    transform: "translate(-404.383 -225.767)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2268",
    "data-name": "Path 2268",
    d: "M407.935,237.716a.316.316,0,0,1-.014-.069l-3.384-11.684c0,.024.009.045.014.069C405.566,229.536,406.921,234.211,407.935,237.716Z",
    transform: "translate(-404.537 -225.963)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2270",
    "data-name": "Path 2270",
    d: "M438.913,244.009l-3.382-11.685a2.727,2.727,0,0,1-.6,2.566,2.933,2.933,0,0,1-4.027.364l3.382,11.684a2.936,2.936,0,0,0,4.03-.362A2.73,2.73,0,0,0,438.913,244.009Z",
    transform: "translate(-430.909 -232.325)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2275",
    "data-name": "Path 2275",
    d: "M404.345,225.992l3.384,11.684a.4.4,0,0,0,.13.2.419.419,0,0,0,.324.09L404.8,226.281a.416.416,0,0,1-.324-.09A.412.412,0,0,1,404.345,225.992Z",
    transform: "translate(-404.345 -225.992)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2278",
    "data-name": "Path 2278",
    d: "M405.112,238.556a4.731,4.731,0,0,1,.7-2.407c-.118-.409-.277-.955-.395-1.364l-.419-1.447-.435-1.5c-.132-.459-.31-1.069-.442-1.528l-.442-1.53c-.132-.452-.305-1.052-.435-1.5l-.419-1.447-.395-1.364a4.673,4.673,0,0,0-.7,2.407Z",
    transform: "translate(-401.73 -224.464)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2281",
    "data-name": "Path 2281",
    d: "M401.532,235.7a4.683,4.683,0,0,1,.743.915l-.395-1.365c-.125-.435-.293-1.015-.419-1.447-.132-.452-.305-1.052-.435-1.5l-.442-1.53c-.135-.459-.31-1.071-.445-1.53s-.3-1.05-.433-1.5c-.128-.433-.293-1.012-.421-1.445l-.4-1.364a4.451,4.451,0,0,0-.742-.915Z",
    transform: "translate(-398.148 -224.012)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2284",
    "data-name": "Path 2284",
    d: "M405.043,237.136a.437.437,0,0,1,.208.024l-3.384-11.684a.38.38,0,0,0-.208-.024C402.673,228.957,404.028,233.632,405.043,237.136Z",
    transform: "translate(-401.659 -225.447)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2286",
    "data-name": "Path 2286",
    d: "M401.568,236.19l-.085-.3-.092-.317-.095-.326-.095-.333-.1-.333-.095-.326-.092-.314-.085-.3-.31-1.069-.326-1.13c-.1-.352-.239-.823-.341-1.175l-.348-1.2-.345-1.194-.341-1.175c-.1-.341-.229-.792-.326-1.133-.092-.319-.218-.747-.31-1.066l-.064-.1,3.384,11.684Z",
    transform: "translate(-398.122 -224.399)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2290",
    "data-name": "Path 2290",
    d: "M408.4,236.386a3.783,3.783,0,0,1,1.251,1.885l-3.382-11.684a3.816,3.816,0,0,0-1.251-1.887,4.186,4.186,0,0,0-5.737.523,3.924,3.924,0,0,0-.991,2.5l3.384,11.687a3.913,3.913,0,0,1,.991-2.5A4.183,4.183,0,0,1,408.4,236.386Z",
    transform: "translate(-398.286 -223.798)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2294",
    "data-name": "Path 2294",
    d: "M405.186,237.412,401.8,225.725a.4.4,0,0,0-.132-.2.466.466,0,0,0-.116-.066l3.384,11.687a.38.38,0,0,1,.116.066A.4.4,0,0,1,405.186,237.412Z",
    transform: "translate(-401.554 -225.458)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2296",
    "data-name": "Path 2296",
    d: "M404.933,237.258l-3.384-11.687a.325.325,0,0,1,.014.069l3.382,11.684A.554.554,0,0,0,404.933,237.258Z",
    transform: "translate(-401.549 -225.571)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2300",
    "data-name": "Path 2300",
    d: "M401.548,226.061l3.384,11.687a.441.441,0,0,0,.173-.059.431.431,0,0,0,.206-.4L401.929,225.6a.432.432,0,0,1-.381.461Z",
    transform: "translate(-401.548 -225.6)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2302",
    "data-name": "Path 2302",
    d: "M405.074,237.871a3.6,3.6,0,0,1-.094-.414L401.6,225.77a4.061,4.061,0,0,0,.095.414C402.705,229.691,404.06,234.364,405.074,237.871Z",
    transform: "translate(-401.596 -225.77)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2306",
    "data-name": "Path 2306",
    d: "M408.59,240.322a3.889,3.889,0,0,0,.844-3.661l-3.382-11.684a3.891,3.891,0,0,1-.844,3.658q1.688,5.846,3.382,11.687-1.692-5.846-3.384-11.687a4.183,4.183,0,0,1-5.735.513q1.688,5.842,3.382,11.684-1.692-5.842-3.382-11.684a3.789,3.789,0,0,1-1.249-1.882l3.384,11.687a3.778,3.778,0,0,0,1.246,1.88A4.184,4.184,0,0,0,408.59,240.322Z",
    transform: "translate(-398.222 -224.977)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    d: "M397.86,227.638l3.384,11.687a4.605,4.605,0,0,0,1.516,2.284,5.061,5.061,0,0,0,6.943-.622,4.7,4.7,0,0,0,1.024-4.427l-3.382-11.684a4.705,4.705,0,0,1-1.024,4.427,5.064,5.064,0,0,1-6.945.62A4.6,4.6,0,0,1,397.86,227.638Z",
    transform: "translate(-397.86 -224.876)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2313",
    "data-name": "Path 2313",
    d: "M401.319,236.13a4.467,4.467,0,0,1,.437,1.022l-3.382-11.687a4.617,4.617,0,0,0-.437-1.022l2.646,9.14.369,1.272.189.66.092.317.045.151C401.29,236.026,401.3,236.087,401.319,236.13Z",
    transform: "translate(-397.937 -224.443)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2315",
    "data-name": "Path 2315",
    d: "M405.447,238.023a4.125,4.125,0,0,1-.116-.508l-3.384-11.684c.031.17.069.341.116.506C403.08,229.841,404.432,234.516,405.447,238.023Z",
    transform: "translate(-401.947 -225.83)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2319",
    "data-name": "Path 2319",
    d: "M398,234.29a8,8,0,0,1,2.634,3.973l-3.384-11.687a7.99,7.99,0,0,0-2.634-3.973C395.633,226.11,396.987,230.783,398,234.29Z",
    transform: "translate(-394.618 -222.603)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2323",
    "data-name": "Path 2323",
    d: "M400.722,238.135l-3.384-11.684a7.2,7.2,0,0,0-2.372-3.578l3.382,11.684A7.2,7.2,0,0,1,400.722,238.135Z",
    transform: "translate(-394.966 -222.873)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2325",
    "data-name": "Path 2325",
    d: "M399.826,236.07l-3.384-11.684a7.366,7.366,0,0,1-1.6,6.934l3.382,11.687A7.372,7.372,0,0,0,399.826,236.07Z",
    transform: "translate(-394.846 -224.386)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2332",
    "data-name": "Path 2332",
    d: "M438.529,248.216a2.691,2.691,0,0,1,.882,1.327l-3.384-11.684a2.66,2.66,0,0,0-.88-1.327l2.987,10.32A5.348,5.348,0,0,0,438.529,248.216Z",
    transform: "translate(-435.147 -236.532)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2335",
    "data-name": "Path 2335",
    d: "M399.642,235.97l-3.384-11.687a8.185,8.185,0,0,1-1.774,7.707l3.384,11.687A8.2,8.2,0,0,0,399.642,235.97Z",
    transform: "translate(-394.484 -224.283)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2339",
    "data-name": "Path 2339",
    d: "M406.752,244.054a7.994,7.994,0,0,0,5.366-2.679l-3.384-11.684a7.971,7.971,0,0,1-5.363,2.677q1.692,5.842,3.382,11.684-1.692-5.842-3.382-11.684a7.807,7.807,0,0,1-5.642-1.793l3.384,11.687A7.815,7.815,0,0,0,406.752,244.054Z",
    transform: "translate(-397.728 -229.69)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2344",
    "data-name": "Path 2344",
    d: "M443.106,248.777l-3.384-11.684a2.716,2.716,0,0,1-.591,2.559,2.931,2.931,0,0,1-4.027.364l3.382,11.684a2.933,2.933,0,0,0,4.03-.362A2.732,2.732,0,0,0,443.106,248.777Z",
    transform: "translate(-435.103 -237.093)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2347",
    "data-name": "Path 2347",
    d: "M418.239,244.089a20.58,20.58,0,0,1,14.926,4.5L429.784,236.9a20.583,20.583,0,0,0-14.929-4.5Z",
    transform: "translate(-414.855 -232.318)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2349",
    "data-name": "Path 2349",
    d: "M496.5,268.527a5.593,5.593,0,0,1,7.669-.686q-1.5-5.161-2.989-10.32l-.395-1.364a5.586,5.586,0,0,0-7.667.686,5.2,5.2,0,0,0-1.13,4.888l3.382,11.687A5.2,5.2,0,0,1,496.5,268.527Z",
    transform: "translate(-491.791 -254.944)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2354",
    "data-name": "Path 2354",
    d: "M494.8,257.814l3.382,11.684a5.075,5.075,0,0,0,1.674,2.523l-3.382-11.687A5.059,5.059,0,0,1,494.8,257.814Z",
    transform: "translate(-494.804 -257.814)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    "data-name": "Path 2356",
    d: "M397.455,230.9l3.382,11.687a8.628,8.628,0,0,0,6.264,1.986,8.868,8.868,0,0,0,5.959-2.973l-3.382-11.684a8.862,8.862,0,0,1-5.962,2.97A8.622,8.622,0,0,1,397.455,230.9Z",
    transform: "translate(-397.455 -229.914)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2358",
    "data-name": "Path 2358",
    d: "M468.9,254.827l3.382,11.684a2.722,2.722,0,0,1,.6-2.566,2.928,2.928,0,0,1,4.022-.357L473.518,251.9a2.934,2.934,0,0,0-4.025.359A2.725,2.725,0,0,0,468.9,254.827Z",
    transform: "translate(-468.795 -251.265)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-85"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2362",
    "data-name": "Path 2362",
    d: "M470.376,252.771l3.384,11.684a2.67,2.67,0,0,0,.88,1.327L471.258,254.1A2.674,2.674,0,0,1,470.376,252.771Z",
    transform: "translate(-470.376 -252.771)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2364",
    "data-name": "Path 2364",
    d: "M505.919,273.566q-1.692-5.842-3.382-11.684a2.938,2.938,0,0,0-4.03.362,2.737,2.737,0,0,0-.591,2.571L501.3,276.5a2.725,2.725,0,0,1,.589-2.568A2.939,2.939,0,0,1,505.919,273.566Zm-7.411-11.32h0l.12.416.123.426.125.435.13.445.13.449.132.456.133.464.135.468.137.471.137.475.14.475.137.48.14.478.137.48.139.478.137.475.083.284.083.284.08.281.08.281.083.279.078.277.08.274.078.272.08.272.076.267.078.265.076.26.073.26.076.255.073.251.071.248-.071-.248-.073-.251-.076-.255-.073-.26-.076-.26-.078-.265-.076-.267-.08-.272-.078-.272-.08-.274-.078-.277-.083-.279-.08-.281-.08-.281-.083-.284-.083-.284-.137-.475-.139-.48-.137-.478-.14-.48-.139-.478-.137-.478-.137-.475-.137-.471-.135-.466-.135-.464-.132-.456-.13-.452-.128-.442-.125-.435-.123-.426-.12-.416",
    transform: "translate(-497.811 -261.245)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2368",
    "data-name": "Path 2368",
    d: "M499.394,262.754l3.382,11.684a2.664,2.664,0,0,0,.877,1.322l-3.384-11.684A2.645,2.645,0,0,1,499.394,262.754Z",
    transform: "translate(-499.394 -262.754)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2372",
    "data-name": "Path 2372",
    d: "M415.562,245.94a19.155,19.155,0,0,1,6.326,9.53l-3.382-11.687a19.155,19.155,0,0,0-6.326-9.528Z",
    transform: "translate(-412.18 -234.256)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2374",
    "data-name": "Path 2374",
    d: "M429.581,251.148a21.259,21.259,0,0,1,14.075-7.109l-.395-1.365-.421-1.447c-.13-.449-.3-1.05-.433-1.5s-.31-1.069-.445-1.528l-.442-1.53-.435-1.5c-.125-.435-.293-1.012-.419-1.447l-.395-1.365a21.272,21.272,0,0,0-14.075,7.106,19.634,19.634,0,0,0-4.273,18.476l3.384,11.684A19.63,19.63,0,0,1,429.581,251.148Z",
    transform: "translate(-421.167 -232.355)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2379",
    "data-name": "Path 2379",
    d: "M450.808,260.939a5.086,5.086,0,0,1,1.674,2.523L449.1,251.778a5.066,5.066,0,0,0-1.674-2.523C448.44,252.76,448.8,257.9,450.808,260.939Z",
    transform: "translate(-447.426 -249.255)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-91"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2384",
    "data-name": "Path 2384",
    d: "M459.522,262.006l-3.382-11.684a5.185,5.185,0,0,1-1.128,4.881,5.588,5.588,0,0,1-7.671.69l3.382,11.687a5.591,5.591,0,0,0,7.674-.69A5.19,5.19,0,0,0,459.522,262.006Z",
    transform: "translate(-447.341 -250.322)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2390",
    "data-name": "Path 2390",
    d: "M455.937,268a2.671,2.671,0,0,1,.882,1.327l-3.384-11.687a2.654,2.654,0,0,0-.88-1.324q.734,2.536,1.469,5.075.55,1.9,1.1,3.8l.62,2.14A2.731,2.731,0,0,0,455.937,268Z",
    transform: "translate(-452.555 -256.315)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2393",
    "data-name": "Path 2393",
    d: "M524.282,280.32,527.666,292a5.982,5.982,0,0,1,8.211-.733l-3.382-11.687A5.987,5.987,0,0,0,524.282,280.32Z",
    transform: "translate(-524.282 -278.287)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2395",
    "data-name": "Path 2395",
    d: "M460.516,268.562l-3.382-11.687a2.725,2.725,0,0,1-.6,2.566,2.931,2.931,0,0,1-4.027.364l3.382,11.684a2.934,2.934,0,0,0,4.03-.362A2.727,2.727,0,0,0,460.516,268.562Z",
    transform: "translate(-452.512 -256.875)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-95"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2402",
    "data-name": "Path 2402",
    d: "M411.86,249.84l3.382,11.684a19.183,19.183,0,0,0,6.333,9.54,21.119,21.119,0,0,0,28.992-2.611,19.645,19.645,0,0,0,4.278-18.483l-3.382-11.684a19.645,19.645,0,0,1-4.278,18.481,21.122,21.122,0,0,1-28.995,2.611A19.172,19.172,0,0,1,411.86,249.84Z",
    transform: "translate(-411.86 -238.286)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2406",
    "data-name": "Path 2406",
    d: "M460.132,272.766a2.676,2.676,0,0,1,.882,1.327l-3.384-11.685a2.661,2.661,0,0,0-.88-1.327q1.493,5.161,2.987,10.32A5.351,5.351,0,0,0,460.132,272.766Z",
    transform: "translate(-456.75 -261.082)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2410",
    "data-name": "Path 2410",
    d: "M530.438,287.187l3.384,11.687a5.565,5.565,0,0,1,1.211-5.236l-3.382-11.684A5.556,5.556,0,0,0,530.438,287.187Z",
    transform: "translate(-530.224 -281.954)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2412",
    "data-name": "Path 2412",
    d: "M464.708,273.327l-3.384-11.684a2.716,2.716,0,0,1-.591,2.559,2.931,2.931,0,0,1-4.027.364l3.382,11.684a2.934,2.934,0,0,0,4.03-.362A2.726,2.726,0,0,0,464.708,273.327Z",
    transform: "translate(-456.706 -261.643)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-99"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2415",
    "data-name": "Path 2415",
    d: "M441.415,269.665l-.026-.09-.026-.095-.028-.1-.031-.1-.028-.1-.028-.1-.026-.095-.026-.09c-.111-.383-.26-.891-.371-1.275-.116-.407-.272-.948-.39-1.353-.123-.421-.284-.984-.407-1.4l-.414-1.428c-.123-.428-.288-1-.414-1.428l-.4-1.4-.392-1.35c-.111-.383-.258-.894-.369-1.277-.078-.043-.156-.083-.234-.123l1.249,4.313c.133.459.31,1.069.442,1.528l.222.766c.835,2.909.835,2.909,1.471,5.08C441.261,269.582,441.339,269.622,441.415,269.665Z",
    transform: "translate(-437.799 -257.855)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2419",
    "data-name": "Path 2419",
    d: "M524.061,292.851a5.428,5.428,0,0,1,1.793,2.7l-3.382-11.684a5.453,5.453,0,0,0-1.795-2.7C521.692,284.671,523.047,289.344,524.061,292.851Z",
    transform: "translate(-520.677 -281.164)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2423",
    "data-name": "Path 2423",
    d: "M529.978,284.167l3.384,11.687a5.429,5.429,0,0,0,1.792,2.7l-3.382-11.685A5.429,5.429,0,0,1,529.978,284.167Z",
    transform: "translate(-529.978 -284.167)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2425",
    "data-name": "Path 2425",
    d: "M439.841,269.594a19.774,19.774,0,0,1,3.169,2.124l-.395-1.364c-.125-.435-.293-1.014-.419-1.447-.13-.452-.3-1.052-.435-1.5s-.31-1.071-.442-1.53l-.442-1.53c-.13-.449-.305-1.05-.435-1.5l-.418-1.447-.395-1.364a20.208,20.208,0,0,0-3.169-2.124Q438.151,263.753,439.841,269.594Z",
    transform: "translate(-436.459 -257.907)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2427",
    "data-name": "Path 2427",
    d: "M525.176,293.994l-3.382-11.687a5.555,5.555,0,0,1-1.208,5.229l3.382,11.687A5.556,5.556,0,0,0,525.176,293.994Z",
    transform: "translate(-520.586 -282.307)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2429",
    "data-name": "Path 2429",
    d: "M498.35,287.956q-1.692-5.842-3.382-11.687a2.94,2.94,0,0,0-4.03.364,2.726,2.726,0,0,0-.6,2.566l3.384,11.687a2.73,2.73,0,0,1,.594-2.568A2.938,2.938,0,0,1,498.35,287.956Z",
    transform: "translate(-490.238 -275.635)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2434",
    "data-name": "Path 2434",
    d: "M491.821,277.142l3.384,11.684a2.661,2.661,0,0,0,.88,1.327L492.7,278.466A2.656,2.656,0,0,1,491.821,277.142Z",
    transform: "translate(-491.821 -277.142)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2437",
    "data-name": "Path 2437",
    d: "M523.657,288.065l3.382,11.684a5.985,5.985,0,0,0,8.218-.74l-3.384-11.684A5.982,5.982,0,0,1,523.657,288.065Z",
    transform: "translate(-523.657 -287.325)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2442",
    "data-name": "Path 2442",
    d: "M437.167,270.492a19.154,19.154,0,0,1,6.326,9.53l-3.382-11.687a19.153,19.153,0,0,0-6.326-9.528l0,0q1.692,5.842,3.382,11.687Z",
    transform: "translate(-433.783 -258.805)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2444",
    "data-name": "Path 2444",
    d: "M446.311,275.748a21.256,21.256,0,0,1,25.6-4.86q-.624-2.16-1.251-4.316-1.068-3.685-2.133-7.371a21.262,21.262,0,0,0-25.6,4.86,19.634,19.634,0,0,0-4.273,18.476l3.384,11.684A19.63,19.63,0,0,1,446.311,275.748Z",
    transform: "translate(-437.897 -256.869)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-109"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2449",
    "data-name": "Path 2449",
    d: "M472.255,285.31a5.086,5.086,0,0,1,1.674,2.523l-3.384-11.685a5.076,5.076,0,0,0-1.674-2.523C469.886,277.131,470.245,282.267,472.255,285.31Z",
    transform: "translate(-468.871 -273.626)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2452",
    "data-name": "Path 2452",
    d: "M511.971,290.391l3.382,11.684a5.987,5.987,0,0,1,8.213-.735l-3.382-11.684A5.987,5.987,0,0,0,511.971,290.391Z",
    transform: "translate(-511.971 -288.357)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2458",
    "data-name": "Path 2458",
    d: "M480.968,286.378l-3.384-11.685a5.186,5.186,0,0,1-1.126,4.881,5.588,5.588,0,0,1-7.671.691l3.382,11.687a5.591,5.591,0,0,0,7.671-.69A5.2,5.2,0,0,0,480.968,286.378Z",
    transform: "translate(-468.787 -274.693)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2465",
    "data-name": "Path 2465",
    d: "M477.385,292.37a2.661,2.661,0,0,1,.88,1.327l-3.382-11.687a2.674,2.674,0,0,0-.882-1.324l.816,2.809q.326,1.132.655,2.265l1.1,3.8L476.99,291A5.328,5.328,0,0,0,477.385,292.37Z",
    transform: "translate(-474.001 -280.686)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2467",
    "data-name": "Path 2467",
    d: "M518.127,297.257l3.382,11.687a5.56,5.56,0,0,1,1.213-5.236l-3.384-11.684A5.561,5.561,0,0,0,518.127,297.257Z",
    transform: "translate(-517.913 -292.024)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2472",
    "data-name": "Path 2472",
    d: "M513.542,305.624l-3.384-11.687a5.434,5.434,0,0,0-1.792-2.7l3.382,11.687A5.428,5.428,0,0,1,513.542,305.624Z",
    transform: "translate(-508.366 -291.234)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-115"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2474",
    "data-name": "Path 2474",
    d: "M481.964,292.933l-3.384-11.687a2.726,2.726,0,0,1-.594,2.566,2.941,2.941,0,0,1-4.03.364l3.384,11.684a2.935,2.935,0,0,0,4.027-.362A2.728,2.728,0,0,0,481.964,292.933Z",
    transform: "translate(-473.957 -281.246)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2479",
    "data-name": "Path 2479",
    d: "M517.667,294.237l3.382,11.687a5.431,5.431,0,0,0,1.795,2.7L519.46,296.94A5.422,5.422,0,0,1,517.667,294.237Z",
    transform: "translate(-517.667 -294.237)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2482",
    "data-name": "Path 2482",
    d: "M512.865,304.064l-3.384-11.687a5.559,5.559,0,0,1-1.206,5.229l3.382,11.687A5.556,5.556,0,0,0,512.865,304.064Z",
    transform: "translate(-508.275 -292.377)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2486",
    "data-name": "Path 2486",
    d: "M433.463,274.39l3.382,11.684a19.183,19.183,0,0,0,6.333,9.54A21.119,21.119,0,0,0,472.17,293a19.644,19.644,0,0,0,4.278-18.483l-3.382-11.684a19.644,19.644,0,0,1-4.278,18.481,21.122,21.122,0,0,1-28.995,2.611A19.172,19.172,0,0,1,433.463,274.39Z",
    transform: "translate(-433.463 -262.836)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2491",
    "data-name": "Path 2491",
    d: "M481.579,297.135a2.666,2.666,0,0,1,.877,1.324l-3.382-11.687a2.653,2.653,0,0,0-.88-1.322l.6,2.079c.128.442.3,1.033.428,1.478s.307,1.062.44,1.518l1.1,3.8.419,1.45A5.346,5.346,0,0,0,481.579,297.135Z",
    transform: "translate(-478.195 -285.451)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2495",
    "data-name": "Path 2495",
    d: "M486.155,297.7l-3.382-11.687a2.733,2.733,0,0,1-.594,2.568,2.934,2.934,0,0,1-4.03.364l3.384,11.685a2.93,2.93,0,0,0,4.027-.362A2.729,2.729,0,0,0,486.155,297.7Z",
    transform: "translate(-478.151 -286.01)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2500",
    "data-name": "Path 2500",
    d: "M511.347,298.135l3.384,11.684a5.982,5.982,0,0,0,8.215-.74l-3.382-11.684A5.99,5.99,0,0,1,511.347,298.135Z",
    transform: "translate(-511.347 -297.395)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2502",
    "data-name": "Path 2502",
    d: "M499.934,300.236l3.384,11.687a5.98,5.98,0,0,1,8.211-.735L508.147,299.5A5.987,5.987,0,0,0,499.934,300.236Z",
    transform: "translate(-499.934 -298.203)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2507",
    "data-name": "Path 2507",
    d: "M469.64,297.456a19.164,19.164,0,0,1,6.328,9.53L472.587,295.3a19.181,19.181,0,0,0-6.328-9.533,20.353,20.353,0,0,0-11.032-4.491q1.688,5.842,3.382,11.684A20.343,20.343,0,0,1,469.64,297.456Z",
    transform: "translate(-455.227 -281.278)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2509",
    "data-name": "Path 2509",
    d: "M488.949,293.016l0-.016,0-.019,0-.017-.007-.019,0-.019,0-.019,0-.017,0-.017-.39-1.348-.414-1.431c-.13-.445-.3-1.038-.43-1.483s-.305-1.057-.437-1.511-.305-1.057-.437-1.511l-.428-1.483-.414-1.428-.39-1.348a21.326,21.326,0,0,0-17.972,7.1,19.638,19.638,0,0,0-4.271,18.476l3.382,11.687a19.637,19.637,0,0,1,4.271-18.476A21.329,21.329,0,0,1,488.949,293.016Z",
    transform: "translate(-462.568 -281.239)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2512",
    "data-name": "Path 2512",
    d: "M506.09,307.1l3.382,11.687a5.566,5.566,0,0,1,1.213-5.236L507.3,301.87A5.561,5.561,0,0,0,506.09,307.1Z",
    transform: "translate(-505.876 -301.87)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2516",
    "data-name": "Path 2516",
    d: "M499.711,312.766a5.428,5.428,0,0,1,1.795,2.7l-3.384-11.687a5.417,5.417,0,0,0-1.792-2.7C497.343,304.586,497.7,309.722,499.711,312.766Z",
    transform: "translate(-496.329 -301.081)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2520",
    "data-name": "Path 2520",
    d: "M505.63,304.083l3.382,11.687a5.448,5.448,0,0,0,1.795,2.7l-3.384-11.684A5.424,5.424,0,0,1,505.63,304.083Z",
    transform: "translate(-505.63 -304.083)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2525",
    "data-name": "Path 2525",
    d: "M500.828,313.908l-3.382-11.684a5.558,5.558,0,0,1-1.208,5.226l3.382,11.687A5.556,5.556,0,0,0,500.828,313.908Z",
    transform: "translate(-496.238 -302.224)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-129"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2530",
    "data-name": "Path 2530",
    d: "M486.793,313.12q-1.043-3.615-2.09-7.227l-.894-3.091,0,0Z",
    transform: "translate(-483.806 -302.8)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-130"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2532",
    "data-name": "Path 2532",
    d: "M499.391,315.55l-.047-.166-.047-.165-.05-.168-.05-.17-.05-.173-.05-.173-.05-.175-.052-.175c-.109-.378-.255-.882-.364-1.263l-.378-1.305c-.116-.4-.272-.934-.385-1.334s-.272-.939-.39-1.341l-.385-1.331-.376-1.3-.364-1.253-.343-1.19A8.281,8.281,0,0,0,490,302.054q1.692,5.842,3.382,11.684l-.395-1.365c-.125-.435-.293-1.012-.419-1.447l-.435-1.5-.442-1.53c-.132-.459-.31-1.069-.442-1.528s-.305-1.052-.435-1.5-.293-1.012-.419-1.447L490,302.054a8.551,8.551,0,0,0-5.668,2.864,8.209,8.209,0,0,0-.69.9l3.384,11.684a8.494,8.494,0,0,1,12.368-1.953Z",
    transform: "translate(-483.639 -302.019)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-131"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2535",
    "data-name": "Path 2535",
    d: "M499.31,307.981l3.382,11.685a5.984,5.984,0,0,0,8.215-.738l-3.382-11.687A5.982,5.982,0,0,1,499.31,307.981Z",
    transform: "translate(-499.31 -307.241)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-132"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2537",
    "data-name": "Path 2537",
    d: "M528.192,339.7a19.414,19.414,0,0,1,10.71-18.554l-.395-1.367c-.125-.433-.293-1.012-.419-1.447s-.3-1.05-.435-1.5-.31-1.069-.442-1.528l-.442-1.53-.435-1.5c-.125-.433-.293-1.012-.419-1.447l-.395-1.364a19.414,19.414,0,0,0-10.71,18.557Z",
    transform: "translate(-524.76 -309.46)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-133"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2539",
    "data-name": "Path 2539",
    d: "M488.9,308.646l3.384,11.687a7.92,7.92,0,0,1,1.31-5.023l-3.382-11.684A7.9,7.9,0,0,0,488.9,308.646Z",
    transform: "translate(-488.87 -303.626)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2541",
    "data-name": "Path 2541",
    d: "M493.5,317.436q-1.692-5.846-3.384-11.687-.358.348-.693.726l3.382,11.684C493.028,317.906,493.262,317.665,493.5,317.436Z",
    transform: "translate(-489.424 -305.749)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2544",
    "data-name": "Path 2544",
    d: "M486.047,314.487a7.735,7.735,0,0,1,2.306,3.136q-1.692-5.842-3.382-11.684a7.73,7.73,0,0,0-2.308-3.138h0v0q.738,2.54,1.471,5.075.954,3.306,1.911,6.607Z",
    transform: "translate(-482.663 -302.8)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2546",
    "data-name": "Path 2546",
    d: "M486.044,315.811l0,0c-.121-.409-.277-.955-.4-1.367-.125-.433-.293-1.012-.419-1.447l-.435-1.5-.442-1.53c-.132-.456-.31-1.069-.442-1.528s-.305-1.05-.435-1.5l-.419-1.447c-.118-.409-.277-.953-.395-1.362v0c.118.409.277.953.395,1.362l.419,1.447q.436,1.515.877,3.029l.442,1.53c.066.225.154.527.218.754l.428,1.48.409,1.409C485.909,315.341,485.975,315.613,486.044,315.811Z",
    transform: "translate(-482.662 -304.127)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2548",
    "data-name": "Path 2548",
    d: "M489.514,306.773l3.382,11.684a7.836,7.836,0,0,1-.151-1.022l-3.384-11.687A7.889,7.889,0,0,0,489.514,306.773Z",
    transform: "translate(-489.36 -305.749)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-138"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2550",
    "data-name": "Path 2550",
    d: "M492.947,317.866q-1.689-5.842-3.382-11.684c-.068.073-.139.149-.206.227l3.382,11.684Z",
    transform: "translate(-489.36 -306.182)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2553",
    "data-name": "Path 2553",
    d: "M485.945,315.813c.09.229.17.464.239.7L482.8,304.828c-.069-.236-.149-.471-.241-.7Z",
    transform: "translate(-482.561 -304.128)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-140"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2555",
    "data-name": "Path 2555",
    d: "M489.431,306.679l3.384,11.685q-.071-.245-.128-.5l-3.382-11.684C489.342,306.348,489.384,306.513,489.431,306.679Z",
    transform: "translate(-489.306 -306.182)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2560",
    "data-name": "Path 2560",
    d: "M454.908,298.762l3.382,11.684a19.184,19.184,0,0,0,6.328,9.537,21.129,21.129,0,0,0,28.995-2.611,19.644,19.644,0,0,0,4.28-18.481l-3.384-11.684a19.637,19.637,0,0,1-4.278,18.478,21.126,21.126,0,0,1-28.995,2.611A19.146,19.146,0,0,1,454.908,298.762Z",
    transform: "translate(-454.908 -287.208)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2564",
    "data-name": "Path 2564",
    d: "M538.179,324.577a18.393,18.393,0,0,1,6.056,9.119l-3.384-11.687a18.376,18.376,0,0,0-6.054-9.116,19.7,19.7,0,0,0-14.3-4.3,20.408,20.408,0,0,0-7.534,2.176q1.688,5.842,3.381,11.687a20.44,20.44,0,0,1,7.534-2.178A19.707,19.707,0,0,1,538.179,324.577Z",
    transform: "translate(-512.968 -308.505)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-143"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2568",
    "data-name": "Path 2568",
    d: "M533.728,324.817a17.136,17.136,0,0,1,5.666,8.535l-3.381-11.685a17.176,17.176,0,0,0-5.666-8.537,18.65,18.65,0,0,0-16.861-3.389q1.692,5.846,3.384,11.687A18.631,18.631,0,0,1,533.728,324.817Z",
    transform: "translate(-513.485 -309.024)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-144"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2570",
    "data-name": "Path 2570",
    d: "M530.9,326.741a18.944,18.944,0,0,1,9.126-5.728c-.12-.409-.277-.955-.395-1.365-.128-.435-.293-1.014-.421-1.447l-.433-1.5c-.135-.459-.312-1.071-.445-1.53l-.442-1.53-.435-1.5-.419-1.445c-.118-.411-.277-.955-.395-1.367a18.973,18.973,0,0,0-9.123,5.728,17.591,17.591,0,0,0-3.829,16.551l3.382,11.685A17.592,17.592,0,0,1,530.9,326.741Z",
    transform: "translate(-523.01 -309.327)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2572",
    "data-name": "Path 2572",
    d: "M533.061,332.763a18.407,18.407,0,0,1-.677-3.772L529,317.307a18.278,18.278,0,0,0,.674,3.772C530.691,324.583,532.044,329.259,533.061,332.763Z",
    transform: "translate(-529.003 -317.307)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2576",
    "data-name": "Path 2576",
    d: "M495.92,324.617a11.385,11.385,0,0,1,2.18-3.672l-3.382-11.687a11.443,11.443,0,0,0-2.183,3.673Q494.228,318.776,495.92,324.617Z",
    transform: "translate(-492.536 -309.258)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2578",
    "data-name": "Path 2578",
    d: "M496.84,322.656l.057-.158c-.121-.409-.277-.955-.4-1.364l-.419-1.447c-.13-.452-.3-1.052-.435-1.5l-.442-1.53-.442-1.53-.435-1.5c-.125-.433-.293-1.012-.419-1.447l-.395-1.365-.054.158Q495.146,316.812,496.84,322.656Z",
    transform: "translate(-493.458 -310.811)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2580",
    "data-name": "Path 2580",
    d: "M495.192,316.582q-.827-2.852-1.651-5.7l-.059.173,3.384,11.684.057-.17-.017-.059-.019-.059-.017-.061-.019-.064-.016-.062-.019-.064-.019-.062-.016-.059-.192-.665-.2-.693-.206-.707-.206-.714-.206-.712-.2-.7-.2-.672Z",
    transform: "translate(-493.482 -310.878)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2582",
    "data-name": "Path 2582",
    d: "M496.888,322.789l.05-.154-.395-1.364-.421-1.447-.433-1.5c-.135-.459-.31-1.071-.445-1.528l-.442-1.53c-.13-.452-.3-1.052-.435-1.5s-.293-1.012-.419-1.447l-.395-1.365-.047.154Q495.195,316.947,496.888,322.789Z",
    transform: "translate(-493.506 -310.951)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2587",
    "data-name": "Path 2587",
    d: "M482.432,309.078l3.384,11.685a7.716,7.716,0,0,0,2.549,3.84,8.2,8.2,0,0,0,4.741,1.83,8.645,8.645,0,0,0,4.552-1,8.487,8.487,0,0,0,2.386-1.885,8.114,8.114,0,0,0,1.809-3.457,7.9,7.9,0,0,0,.168-.958,7.748,7.748,0,0,0-.255-3.029l-3.382-11.684a7.828,7.828,0,0,1,.255,3.027,7.928,7.928,0,0,1-.17.96,8.072,8.072,0,0,1-1.807,3.455,8.5,8.5,0,0,1-2.386,1.887,8.668,8.668,0,0,1-4.552,1,8.21,8.21,0,0,1-4.741-1.83A7.73,7.73,0,0,1,482.432,309.078Z",
    transform: "translate(-482.432 -304.424)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-151"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2589",
    "data-name": "Path 2589",
    d: "M491.111,321.945a1.879,1.879,0,0,1,2.58-.227q-1.493-5.161-2.989-10.32l-.395-1.365a1.876,1.876,0,0,0-2.578.227,1.755,1.755,0,0,0-.381,1.648l3.382,11.684A1.754,1.754,0,0,1,491.111,321.945Z",
    transform: "translate(-487.282 -309.624)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2593",
    "data-name": "Path 2593",
    d: "M488.3,310.589l3.382,11.687a1.727,1.727,0,0,0,.565.849l-3.384-11.687A1.7,1.7,0,0,1,488.3,310.589Z",
    transform: "translate(-488.295 -310.589)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2595",
    "data-name": "Path 2595",
    d: "M497.263,322.213l-.168-.579-.173-.6-.18-.615-.182-.631-.187-.643-.187-.653c-.057-.2-.135-.461-.192-.657l-.192-.662-.234-.8c-.068-.241-.161-.563-.232-.8l-.229-.8-.229-.787c-.066-.232-.156-.542-.222-.773s-.154-.527-.22-.754l-.21-.731-.2-.7a10.945,10.945,0,0,0-.069,6.286l3.384,11.687a10.954,10.954,0,0,1,.066-6.288l-.017-.057-.017-.059-.019-.064-.019-.064-.019-.064-.017-.061-.019-.062Z",
    transform: "translate(-493.527 -311.016)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-154"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2597",
    "data-name": "Path 2597",
    d: "M492.662,319.157l3.382,11.684a10.287,10.287,0,0,1,2.228-9.674L494.89,309.48A10.285,10.285,0,0,0,492.662,319.157Z",
    transform: "translate(-492.265 -309.48)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2599",
    "data-name": "Path 2599",
    d: "M489.4,314.228l3.382,11.685a1.739,1.739,0,0,1,.378-1.636,1.886,1.886,0,0,1,2.585-.234l-3.384-11.684a1.883,1.883,0,0,0-2.582.232A1.743,1.743,0,0,0,489.4,314.228Z",
    transform: "translate(-489.328 -311.949)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2603",
    "data-name": "Path 2603",
    d: "M490.341,312.913l3.382,11.684a1.719,1.719,0,0,0,.568.854l-3.384-11.687A1.706,1.706,0,0,1,490.341,312.913Z",
    transform: "translate(-490.341 -312.913)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-157"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2608",
    "data-name": "Path 2608",
    d: "M491.808,313.572l3.382,11.684a10.04,10.04,0,0,0,3.308,4.987l-3.384-11.685A10.029,10.029,0,0,1,491.808,313.572Z",
    transform: "translate(-491.808 -313.572)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2613",
    "data-name": "Path 2613",
    d: "M492.046,313.674l3.384,11.687A10.811,10.811,0,0,0,499,330.743l-3.382-11.687A10.831,10.831,0,0,1,492.046,313.674Z",
    transform: "translate(-492.046 -313.674)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2616",
    "data-name": "Path 2616",
    d: "M478.685,322.607a10.984,10.984,0,0,1,1.828,1.9l-.395-1.365-.419-1.447-.435-1.5-.442-1.53c-.132-.459-.31-1.069-.442-1.528s-.305-1.052-.435-1.5l-.419-1.447-.395-1.364a11.082,11.082,0,0,0-1.828-1.9C476.318,314.427,476.677,319.561,478.685,322.607Z",
    transform: "translate(-475.303 -310.92)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2618",
    "data-name": "Path 2618",
    d: "M478.724,323.5l-.09-.305-.045-.161-.1-.333-.1-.341-.1-.345-.1-.341-.095-.331-.092-.319-.194-.669-1.334-4.6q-.333-1.16-.672-2.322l-.317-1.092a2.185,2.185,0,0,1-.149-.518l-.069-.092q1.692,5.842,3.382,11.685Z",
    transform: "translate(-475.274 -311.724)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2622",
    "data-name": "Path 2622",
    d: "M513.2,324.723l3.382,11.685a17.164,17.164,0,0,0,5.673,8.544,18.926,18.926,0,0,0,25.975-2.336,17.6,17.6,0,0,0,3.831-16.558l-3.382-11.687a17.6,17.6,0,0,1-3.834,16.558,18.923,18.923,0,0,1-25.972,2.339A17.184,17.184,0,0,1,513.2,324.723Z",
    transform: "translate(-513.198 -314.37)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-162"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2626",
    "data-name": "Path 2626",
    d: "M512.662,325.3l3.382,11.684a18.4,18.4,0,0,0,6.061,9.126,19.685,19.685,0,0,0,14.29,4.3c10.845-.972,19.018-10.258,18.244-20.732a18.28,18.28,0,0,0-.674-3.774l-3.384-11.687a18.293,18.293,0,0,1,.674,3.774c.773,10.474-7.4,19.763-18.244,20.734a19.689,19.689,0,0,1-14.291-4.3A18.417,18.417,0,0,1,512.662,325.3Z",
    transform: "translate(-512.662 -314.216)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-163"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2631",
    "data-name": "Path 2631",
    d: "M481.012,325.312a1.7,1.7,0,0,1,.565.851L478.2,314.477a1.715,1.715,0,0,0-.565-.849C478.645,317.133,479,322.269,481.012,325.312Z",
    transform: "translate(-477.63 -313.628)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-164"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2634",
    "data-name": "Path 2634",
    d: "M477.948,323.445a10.8,10.8,0,0,1,1.674,3.393l-3.384-11.684a10.706,10.706,0,0,0-1.672-3.391L475.7,315.7q.834,2.88,1.667,5.756l.1.338.05.17.05.173.1.343.1.338.047.166.045.161A2.181,2.181,0,0,0,477.948,323.445Z",
    transform: "translate(-474.566 -311.763)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-165"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2638",
    "data-name": "Path 2638",
    d: "M481.606,327.864l-3.384-11.687a10.029,10.029,0,0,0-3.308-4.987l3.384,11.687A10.009,10.009,0,0,1,481.606,327.864Z",
    transform: "translate(-474.914 -311.19)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-166"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2642",
    "data-name": "Path 2642",
    d: "M483.963,325.674l-3.382-11.687a1.766,1.766,0,0,1-.385,1.66,1.886,1.886,0,0,1-2.594.234l3.382,11.684a1.888,1.888,0,0,0,2.594-.232A1.763,1.763,0,0,0,483.963,325.674Z",
    transform: "translate(-477.601 -313.987)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2648",
    "data-name": "Path 2648",
    d: "M483.022,327.538a1.69,1.69,0,0,1,.563.847L480.2,316.7a1.7,1.7,0,0,0-.56-.847C480.654,319.359,481.014,324.495,483.022,327.538Z",
    transform: "translate(-479.64 -315.854)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2660",
    "data-name": "Path 2660",
    d: "M485.952,327.9l-3.384-11.685a1.738,1.738,0,0,1-.378,1.639,1.883,1.883,0,0,1-2.578.237l3.382,11.687a1.883,1.883,0,0,0,2.58-.239A1.742,1.742,0,0,0,485.952,327.9Z",
    transform: "translate(-479.612 -316.212)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-169"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2665",
    "data-name": "Path 2665",
    d: "M485.071,329.863a1.716,1.716,0,0,1,.558.844l-3.384-11.687a1.683,1.683,0,0,0-.558-.842C482.7,321.684,483.061,326.82,485.071,329.863Z",
    transform: "translate(-481.687 -318.179)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2667",
    "data-name": "Path 2667",
    d: "M480.363,324.986,476.979,313.3a10.293,10.293,0,0,1-2.232,9.681l3.382,11.685A10.291,10.291,0,0,0,480.363,324.986Z",
    transform: "translate(-474.746 -313.299)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2669",
    "data-name": "Path 2669",
    d: "M480.179,324.881,476.795,313.2a10.913,10.913,0,0,1,.211,5.2,11.279,11.279,0,0,1-2.62,5.245l3.384,11.687a11.336,11.336,0,0,0,2.62-5.245A10.953,10.953,0,0,0,480.179,324.881Z",
    transform: "translate(-474.385 -313.197)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-172"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2671",
    "data-name": "Path 2671",
    d: "M488,330.222l-3.384-11.687a1.748,1.748,0,0,1-.381,1.648,1.871,1.871,0,0,1-2.573.232L485.04,332.1a1.879,1.879,0,0,0,2.575-.232A1.757,1.757,0,0,0,488,330.222Z",
    transform: "translate(-481.659 -318.535)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2683",
    "data-name": "Path 2683",
    d: "M478.677,322.314,482.061,334a11.093,11.093,0,0,0,14.718-1.717L493.4,320.595A11.094,11.094,0,0,1,478.677,322.314Z",
    transform: "translate(-478.677 -320.595)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-174"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2687",
    "data-name": "Path 2687",
    d: "M486.451,324.58l3.382,11.684-.007-.031-3.384-11.684Z",
    transform: "translate(-486.442 -324.549)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-175"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2691",
    "data-name": "Path 2691",
    d: "M486.287,324.562l3.384,11.684a.338.338,0,0,0,.111.177.391.391,0,0,0,.255.08l-3.382-11.685a.411.411,0,0,1-.255-.083A.359.359,0,0,1,486.287,324.562Z",
    transform: "translate(-486.287 -324.562)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-176"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2693",
    "data-name": "Path 2693",
    d: "M489.5,336.523a.387.387,0,0,0,.392-.291l-3.382-11.684a.389.389,0,0,1-.393.291Z",
    transform: "translate(-486.121 -324.548)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-177"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2697",
    "data-name": "Path 2697",
    d: "M485.77,324.692l3.384,11.687a1.175,1.175,0,0,0,.385.594,1.286,1.286,0,0,0,2.038-.662L488.2,324.626a1.266,1.266,0,0,1-1.237.939,1.245,1.245,0,0,1-.8-.279A1.186,1.186,0,0,1,485.77,324.692Z",
    transform: "translate(-485.77 -324.626)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-178"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2699",
    "data-name": "Path 2699",
    d: "M486.809,324.687l3.384,11.687-.017-.059L486.8,324.63Z",
    transform: "translate(-486.795 -324.63)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2702",
    "data-name": "Path 2702",
    d: "M478.4,322.881l3.384,11.687a11.987,11.987,0,0,0,15.6-2.064L494,320.819A11.986,11.986,0,0,1,478.4,322.881Z",
    transform: "translate(-478.403 -320.819)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-180"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2716",
    "data-name": "Path 2716",
    d: "M367.535,221.384,364.153,209.7A9.892,9.892,0,0,1,362,219.01l3.384,11.685A9.9,9.9,0,0,0,367.535,221.384Z",
    transform: "translate(-361.999 -209.7)",
    fill: "#cddbfd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-181"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2724",
    "data-name": "Path 2724",
    d: "M565.2,294.7l3.382,11.684a9.656,9.656,0,0,0,3.188,4.8L568.381,299.5A9.652,9.652,0,0,1,565.2,294.7Z",
    transform: "translate(-565.196 -294.701)",
    fill: "#cddbfd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2737",
    "data-name": "Path 2737",
    d: "M487.31,356.148l3.382,11.684a10.651,10.651,0,0,0,14.617-1.32l-3.384-11.687A10.646,10.646,0,0,1,487.31,356.148Z",
    transform: "translate(-487.31 -354.826)",
    fill: "#cddbfd"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1943",
    "data-name": "Path 1943",
    d: "M840.754,89.1c21.952,11.509,48.923,32.06,64.257,51.562s24.375,44.988,20.093,69.444c-5.221,29.821-28.794,53.133-54.2,69.514-21.661,13.967-47.258,26.431-56.772,50.423-10.785,27.2,3.631,57.1,15.253,83.957,11.906,27.5,29.971,65.909,34.355,95.566,17.239,116.637-51.8,134.556-80.452,136.8-72.386,5.662-176.137,17.578-241.357-14.4S394.014,495.826,359.477,431.814c-28.707-53.209-7.828-153.577.845-213.438S401.013,101.456,450.476,66.8c56.3-39.45,121.737-41.562,187.711-35.292C723.673,39.631,774.212,54.212,840.754,89.1Z",
    transform: "translate(-279.994 -28.822)",
    fill: "#eadbab"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11480",
    "data-name": "Group 11480",
    transform: "translate(101.114 219.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11479",
    "data-name": "Group 11479",
    transform: "translate(304.098 177.553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11476",
    "data-name": "Group 11476",
    transform: "translate(0 103.902)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2010",
    "data-name": "Path 2010",
    d: "M425.669,385.9c-3.686-1.344-8.1-2.178-11.294.107a9.163,9.163,0,0,0-3.1,4.37c-3.443,9.379,4.194,19.23,12.527,24.72s18.313,9.431,23.667,17.862c-7.574,3.827-17.038-1.345-25.1,1.31-5.764,1.9-9.75,7.906-9.787,13.987a17.952,17.952,0,0,0,8.8,15.041c11.538,6.923,26.391.546,39.692,2.524,3.605.536,7.271,1.8,9.737,4.494s3.35,7.055,1.283,10.062c-4.426,6.437-17.18,2.1-20.524,9.165-1.441,3.042-.006,6.851,2.544,9.043s5.952,3.084,9.265,3.641a62.485,62.485,0,0,0,23.637-.575c2.83-.618,5.684-1.441,8.571-1.2s5.891,1.846,6.786,4.608c2.684,8.287-14.393,13.847-10.9,21.824,2.021,4.616,8.688,3.911,13.5,2.428l33.944-10.463c6.155-1.9,12.959-4.328,15.812-10.114,1.467-2.974,1.63-6.4,1.682-9.721a199.374,199.374,0,0,0-6.557-53.938c-1.029-3.906-2.324-8.012-5.4-10.626s-8.483-2.841-10.659.559c-1.409,2.2-2.447,6.047-4.9,5.15-1.15-.42-1.6-1.787-1.878-2.981-4.4-18.612-6.22-39.634-20.2-52.654a9.917,9.917,0,0,0-4.533-2.744c-4.537-.937-8.36,3.927-8.985,8.526s.656,9.294.091,13.9-4.222,9.547-8.793,8.79a69.206,69.206,0,0,0-18.215-33.652c-3.569-3.62-9.741-6.8-13.227-3.1-1.9,2.015-1.856,5.14-1.517,7.891a63.773,63.773,0,0,0,4.691,17.355c1.161,2.7,3.745,8.875-.818,9-2.476.07-6.839-8.185-8.336-9.877A53.243,53.243,0,0,0,425.669,385.9Z",
    transform: "translate(-410.424 -374.598)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11472",
    "data-name": "Group 11472",
    transform: "translate(3.737 17.931)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2011",
    "data-name": "Path 2011",
    d: "M499.224,399.887a7.912,7.912,0,0,0,2.033,1.187,2.669,2.669,0,0,0,2.276-.162.8.8,0,0,0,.346-.387.958.958,0,0,0-.175-.757,19.368,19.368,0,0,0-4.828-5.037,5.2,5.2,0,0,0-1.756-1.077,1.778,1.778,0,0,0-1.892.482c-.614.8-.12,1.979.542,2.742A21.535,21.535,0,0,0,499.224,399.887Z",
    transform: "translate(-484.008 -384.033)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2012",
    "data-name": "Path 2012",
    d: "M502.475,392.032a.677.677,0,0,0,.944-.161.887.887,0,0,0,.075-.332,4.29,4.29,0,0,0-1.119-3.246.858.858,0,0,0-.833-.355.733.733,0,0,0-.4.45,2.147,2.147,0,0,0-.01,1.422A4.964,4.964,0,0,0,502.475,392.032Z",
    transform: "translate(-492.394 -386.566)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2013",
    "data-name": "Path 2013",
    d: "M496.556,401.235a.432.432,0,0,0-.517.326.566.566,0,0,0,.035.213,2.743,2.743,0,0,0,1.449,1.642.55.55,0,0,0,.578.006.471.471,0,0,0,.127-.365,1.359,1.359,0,0,0-.339-.84A3.156,3.156,0,0,0,496.556,401.235Z",
    transform: "translate(-479.91 -380.603)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2014",
    "data-name": "Path 2014",
    d: "M485.293,407.424a.432.432,0,0,0-.2.578.531.531,0,0,0,.161.145,2.722,2.722,0,0,0,2.154.374c.2-.051.418-.156.455-.358a.469.469,0,0,0-.127-.363,1.357,1.357,0,0,0-.789-.443A3.146,3.146,0,0,0,485.293,407.424Z",
    transform: "translate(-453.624 -377.894)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2015",
    "data-name": "Path 2015",
    d: "M506.44,390.68c-.022-.229-.224-.457-.45-.416a.59.59,0,0,0-.2.091,2.726,2.726,0,0,0-1.2,1.834.549.549,0,0,0,.146.56.465.465,0,0,0,.384.026,1.362,1.362,0,0,0,.72-.55A3.174,3.174,0,0,0,506.44,390.68Z",
    transform: "translate(-500.496 -385.515)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2016",
    "data-name": "Path 2016",
    d: "M484.218,405.543a1.4,1.4,0,0,0,1.05-.695,2.269,2.269,0,0,0,.126-1.548,4.675,4.675,0,0,0-.872-1.963,1.827,1.827,0,0,0-1.206-.767,1.888,1.888,0,0,0-1.32.529,2.22,2.22,0,0,0-.825,1.238,1.944,1.944,0,0,0,.486,1.555C482.171,404.506,483.349,405.635,484.218,405.543Z",
    transform: "translate(-445.589 -380.9)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2017",
    "data-name": "Path 2017",
    d: "M490.948,405.843a2.184,2.184,0,0,0,1.664-1.048,3.274,3.274,0,0,0,.44-1.963,1.829,1.829,0,0,0-.479-1.242,1.417,1.417,0,0,0-1.435-.229,2.478,2.478,0,0,0-1.148.974,4.047,4.047,0,0,0-.628,1.54A1.642,1.642,0,0,0,490.948,405.843Z",
    transform: "translate(-465.037 -380.587)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2018",
    "data-name": "Path 2018",
    d: "M492.219,399.251a.673.673,0,0,0,.513-.323,1,1,0,0,0,.135-.6.557.557,0,0,0-.148-.381.435.435,0,0,0-.44-.071.765.765,0,0,0-.353.3,1.245,1.245,0,0,0-.193.473A.5.5,0,0,0,492.219,399.251Z",
    transform: "translate(-468.306 -382.119)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2019",
    "data-name": "Path 2019",
    d: "M502.4,399.553a.671.671,0,0,0,.511-.321,1.018,1.018,0,0,0,.136-.6.57.57,0,0,0-.148-.381.437.437,0,0,0-.442-.071.76.76,0,0,0-.352.3,1.247,1.247,0,0,0-.194.473A.5.5,0,0,0,502.4,399.553Z",
    transform: "translate(-493.212 -381.983)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2020",
    "data-name": "Path 2020",
    d: "M504.734,395.539a.682.682,0,0,0-.416-.45,1.014,1.014,0,0,0-.625-.022.575.575,0,0,0-.35.219.443.443,0,0,0,.013.453.77.77,0,0,0,.363.3,1.245,1.245,0,0,0,.507.1A.511.511,0,0,0,504.734,395.539Z",
    transform: "translate(-496.922 -383.38)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2021",
    "data-name": "Path 2021",
    d: "M506.739,394.292a.328.328,0,0,0,.252-.158.5.5,0,0,0,.068-.3.274.274,0,0,0-.074-.188.211.211,0,0,0-.217-.035.374.374,0,0,0-.174.148.6.6,0,0,0-.1.233A.249.249,0,0,0,506.739,394.292Z",
    transform: "translate(-503.882 -384.021)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2022",
    "data-name": "Path 2022",
    d: "M503.058,393.92a.329.329,0,0,0,.252-.159.494.494,0,0,0,.067-.3.271.271,0,0,0-.072-.187.211.211,0,0,0-.217-.035.371.371,0,0,0-.174.146.6.6,0,0,0-.1.234A.25.25,0,0,0,503.058,393.92Z",
    transform: "translate(-494.87 -384.187)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2023",
    "data-name": "Path 2023",
    d: "M507.694,391.515a.329.329,0,0,0,.252-.159.492.492,0,0,0,.067-.3.272.272,0,0,0-.072-.188.211.211,0,0,0-.217-.035.37.37,0,0,0-.175.148.61.61,0,0,0-.094.233A.247.247,0,0,0,507.694,391.515Z",
    transform: "translate(-506.216 -385.264)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2024",
    "data-name": "Path 2024",
    d: "M505.45,388.408a.682.682,0,0,0,.518-.326,1.02,1.02,0,0,0,.136-.611.561.561,0,0,0-.149-.387.442.442,0,0,0-.446-.072.776.776,0,0,0-.358.3,1.252,1.252,0,0,0-.2.479A.511.511,0,0,0,505.45,388.408Z",
    transform: "translate(-500.691 -386.983)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2025",
    "data-name": "Path 2025",
    d: "M508.394,389.5a.675.675,0,0,0,.513-.321,1.009,1.009,0,0,0,.135-.6.56.56,0,0,0-.148-.382.432.432,0,0,0-.44-.069.756.756,0,0,0-.353.3,1.247,1.247,0,0,0-.193.472A.5.5,0,0,0,508.394,389.5Z",
    transform: "translate(-507.9 -386.486)",
    fill: "#97b4fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11473",
    "data-name": "Group 11473",
    transform: "translate(6.915 70.52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2026",
    "data-name": "Path 2026",
    d: "M496.018,432.512a7.845,7.845,0,0,0,2.332.3,2.668,2.668,0,0,0,2.036-1.034.807.807,0,0,0,.169-.491.961.961,0,0,0-.455-.63,19.272,19.272,0,0,0-6.4-2.764,5.159,5.159,0,0,0-2.037-.31,1.777,1.777,0,0,0-1.556,1.18c-.256.977.654,1.871,1.561,2.317A21.515,21.515,0,0,0,496.018,432.512Z",
    transform: "translate(-476.768 -421.397)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2027",
    "data-name": "Path 2027",
    d: "M501.327,426.845a.677.677,0,0,0,.808-.515.863.863,0,0,0-.058-.334,4.279,4.279,0,0,0-2.289-2.557.856.856,0,0,0-.9,0,.729.729,0,0,0-.2.572,2.141,2.141,0,0,0,.542,1.313A4.956,4.956,0,0,0,501.327,426.845Z",
    transform: "translate(-490.831 -423.306)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2028",
    "data-name": "Path 2028",
    d: "M489.786,433.647a.432.432,0,0,0-.35.5.561.561,0,0,0,.114.182,2.733,2.733,0,0,0,1.972.95.548.548,0,0,0,.534-.219.476.476,0,0,0-.023-.387,1.365,1.365,0,0,0-.638-.641A3.146,3.146,0,0,0,489.786,433.647Z",
    transform: "translate(-467.368 -418.683)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2029",
    "data-name": "Path 2029",
    d: "M477.338,435.5a.433.433,0,0,0,.038.611.562.562,0,0,0,.2.071,2.727,2.727,0,0,0,2.131-.5c.162-.123.326-.306.281-.505a.477.477,0,0,0-.259-.287,1.362,1.362,0,0,0-.9-.1A3.152,3.152,0,0,0,477.338,435.5Z",
    transform: "translate(-437.629 -418.176)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2030",
    "data-name": "Path 2030",
    d: "M503.052,426.748a.431.431,0,0,0-.575-.207.592.592,0,0,0-.146.159,2.738,2.738,0,0,0-.391,2.157c.048.2.151.42.352.458a.466.466,0,0,0,.365-.125,1.365,1.365,0,0,0,.449-.786A3.178,3.178,0,0,0,503.052,426.748Z",
    transform: "translate(-496.486 -421.879)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2031",
    "data-name": "Path 2031",
    d: "M479.542,431.617a1.4,1.4,0,0,0,.7-1.047,2.257,2.257,0,0,0-.484-1.477,4.625,4.625,0,0,0-1.562-1.47,1.825,1.825,0,0,0-1.41-.239,1.892,1.892,0,0,0-1.011,1,2.211,2.211,0,0,0-.281,1.461,1.939,1.939,0,0,0,1.048,1.245C477.253,431.459,478.777,432.042,479.542,431.617Z",
    transform: "translate(-435.31 -421.506)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2032",
    "data-name": "Path 2032",
    d: "M485.393,435.527a2.2,2.2,0,0,0,1.128-1.614,3.28,3.28,0,0,0-.355-1.981,1.831,1.831,0,0,0-.922-.958,1.419,1.419,0,0,0-1.412.347,2.49,2.49,0,0,0-.68,1.344,4.057,4.057,0,0,0,.016,1.665A1.641,1.641,0,0,0,485.393,435.527Z",
    transform: "translate(-452.646 -419.903)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2033",
    "data-name": "Path 2033",
    d: "M487.785,429.9a.674.674,0,0,0,.348-.5,1.028,1.028,0,0,0-.109-.61.569.569,0,0,0-.284-.294.438.438,0,0,0-.434.107.756.756,0,0,0-.208.413,1.265,1.265,0,0,0,0,.511A.5.5,0,0,0,487.785,429.9Z",
    transform: "translate(-460.025 -420.988)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2034",
    "data-name": "Path 2034",
    d: "M497.046,434.137a.678.678,0,0,0,.347-.5,1.011,1.011,0,0,0-.11-.608.568.568,0,0,0-.282-.3.437.437,0,0,0-.434.107.761.761,0,0,0-.208.413,1.248,1.248,0,0,0,0,.513A.5.5,0,0,0,497.046,434.137Z",
    transform: "translate(-482.692 -419.092)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2035",
    "data-name": "Path 2035",
    d: "M500.226,430.7a.684.684,0,0,0-.557-.253,1.023,1.023,0,0,0-.585.224.572.572,0,0,0-.239.337.444.444,0,0,0,.187.413.783.783,0,0,0,.45.132,1.269,1.269,0,0,0,.507-.1A.514.514,0,0,0,500.226,430.7Z",
    transform: "translate(-489.23 -420.109)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2036",
    "data-name": "Path 2036",
    d: "M502.788,430.966a.327.327,0,0,0,.171-.245.493.493,0,0,0-.054-.3.273.273,0,0,0-.139-.145.212.212,0,0,0-.214.052.368.368,0,0,0-.1.2.617.617,0,0,0,0,.252A.248.248,0,0,0,502.788,430.966Z",
    transform: "translate(-497.089 -420.189)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2037",
    "data-name": "Path 2037",
    d: "M499.54,429.192a.34.34,0,0,0,.171-.245.506.506,0,0,0-.054-.3.275.275,0,0,0-.14-.145.212.212,0,0,0-.214.052.368.368,0,0,0-.1.2.59.59,0,0,0,0,.252A.249.249,0,0,0,499.54,429.192Z",
    transform: "translate(-489.136 -420.984)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2038",
    "data-name": "Path 2038",
    d: "M504.742,428.777a.333.333,0,0,0,.172-.245.514.514,0,0,0-.054-.3.275.275,0,0,0-.14-.145.212.212,0,0,0-.214.052.368.368,0,0,0-.1.2.617.617,0,0,0,0,.252A.248.248,0,0,0,504.742,428.777Z",
    transform: "translate(-501.872 -421.169)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2039",
    "data-name": "Path 2039",
    d: "M504.185,425.052a.679.679,0,0,0,.35-.5,1.017,1.017,0,0,0-.11-.617.566.566,0,0,0-.287-.3.439.439,0,0,0-.439.109.78.78,0,0,0-.213.418,1.276,1.276,0,0,0,.006.518A.51.51,0,0,0,504.185,425.052Z",
    transform: "translate(-500.157 -423.168)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2040",
    "data-name": "Path 2040",
    d: "M506.469,427.2a.668.668,0,0,0,.346-.5,1.006,1.006,0,0,0-.109-.609.566.566,0,0,0-.282-.294.44.44,0,0,0-.434.106.766.766,0,0,0-.208.414,1.217,1.217,0,0,0,0,.511A.5.5,0,0,0,506.469,427.2Z",
    transform: "translate(-505.756 -422.196)",
    fill: "#97b4fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11474",
    "data-name": "Group 11474",
    transform: "translate(44.841 104.515)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2041",
    "data-name": "Path 2041",
    d: "M471.15,458.366a1.126,1.126,0,0,0,.817-.308,2.613,2.613,0,0,0,.237-2,1.03,1.03,0,0,0-.329-.476,4.115,4.115,0,0,0-2.809-.97.752.752,0,0,0-.725.227,2.055,2.055,0,0,0-.138,1.509,2.52,2.52,0,0,0,1.17,1.784A3.521,3.521,0,0,0,471.15,458.366Z",
    transform: "translate(-454.689 -443.283)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2042",
    "data-name": "Path 2042",
    d: "M477.089,454.95a.676.676,0,0,0,.533-.8.85.85,0,0,0-.187-.282,4.269,4.269,0,0,0-3.122-1.419c-.318,0-.7.07-.83.361a.739.739,0,0,0,.051.6,2.137,2.137,0,0,0,1.022.984A4.925,4.925,0,0,0,477.089,454.95Z",
    transform: "translate(-467.714 -444.248)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2043",
    "data-name": "Path 2043",
    d: "M461.491,458.178a.433.433,0,0,0-.122.6.563.563,0,0,0,.18.122,2.721,2.721,0,0,0,2.185.074c.19-.077.394-.211.4-.416a.474.474,0,0,0-.177-.343,1.36,1.36,0,0,0-.841-.331A3.149,3.149,0,0,0,461.491,458.178Z",
    transform: "translate(-436.616 -441.819)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2044",
    "data-name": "Path 2044",
    d: "M449.913,455.235a.434.434,0,0,0,.279.544.57.57,0,0,0,.216-.017,2.725,2.725,0,0,0,1.752-1.312.55.55,0,0,0,.055-.575.467.467,0,0,0-.352-.158,1.349,1.349,0,0,0-.864.269A3.141,3.141,0,0,0,449.913,455.235Z",
    transform: "translate(-408.261 -443.683)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2045",
    "data-name": "Path 2045",
    d: "M476.148,456.145a.432.432,0,0,0-.61.042.56.56,0,0,0-.069.2,2.739,2.739,0,0,0,.507,2.133c.123.162.307.324.505.278a.466.466,0,0,0,.284-.261,1.366,1.366,0,0,0,.1-.9A3.15,3.15,0,0,0,476.148,456.145Z",
    transform: "translate(-469.837 -442.641)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2046",
    "data-name": "Path 2046",
    d: "M455.232,449.912a1.4,1.4,0,0,0,.219-1.241,2.249,2.249,0,0,0-1.034-1.155,4.627,4.627,0,0,0-2.02-.718,1.824,1.824,0,0,0-1.387.35,1.9,1.9,0,0,0-.526,1.323,2.22,2.22,0,0,0,.329,1.451,1.938,1.938,0,0,0,1.461.718C453.073,450.688,454.7,450.608,455.232,449.912Z",
    transform: "translate(-412.331 -446.786)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2047",
    "data-name": "Path 2047",
    d: "M459.363,456.9a2.2,2.2,0,0,0,.387-1.931,3.279,3.279,0,0,0-1.119-1.671,1.816,1.816,0,0,0-1.229-.505,1.419,1.419,0,0,0-1.154.886,2.484,2.484,0,0,0-.083,1.506,4.053,4.053,0,0,0,.682,1.517A1.637,1.637,0,0,0,459.363,456.9Z",
    transform: "translate(-424.767 -444.098)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2048",
    "data-name": "Path 2048",
    d: "M467.932,453.655a2.2,2.2,0,0,0,.387-1.933,3.276,3.276,0,0,0-1.119-1.671,1.824,1.824,0,0,0-1.229-.505,1.42,1.42,0,0,0-1.153.886,2.485,2.485,0,0,0-.084,1.506,4.043,4.043,0,0,0,.682,1.517A1.637,1.637,0,0,0,467.932,453.655Z",
    transform: "translate(-445.744 -445.551)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2049",
    "data-name": "Path 2049",
    d: "M462.326,453.16a.677.677,0,0,0,.119-.594,1,1,0,0,0-.345-.513.555.555,0,0,0-.376-.155.434.434,0,0,0-.355.272.761.761,0,0,0-.026.462,1.235,1.235,0,0,0,.21.466A.5.5,0,0,0,462.326,453.16Z",
    transform: "translate(-434.987 -444.496)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2050",
    "data-name": "Path 2050",
    d: "M469.106,460.771a.679.679,0,0,0,.119-.594,1.011,1.011,0,0,0-.345-.514.561.561,0,0,0-.376-.155.437.437,0,0,0-.355.272.767.767,0,0,0-.026.463,1.245,1.245,0,0,0,.21.466A.5.5,0,0,0,469.106,460.771Z",
    transform: "translate(-451.583 -441.089)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2051",
    "data-name": "Path 2051",
    d: "M472.551,458.522a.681.681,0,0,0-.612-.007,1.019,1.019,0,0,0-.444.44.571.571,0,0,0-.084.405.444.444,0,0,0,.337.3.772.772,0,0,0,.465-.062,1.251,1.251,0,0,0,.423-.3A.511.511,0,0,0,472.551,458.522Z",
    transform: "translate(-459.889 -441.565)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2052",
    "data-name": "Path 2052",
    d: "M475.3,460.283a.334.334,0,0,0,.059-.292.506.506,0,0,0-.169-.253.283.283,0,0,0-.187-.077.216.216,0,0,0-.175.135.38.38,0,0,0-.013.227.6.6,0,0,0,.1.23A.246.246,0,0,0,475.3,460.283Z",
    transform: "translate(-467.414 -441.021)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2053",
    "data-name": "Path 2053",
    d: "M473.038,457.349a.337.337,0,0,0,.059-.294.5.5,0,0,0-.169-.253.281.281,0,0,0-.187-.075.214.214,0,0,0-.175.133.385.385,0,0,0-.013.229.615.615,0,0,0,.1.23A.248.248,0,0,0,473.038,457.349Z",
    transform: "translate(-461.875 -442.335)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2054",
    "data-name": "Path 2054",
    d: "M477.968,459.066a.334.334,0,0,0,.059-.292.5.5,0,0,0-.171-.253.277.277,0,0,0-.185-.077.214.214,0,0,0-.175.135.38.38,0,0,0-.013.227.6.6,0,0,0,.1.23A.246.246,0,0,0,477.968,459.066Z",
    transform: "translate(-473.943 -441.566)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2055",
    "data-name": "Path 2055",
    d: "M479.294,455.327a.685.685,0,0,0,.12-.6,1.032,1.032,0,0,0-.349-.521.57.57,0,0,0-.382-.156.44.44,0,0,0-.359.275.785.785,0,0,0-.026.469,1.245,1.245,0,0,0,.213.472A.51.51,0,0,0,479.294,455.327Z",
    transform: "translate(-476.504 -443.534)",
    fill: "#97b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2056",
    "data-name": "Path 2056",
    d: "M480.514,458.22a.674.674,0,0,0,.119-.594,1.007,1.007,0,0,0-.343-.513.562.562,0,0,0-.378-.156.439.439,0,0,0-.355.272.766.766,0,0,0-.026.463,1.257,1.257,0,0,0,.21.466A.5.5,0,0,0,480.514,458.22Z",
    transform: "translate(-479.507 -442.231)",
    fill: "#97b4fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11475",
    "data-name": "Group 11475",
    transform: "translate(44.511 37.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2057",
    "data-name": "Path 2057",
    d: "M406.275,412.749a439.2,439.2,0,0,1,97.089,92.714",
    transform: "translate(-395.859 -394.735)",
    fill: "none",
    stroke: "#cddbfd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.662
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2058",
    "data-name": "Path 2058",
    d: "M439.636,431.416c6.562,12.361,9.4,24.454,2.225,36.465-1.2,2-10.96,8.254-21.543,8.617",
    transform: "translate(-358.899 -386.376)",
    fill: "none",
    stroke: "#cddbfd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.662
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2059",
    "data-name": "Path 2059",
    d: "M459.08,410.918c9.228,12.538,8.313,31.545-2.076,43.135-3.217,3.588-7.591,6.609-12.4,6.472",
    transform: "translate(-413.429 -395.555)",
    fill: "none",
    stroke: "#cddbfd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.662
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2060",
    "data-name": "Path 2060",
    d: "M480.049,400.307a53.27,53.27,0,0,1,6.425,16.2c1.029,4.763,1.254,10.2-1.756,14.029a13.235,13.235,0,0,1-8.861,4.511,39.216,39.216,0,0,1-10.155-.5",
    transform: "translate(-465.702 -400.307)",
    fill: "none",
    stroke: "#cddbfd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.662
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11477",
    "data-name": "Group 11477",
    transform: "translate(93.929 46.549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2061",
    "data-name": "Path 2061",
    d: "M459.193,405.356c-8.665-24.058-20.809-48.3-41.943-62.637-10.2-6.918-24.21-11.016-34.574-4.349-8.583,5.521-11.781,16.729-11.522,26.947.327,12.919,5.012,25.306,10.268,37.106,16.74,37.581,39.877,72.234,54,110.881,2.747,7.517,5.522,15.688,12.056,20.294a18.783,18.783,0,0,0,21.086,0c16.436-11.585,11.144-36.342,8.965-52.815A363.116,363.116,0,0,0,459.193,405.356Z",
    transform: "translate(-371.139 -334.984)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2062",
    "data-name": "Path 2062",
    d: "M380.026,336.608c26.937,30.516,45.337,67.878,57.658,106.707s18.794,79.265,23.983,119.676",
    transform: "translate(-365.577 -334.257)",
    fill: "none",
    stroke: "#0a0940",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.487
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11478",
    "data-name": "Group 11478",
    transform: "translate(164.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2063",
    "data-name": "Path 2063",
    d: "M405.991,511.682l-44.672-12.9s-27.151-93.335-4.645-118.483c0,0-9.852-73.8,11.53-77.318s29.314,57.467,29.314,57.467S441.225,371.539,405.991,511.682Z",
    transform: "translate(-347.748 -302.833)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2064",
    "data-name": "Path 2064",
    d: "M371.565,302.935s24.066,105.844,14.988,202.118",
    transform: "translate(-351.108 -302.788)",
    fill: "none",
    stroke: "#0a0940",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.487
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12213",
    "data-name": "Group 12213",
    transform: "translate(66.349 135.524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12199",
    "data-name": "Group 12199",
    transform: "translate(0 37.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12191",
    "data-name": "Group 12191",
    transform: "translate(-66.349 174.293) rotate(-39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12190",
    "data-name": "Group 12190",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11482",
    "data-name": "Group 11482",
    transform: "translate(297.742 37.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2069",
    "data-name": "Path 2069",
    d: "M378.327,163.755l3.383,11.685L529.443,296.283,526.06,284.6Z",
    transform: "translate(-378.327 -163.755)",
    fill: "#6c7282"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11485",
    "data-name": "Group 11485",
    transform: "translate(299.318 49.595)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11484",
    "data-name": "Group 11484",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11483",
    "data-name": "Group 11483",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2070",
    "data-name": "Path 2070",
    d: "M438.239,172.576l3.382,11.687a2.731,2.731,0,0,1,.594-2.568,2.946,2.946,0,0,1,4.03-.364l-3.384-11.684a2.941,2.941,0,0,0-4.03.364,2.724,2.724,0,0,0-.591,2.566",
    transform: "translate(-438.133 -169.012)",
    fill: "#233a81"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11488",
    "data-name": "Group 11488",
    transform: "translate(299.424 53.16)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11487",
    "data-name": "Group 11487",
    transform: "translate(0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11486",
    "data-name": "Group 11486",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2072",
    "data-name": "Path 2072",
    d: "M440.084,170.519l3.382,11.687.009.031-3.382-11.687-.009-.031",
    transform: "translate(-440.084 -170.519)",
    fill: "#747b8c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2073",
    "data-name": "Path 2073",
    d: "M439.881,170.532l3.382,11.687a2.69,2.69,0,0,0,.48.9l-3.382-11.684a2.639,2.639,0,0,1-.48-.906",
    transform: "translate(-439.872 -170.501)",
    fill: "#6f7687"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2074",
    "data-name": "Path 2074",
    d: "M439.716,170.915,443.1,182.6a2.765,2.765,0,0,0,.39.39L440.1,171.3a2.733,2.733,0,0,1-.388-.388",
    transform: "translate(-439.226 -169.979)",
    fill: "#6c7282"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11491",
    "data-name": "Group 11491",
    transform: "translate(344.321 52.54)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11490",
    "data-name": "Group 11490",
    transform: "translate(0)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11489",
    "data-name": "Group 11489",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2076",
    "data-name": "Path 2076",
    d: "M417.931,176.23l3.384,11.687a4.573,4.573,0,0,1,1-4.3,4.915,4.915,0,0,1,6.742-.608l-3.382-11.684a4.914,4.914,0,0,0-6.742.608,4.571,4.571,0,0,0-1,4.3",
    transform: "translate(-417.755 -170.257)",
    fill: "#6c7282"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11494",
    "data-name": "Group 11494",
    transform: "translate(344.497 58.514)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11493",
    "data-name": "Group 11493",
    transform: "translate(0)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11492",
    "data-name": "Group 11492",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2078",
    "data-name": "Path 2078",
    d: "M421.021,172.783,424.4,184.47l.017.052-3.382-11.687-.017-.052",
    transform: "translate(-421.021 -172.783)",
    fill: "#434e6a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2079",
    "data-name": "Path 2079",
    d: "M420.681,172.8l3.382,11.687a4.408,4.408,0,0,0,.8,1.511l-3.384-11.687a4.4,4.4,0,0,1-.8-1.511",
    transform: "translate(-420.664 -172.753)",
    fill: "#414b66"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2080",
    "data-name": "Path 2080",
    d: "M420.406,173.444l3.384,11.687a4.564,4.564,0,0,0,.65.65L421.059,174.1a4.729,4.729,0,0,1-.653-.653",
    transform: "translate(-419.588 -171.881)",
    fill: "#3e4962"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11497",
    "data-name": "Group 11497",
    transform: "translate(273.846 77.589)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11496",
    "data-name": "Group 11496",
    transform: "translate(0)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11495",
    "data-name": "Group 11495",
    transform: "translate(0 0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2082",
    "data-name": "Path 2082",
    d: "M445.79,183.842l3.382,11.684a8.822,8.822,0,0,1,12.094-1.083l-3.384-11.687a8.822,8.822,0,0,0-12.091,1.085",
    transform: "translate(-445.79 -180.849)",
    fill: "#233a81"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11498",
    "data-name": "Group 11498",
    transform: "translate(270.944 80.582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2084",
    "data-name": "Path 2084",
    d: "M450.9,185.413l3.383,11.685,2.9-3.3-3.383-11.685Z",
    transform: "translate(-450.904 -182.115)",
    fill: "#22387d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11501",
    "data-name": "Group 11501",
    transform: "translate(274.492 78.416)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11500",
    "data-name": "Group 11500",
    transform: "translate(0)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11499",
    "data-name": "Group 11499",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2085",
    "data-name": "Path 2085",
    d: "M446.028,183.895l3.384,11.684a7.935,7.935,0,0,1,10.883-.974l-3.382-11.687a7.936,7.936,0,0,0-10.885.977",
    transform: "translate(-446.028 -181.199)",
    fill: "#1c2e61"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11502",
    "data-name": "Group 11502",
    transform: "translate(271.59 81.111)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2087",
    "data-name": "Path 2087",
    d: "M450.63,185.636l3.383,11.685,2.9-3.3-3.383-11.685Z",
    transform: "translate(-450.63 -182.339)",
    fill: "#1b2c5f"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11503",
    "data-name": "Group 11503",
    transform: "translate(80.277 37.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2088",
    "data-name": "Path 2088",
    d: "M440.8,409.623l3.383,11.685L661.647,175.44l-3.383-11.685Z",
    transform: "translate(-440.799 -163.755)",
    fill: "#686e7e"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11504",
    "data-name": "Group 11504",
    transform: "translate(249.387 37.359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2089",
    "data-name": "Path 2089",
    d: "M440.7,219.06l3.383,11.685,48.593-55.223-3.383-11.686Z",
    transform: "translate(-440.698 -163.837)",
    fill: "#7e7e7e"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11505",
    "data-name": "Group 11505",
    transform: "translate(304.045 50.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2090",
    "data-name": "Path 2090",
    d: "M426.459,169.28l3.383,11.685,27.607,22.582-3.383-11.685Z",
    transform: "translate(-426.459 -169.28)",
    fill: "#233a81"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11508",
    "data-name": "Group 11508",
    transform: "translate(268.861 83.881)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11507",
    "data-name": "Group 11507",
    transform: "translate(0)",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11506",
    "data-name": "Group 11506",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2091",
    "data-name": "Path 2091",
    d: "M452.45,191.236l3.382,11.684a8.226,8.226,0,0,1,1.764-7.726l-3.382-11.684a8.217,8.217,0,0,0-1.764,7.726",
    transform: "translate(-452.131 -183.51)",
    fill: "#233a81"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11511",
    "data-name": "Group 11511",
    transform: "translate(269.717 84.408)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11510",
    "data-name": "Group 11510",
    transform: "translate(0)",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11509",
    "data-name": "Group 11509",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2093",
    "data-name": "Path 2093",
    d: "M452.144,190.69l3.384,11.684a7.4,7.4,0,0,1,1.587-6.957l-3.384-11.684a7.409,7.409,0,0,0-1.587,6.957",
    transform: "translate(-451.857 -183.733)",
    fill: "#1c2e61"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11514",
    "data-name": "Group 11514",
    transform: "translate(331.651 72.811)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11513",
    "data-name": "Group 11513",
    transform: "translate(0)",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11512",
    "data-name": "Group 11512",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2095",
    "data-name": "Path 2095",
    d: "M426.3,178.829l3.384,11.687a2.7,2.7,0,0,1,.385.385l-3.384-11.684a2.6,2.6,0,0,0-.385-.388",
    transform: "translate(-426.296 -178.829)",
    fill: "#233a81"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2096",
    "data-name": "Path 2096",
    d: "M426.094,178.993l3.384,11.685a2.631,2.631,0,0,1,.478.9l-3.382-11.687a2.627,2.627,0,0,0-.48-.9",
    transform: "translate(-425.708 -178.605)",
    fill: "#243c86"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2097",
    "data-name": "Path 2097",
    d: "M426.09,179.373l3.382,11.687.009.031L426.1,179.4l-.007-.031",
    transform: "translate(-425.224 -178.087)",
    fill: "#253d8a"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11515",
    "data-name": "Group 11515",
    transform: "translate(300.301 54.484)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2099",
    "data-name": "Path 2099",
    d: "M428.042,171.079l3.383,11.686,27.607,22.582-3.383-11.685Z",
    transform: "translate(-428.042 -171.079)",
    fill: "#6c7282"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11518",
    "data-name": "Group 11518",
    transform: "translate(270.003 91.363)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11517",
    "data-name": "Group 11517",
    transform: "translate(0)",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11516",
    "data-name": "Group 11516",
    transform: "translate(0 0.002)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2100",
    "data-name": "Path 2100",
    d: "M452.517,186.675l3.384,11.684.026.087-3.384-11.684-.026-.088",
    transform: "translate(-452.517 -186.675)",
    fill: "#1e3169"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2101",
    "data-name": "Path 2101",
    d: "M451.969,186.712l3.384,11.684a7.106,7.106,0,0,0,1.3,2.438l-3.384-11.684a7.189,7.189,0,0,1-1.3-2.438",
    transform: "translate(-451.943 -186.624)",
    fill: "#1d2f65"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2102",
    "data-name": "Path 2102",
    d: "M451.581,187.743l3.384,11.684a7.164,7.164,0,0,0,.918.941L452.5,188.682a7.032,7.032,0,0,1-.92-.939",
    transform: "translate(-450.259 -185.217)",
    fill: "#1c2e61"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11521",
    "data-name": "Group 11521",
    transform: "translate(327.908 74.128)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11520",
    "data-name": "Group 11520",
    transform: "translate(0)",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11519",
    "data-name": "Group 11519",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2104",
    "data-name": "Path 2104",
    d: "M426.046,182.323l3.384,11.687a2.933,2.933,0,0,0,4.022-.367,2.734,2.734,0,0,0,.594-2.571l-3.384-11.687a2.731,2.731,0,0,1-.591,2.571,2.933,2.933,0,0,1-4.025.367",
    transform: "translate(-426.046 -179.386)",
    fill: "#6c7282"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11522",
    "data-name": "Group 11522",
    transform: "translate(299.318 49.595)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2106",
    "data-name": "Path 2106",
    d: "M432.2,169.646a2.941,2.941,0,0,0-4.03.364,2.693,2.693,0,0,0,.286,3.89l27.607,22.581a2.933,2.933,0,0,0,4.025-.367,2.694,2.694,0,0,0-.281-3.888Z",
    transform: "translate(-427.476 -169.012)",
    fill: "#bdcbe9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11525",
    "data-name": "Group 11525",
    transform: "translate(269.18 91.606)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11524",
    "data-name": "Group 11524",
    transform: "translate(0)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11523",
    "data-name": "Group 11523",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2107",
    "data-name": "Path 2107",
    d: "M452.865,186.777l3.382,11.684.028.1-3.382-11.687-.028-.1",
    transform: "translate(-452.865 -186.777)",
    fill: "#1e3169"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2108",
    "data-name": "Path 2108",
    d: "M452.256,186.818l3.382,11.687a7.954,7.954,0,0,0,1.44,2.708l-3.384-11.687a7.926,7.926,0,0,1-1.438-2.708",
    transform: "translate(-452.228 -186.721)",
    fill: "#1d2f65"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2109",
    "data-name": "Path 2109",
    d: "M451.823,187.963l3.384,11.687a8.23,8.23,0,0,0,1.024,1.048l-3.382-11.687a7.941,7.941,0,0,1-1.026-1.048",
    transform: "translate(-450.357 -185.158)",
    fill: "#1c2e61"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11526",
    "data-name": "Group 11526",
    transform: "translate(326.846 88.514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2111",
    "data-name": "Path 2111",
    d: "M427.519,188.083l3.383,11.685,2.3-2.613-3.383-11.685Z",
    transform: "translate(-427.519 -185.469)",
    fill: "#22387d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11529",
    "data-name": "Group 11529",
    transform: "translate(329.147 85.952)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11528",
    "data-name": "Group 11528",
    transform: "translate(0)",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11527",
    "data-name": "Group 11527",
    transform: "translate(0 -0.001)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2112",
    "data-name": "Path 2112",
    d: "M423.145,186.948l3.382,11.687a7.546,7.546,0,0,1,10.344-.932l-3.382-11.687a7.546,7.546,0,0,0-10.344.932",
    transform: "translate(-423.145 -184.386)",
    fill: "#233a81"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11532",
    "data-name": "Group 11532",
    transform: "translate(329.792 86.779)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11531",
    "data-name": "Group 11531",
    transform: "translate(0)",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11530",
    "data-name": "Group 11530",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2114",
    "data-name": "Path 2114",
    d: "M423.382,187l3.382,11.684a6.663,6.663,0,0,1,9.138-.821l-3.382-11.687a6.665,6.665,0,0,0-9.137.823",
    transform: "translate(-423.382 -184.736)",
    fill: "#1c2e61"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11533",
    "data-name": "Group 11533",
    transform: "translate(327.493 89.043)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2116",
    "data-name": "Path 2116",
    d: "M427.246,188.306l3.383,11.685,2.3-2.613-3.383-11.685Z",
    transform: "translate(-427.246 -185.693)",
    fill: "#1b2c5f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11536",
    "data-name": "Group 11536",
    transform: "translate(325.055 91.126)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11535",
    "data-name": "Group 11535",
    transform: "translate(0)",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11534",
    "data-name": "Group 11534",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2117",
    "data-name": "Path 2117",
    d: "M428.761,193.169l3.384,11.687a7.008,7.008,0,0,1,1.521-6.6l-3.384-11.687a7.015,7.015,0,0,0-1.521,6.6",
    transform: "translate(-428.491 -186.574)",
    fill: "#233a81"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11539",
    "data-name": "Group 11539",
    transform: "translate(325.91 91.656)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11538",
    "data-name": "Group 11538",
    transform: "translate(0)",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11537",
    "data-name": "Group 11537",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2119",
    "data-name": "Path 2119",
    d: "M428.456,192.622l3.384,11.684a6.19,6.19,0,0,1,1.343-5.824L429.8,186.8a6.19,6.19,0,0,0-1.346,5.824",
    transform: "translate(-428.218 -186.798)",
    fill: "#1c2e61"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11542",
    "data-name": "Group 11542",
    transform: "translate(335.02 94.161)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11541",
    "data-name": "Group 11541",
    transform: "translate(0)",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11540",
    "data-name": "Group 11540",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2121",
    "data-name": "Path 2121",
    d: "M423.14,191.423l3.384,11.684a2.727,2.727,0,0,1,.594-2.566,2.938,2.938,0,0,1,4.03-.362l-3.382-11.687a2.938,2.938,0,0,0-4.03.364,2.726,2.726,0,0,0-.6,2.566",
    transform: "translate(-423.035 -187.857)",
    fill: "#233a81"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11545",
    "data-name": "Group 11545",
    transform: "translate(326.148 97.481)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11544",
    "data-name": "Group 11544",
    transform: "translate(0)",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11543",
    "data-name": "Group 11543",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2123",
    "data-name": "Path 2123",
    d: "M428.777,189.261l3.384,11.684.021.071L428.8,189.332l-.021-.071",
    transform: "translate(-428.777 -189.261)",
    fill: "#253d8a"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2124",
    "data-name": "Path 2124",
    d: "M428.317,189.291l3.384,11.684a6.006,6.006,0,0,0,1.088,2.05l-3.382-11.684a6.012,6.012,0,0,1-1.09-2.05",
    transform: "translate(-428.296 -189.22)",
    fill: "#243c86"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2125",
    "data-name": "Path 2125",
    d: "M427.945,190.158l3.382,11.684a6.058,6.058,0,0,0,.88.88l-3.382-11.684a6.312,6.312,0,0,1-.88-.88",
    transform: "translate(-426.834 -188.037)",
    fill: "#233a81"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11548",
    "data-name": "Group 11548",
    transform: "translate(325.325 97.722)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11547",
    "data-name": "Group 11547",
    transform: "translate(0)",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11546",
    "data-name": "Group 11546",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2127",
    "data-name": "Path 2127",
    d: "M429.124,189.363l3.384,11.687.024.078-3.384-11.684-.024-.08",
    transform: "translate(-429.124 -189.363)",
    fill: "#1e3169"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2128",
    "data-name": "Path 2128",
    d: "M428.6,189.4l3.384,11.684a6.765,6.765,0,0,0,1.234,2.322l-3.384-11.687a6.8,6.8,0,0,1-1.234-2.32",
    transform: "translate(-428.578 -189.317)",
    fill: "#1d2f65"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2129",
    "data-name": "Path 2129",
    d: "M428.182,190.378l3.384,11.687a7.059,7.059,0,0,0,.993,1l-3.382-11.684a6.842,6.842,0,0,1-1-1",
    transform: "translate(-426.924 -187.978)",
    fill: "#1c2e61"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11551",
    "data-name": "Group 11551",
    transform: "translate(335.125 97.727)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11550",
    "data-name": "Group 11550",
    transform: "translate(0)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11549",
    "data-name": "Group 11549",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2131",
    "data-name": "Path 2131",
    d: "M424.986,189.365l3.384,11.684.009.031L425,189.4l-.009-.031",
    transform: "translate(-424.986 -189.365)",
    fill: "#4a5d8b"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2132",
    "data-name": "Path 2132",
    d: "M424.783,189.378l3.384,11.684a2.636,2.636,0,0,0,.48.906l-3.382-11.687a2.651,2.651,0,0,1-.482-.9",
    transform: "translate(-424.774 -189.347)",
    fill: "#485a86"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2133",
    "data-name": "Path 2133",
    d: "M424.618,189.76,428,201.447a2.768,2.768,0,0,0,.39.39l-3.382-11.687a2.648,2.648,0,0,1-.39-.39",
    transform: "translate(-424.126 -188.826)",
    fill: "#455781"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11552",
    "data-name": "Group 11552",
    transform: "translate(197.935 150.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2135",
    "data-name": "Path 2135",
    d: "M482.767,212.361l3.383,11.685.561-.638-3.383-11.685Z",
    transform: "translate(-482.767 -211.724)",
    fill: "#7e7e7e"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11553",
    "data-name": "Group 11553",
    transform: "translate(339.49 87.583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2136",
    "data-name": "Path 2136",
    d: "M412.448,185.075l3.383,11.685,25.3,20.692-3.383-11.685Z",
    transform: "translate(-412.448 -185.075)",
    fill: "#233a81"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11554",
    "data-name": "Group 11554",
    transform: "translate(338.929 88.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2137",
    "data-name": "Path 2137",
    d: "M412.685,185.345l3.383,11.686,25.3,20.692-3.383-11.685Z",
    transform: "translate(-412.685 -185.345)",
    fill: "#1c2e62"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11555",
    "data-name": "Group 11555",
    transform: "translate(339.75 94.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2138",
    "data-name": "Path 2138",
    d: "M416.836,188.126l3.383,11.685L434.878,211.8,431.5,200.117Z",
    transform: "translate(-416.836 -188.126)",
    fill: "#233a81"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11558",
    "data-name": "Group 11558",
    transform: "translate(354.41 106.788)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11557",
    "data-name": "Group 11557",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11556",
    "data-name": "Group 11556",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2139",
    "data-name": "Path 2139",
    d: "M416.672,193.2l3.382,11.684a2.737,2.737,0,0,1,.388.39l-3.382-11.687a2.735,2.735,0,0,0-.388-.388",
    transform: "translate(-416.672 -193.197)",
    fill: "#233a81"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2140",
    "data-name": "Path 2140",
    d: "M416.469,193.361l3.382,11.687a2.607,2.607,0,0,1,.48.9l-3.382-11.687a2.632,2.632,0,0,0-.48-.9",
    transform: "translate(-416.081 -192.973)",
    fill: "#243c86"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2141",
    "data-name": "Path 2141",
    d: "M416.465,193.743l3.382,11.687.009.031-3.382-11.687-.009-.031",
    transform: "translate(-415.597 -192.452)",
    fill: "#253d8a"
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11559",
    "data-name": "Group 11559",
    transform: "translate(336.006 99.052)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2143",
    "data-name": "Path 2143",
    d: "M418.419,189.925l3.383,11.685L436.461,213.6l-3.383-11.685Z",
    transform: "translate(-418.419 -189.925)",
    fill: "#455781"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11562",
    "data-name": "Group 11562",
    transform: "translate(350.666 108.11)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11561",
    "data-name": "Group 11561",
    transform: "translate(0)",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11560",
    "data-name": "Group 11560",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2144",
    "data-name": "Path 2144",
    d: "M416.42,196.688l3.382,11.684a2.934,2.934,0,0,0,4.03-.362,2.727,2.727,0,0,0,.591-2.568l-3.382-11.687a2.732,2.732,0,0,1-.594,2.571,2.933,2.933,0,0,1-4.027.362",
    transform: "translate(-416.42 -193.756)",
    fill: "#455781"
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11563",
    "data-name": "Group 11563",
    transform: "translate(364.225 108.274)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2146",
    "data-name": "Path 2146",
    d: "M412.448,194.463l3.383,11.685.561-.638-3.383-11.686Z",
    transform: "translate(-412.448 -193.825)",
    fill: "#1b2c5f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11566",
    "data-name": "Group 11566",
    transform: "translate(269.957 137.119)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11565",
    "data-name": "Group 11565",
    transform: "translate(0)",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11564",
    "data-name": "Group 11564",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2147",
    "data-name": "Path 2147",
    d: "M448.943,212.81l3.384,11.684a5.192,5.192,0,0,1,1.13-4.888,5.588,5.588,0,0,1,7.667-.686l-3.382-11.684a5.589,5.589,0,0,0-7.669.686,5.2,5.2,0,0,0-1.13,4.888",
    transform: "translate(-448.743 -206.023)",
    fill: "#828282"
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11567",
    "data-name": "Group 11567",
    transform: "translate(328.139 100.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2149",
    "data-name": "Path 2149",
    d: "M417.248,190.53l3.383,11.685,25.3,20.692-3.383-11.685Z",
    transform: "translate(-417.248 -190.53)",
    fill: "#233a81"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11568",
    "data-name": "Group 11568",
    transform: "translate(353.436 108.912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2150",
    "data-name": "Path 2150",
    d: "M412.685,206.356l3.383,11.685,10.79-12.261L423.474,194.1Z",
    transform: "translate(-412.685 -194.095)",
    fill: "#22387d"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11569",
    "data-name": "Group 11569",
    transform: "translate(352.874 121.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2151",
    "data-name": "Path 2151",
    d: "M417.247,199.918,420.63,211.6l.561-.638-3.383-11.685Z",
    transform: "translate(-417.247 -199.28)",
    fill: "#1b2c5f"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11570",
    "data-name": "Group 11570",
    transform: "translate(354.082 109.441)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2152",
    "data-name": "Path 2152",
    d: "M412.412,206.58l3.383,11.685L426.584,206,423.2,194.319Z",
    transform: "translate(-412.412 -194.319)",
    fill: "#1b2c5f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11573",
    "data-name": "Group 11573",
    transform: "translate(270.157 143.906)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11572",
    "data-name": "Group 11572",
    transform: "translate(0)",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11571",
    "data-name": "Group 11571",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2153",
    "data-name": "Path 2153",
    d: "M452.456,208.893l3.382,11.684.019.059-3.384-11.684-.016-.059",
    transform: "translate(-452.456 -208.893)",
    fill: "#56668b"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2154",
    "data-name": "Path 2154",
    d: "M452.069,208.918l3.384,11.684a5.026,5.026,0,0,0,.915,1.722l-3.384-11.684a5.071,5.071,0,0,1-.915-1.722",
    transform: "translate(-452.052 -208.859)",
    fill: "#546286"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2155",
    "data-name": "Path 2155",
    d: "M451.756,209.646l3.384,11.685a5.114,5.114,0,0,0,.74.743L452.5,210.386a5.361,5.361,0,0,1-.742-.74",
    transform: "translate(-450.824 -207.865)",
    fill: "#515f82"
  }))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11574",
    "data-name": "Group 11574",
    transform: "translate(354.082 121.702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2157",
    "data-name": "Path 2157",
    d: "M406.459,199.5l3.383,11.685,24.867,20.341-3.383-11.686Z",
    transform: "translate(-406.459 -199.504)",
    fill: "#1c2e62"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11575",
    "data-name": "Group 11575",
    transform: "translate(352.875 121.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2158",
    "data-name": "Path 2158",
    d: "M416.754,199.55l3.383,11.685,1.728,1.413-3.383-11.685Z",
    transform: "translate(-416.754 -199.55)",
    fill: "#1c2e62"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11576",
    "data-name": "Group 11576",
    transform: "translate(327.579 101.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2159",
    "data-name": "Path 2159",
    d: "M416.754,190.8l3.383,11.685,27.024,22.105L443.778,212.9Z",
    transform: "translate(-416.754 -190.8)",
    fill: "#1c2e62"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11579",
    "data-name": "Group 11579",
    transform: "translate(260.691 153.02)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11578",
    "data-name": "Group 11578",
    transform: "translate(0)",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11577",
    "data-name": "Group 11577",
    transform: "translate(-0.697 -1)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2160",
    "data-name": "Path 2160",
    d: "M454.869,215.89l3.382,11.684a2.732,2.732,0,0,1,.594-2.568,2.935,2.935,0,0,1,4.027-.362l-3.382-11.684a2.939,2.939,0,0,0-4.03.362,2.729,2.729,0,0,0-.591,2.568",
    transform: "translate(-454.763 -212.324)",
    fill: "#828282"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11582",
    "data-name": "Group 11582",
    transform: "translate(259.994 152.02)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11581",
    "data-name": "Group 11581",
    transform: "translate(0)",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11580",
    "data-name": "Group 11580",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2162",
    "data-name": "Path 2162",
    d: "M454.869,215.89l3.382,11.684a2.732,2.732,0,0,1,.594-2.568,2.935,2.935,0,0,1,4.027-.362l-3.382-11.684a2.939,2.939,0,0,0-4.03.362,2.729,2.729,0,0,0-.591,2.568",
    transform: "translate(-454.763 -212.324)",
    fill: "#828282"
  }))))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11583",
    "data-name": "Group 11583",
    transform: "translate(352.236 53.604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2164",
    "data-name": "Path 2164",
    d: "M388.551,170.707l3.383,11.685L461,238.884,457.613,227.2Z",
    transform: "translate(-388.551 -170.707)",
    fill: "#6c7282"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11586",
    "data-name": "Group 11586",
    transform: "translate(260.097 155.586)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11585",
    "data-name": "Group 11585",
    transform: "translate(0)",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11584",
    "data-name": "Group 11584",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2165",
    "data-name": "Path 2165",
    d: "M456.713,213.832l3.384,11.684.009.033-3.384-11.687-.009-.031",
    transform: "translate(-456.713 -213.832)",
    fill: "#747b8c"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2166",
    "data-name": "Path 2166",
    d: "M456.51,213.845l3.384,11.687a2.609,2.609,0,0,0,.48.9l-3.382-11.684a2.686,2.686,0,0,1-.483-.906",
    transform: "translate(-456.501 -213.814)",
    fill: "#6f7687"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2167",
    "data-name": "Path 2167",
    d: "M456.346,214.228l3.382,11.684a2.727,2.727,0,0,0,.388.388l-3.382-11.684a2.609,2.609,0,0,1-.388-.388",
    transform: "translate(-455.854 -213.292)",
    fill: "#6c7282"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11589",
    "data-name": "Group 11589",
    transform: "translate(421.298 110.097)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11588",
    "data-name": "Group 11588",
    transform: "translate(0)",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11587",
    "data-name": "Group 11587",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2169",
    "data-name": "Path 2169",
    d: "M388.275,194.6l3.382,11.684a4.481,4.481,0,0,1,.653.653l-3.382-11.684a4.6,4.6,0,0,0-.653-.653",
    transform: "translate(-388.275 -194.596)",
    fill: "#6c7282"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2170",
    "data-name": "Path 2170",
    d: "M387.934,194.872l3.382,11.684a4.475,4.475,0,0,1,.806,1.516l-3.384-11.684a4.406,4.406,0,0,0-.8-1.516",
    transform: "translate(-387.281 -194.219)",
    fill: "#6f7687"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2171",
    "data-name": "Path 2171",
    d: "M387.928,195.513l3.384,11.684.014.052-3.382-11.684-.017-.052",
    transform: "translate(-386.471 -193.344)",
    fill: "#747b8c"
  }))))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11590",
    "data-name": "Group 11590",
    transform: "translate(345.967 60.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2173",
    "data-name": "Path 2173",
    d: "M391.2,173.72l3.383,11.685L463.647,241.9l-3.383-11.685Z",
    transform: "translate(-391.202 -173.72)",
    fill: "#3e4963"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11593",
    "data-name": "Group 11593",
    transform: "translate(415.029 112.317)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11592",
    "data-name": "Group 11592",
    transform: "translate(0)",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11591",
    "data-name": "Group 11591",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2174",
    "data-name": "Path 2174",
    d: "M387.853,200.437l3.382,11.687a4.922,4.922,0,0,0,6.751-.608,4.567,4.567,0,0,0,.991-4.3L395.6,195.535a4.57,4.57,0,0,1-.991,4.294,4.919,4.919,0,0,1-6.751.608",
    transform: "translate(-387.853 -195.535)",
    fill: "#3e4962"
  }))))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11594",
    "data-name": "Group 11594",
    transform: "translate(344.322 52.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2176",
    "data-name": "Path 2176",
    d: "M397.2,171.321a4.911,4.911,0,0,0-6.74.608,4.505,4.505,0,0,0,.473,6.517l69.062,56.49a4.919,4.919,0,0,0,6.751-.608,4.509,4.509,0,0,0-.482-6.515Z",
    transform: "translate(-389.284 -170.257)",
    fill: "#6a7ead"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11595",
    "data-name": "Group 11595",
    transform: "translate(364.786 108.274)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2177",
    "data-name": "Path 2177",
    d: "M401.659,193.825l3.383,11.685,25.513,20.87L427.172,214.7Z",
    transform: "translate(-401.659 -193.825)",
    fill: "#233a81"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11596",
    "data-name": "Group 11596",
    transform: "translate(364.872 109.441)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2178",
    "data-name": "Path 2178",
    d: "M401.9,194.319,405.279,206l24.867,20.34-3.383-11.685Z",
    transform: "translate(-401.896 -194.319)",
    fill: "#1c2e62"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11599",
    "data-name": "Group 11599",
    transform: "translate(390.301 129.143)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11598",
    "data-name": "Group 11598",
    transform: "translate(0)",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11597",
    "data-name": "Group 11597",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2179",
    "data-name": "Path 2179",
    d: "M401.238,202.65l3.382,11.687a6.943,6.943,0,0,1,1,1l-3.384-11.684a7.08,7.08,0,0,0-.993-1",
    transform: "translate(-401.238 -202.65)",
    fill: "#233a81"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2180",
    "data-name": "Path 2180",
    d: "M400.716,203.072l3.384,11.684a6.815,6.815,0,0,1,1.234,2.32l-3.384-11.685a6.754,6.754,0,0,0-1.234-2.32",
    transform: "translate(-399.723 -202.074)",
    fill: "#243c86"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2181",
    "data-name": "Path 2181",
    d: "M400.706,204.053l3.384,11.684.024.08-3.384-11.684-.024-.08",
    transform: "translate(-398.478 -200.735)",
    fill: "#253d8a"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11602",
    "data-name": "Group 11602",
    transform: "translate(389.738 129.781)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11601",
    "data-name": "Group 11601",
    transform: "translate(0)",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11600",
    "data-name": "Group 11600",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2183",
    "data-name": "Path 2183",
    d: "M401.524,202.92l3.384,11.687a6.069,6.069,0,0,1,.88.88L402.4,203.8a6.065,6.065,0,0,0-.88-.88",
    transform: "translate(-401.524 -202.92)",
    fill: "#1c2e61"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2184",
    "data-name": "Path 2184",
    d: "M401.063,203.292l3.384,11.687a5.971,5.971,0,0,1,1.09,2.05l-3.384-11.687a6.013,6.013,0,0,0-1.09-2.05",
    transform: "translate(-400.183 -202.412)",
    fill: "#1d2f65"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2185",
    "data-name": "Path 2185",
    d: "M401.054,204.159l3.384,11.687.021.069-3.384-11.685-.021-.071",
    transform: "translate(-399.084 -201.229)",
    fill: "#1e3169"
  }))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11603",
    "data-name": "Group 11603",
    transform: "translate(146.849 208.657)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2187",
    "data-name": "Path 2187",
    d: "M504.37,236.912l3.383,11.685.561-.638-3.383-11.685Z",
    transform: "translate(-504.37 -236.274)",
    fill: "#7e7e7e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11606",
    "data-name": "Group 11606",
    transform: "translate(390.386 132.782)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11605",
    "data-name": "Group 11605",
    transform: "translate(0)",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11604",
    "data-name": "Group 11604",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2188",
    "data-name": "Path 2188",
    d: "M400.953,210.013l3.382,11.687a6.2,6.2,0,0,0,1.346-5.824L402.3,204.189a6.193,6.193,0,0,1-1.343,5.825",
    transform: "translate(-400.953 -204.189)",
    fill: "#1c2e61"
  }))))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11607",
    "data-name": "Group 11607",
    transform: "translate(354.602 123.224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2190",
    "data-name": "Path 2190",
    d: "M406.7,200.147l3.383,11.685,23.786,19.456L430.481,219.6Z",
    transform: "translate(-406.696 -200.147)",
    fill: "#1c2e62"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11610",
    "data-name": "Group 11610",
    transform: "translate(391.031 132.541)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11609",
    "data-name": "Group 11609",
    transform: "translate(0)",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11608",
    "data-name": "Group 11608",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2191",
    "data-name": "Path 2191",
    d: "M400.592,210.682l3.384,11.684a7.014,7.014,0,0,0,1.521-6.6l-3.384-11.684a7.009,7.009,0,0,1-1.521,6.6",
    transform: "translate(-400.592 -204.087)",
    fill: "#1c2e61"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11613",
    "data-name": "Group 11613",
    transform: "translate(401.965 133.559)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11612",
    "data-name": "Group 11612",
    transform: "translate(0)",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11611",
    "data-name": "Group 11611",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2193",
    "data-name": "Path 2193",
    d: "M394.832,208.082l3.384,11.684a2.724,2.724,0,0,1,.591-2.566,2.946,2.946,0,0,1,4.03-.364l-3.382-11.684a2.943,2.943,0,0,0-4.03.362,2.73,2.73,0,0,0-.594,2.568",
    transform: "translate(-394.727 -204.518)",
    fill: "#233a81"
  }))))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11614",
    "data-name": "Group 11614",
    transform: "translate(388.086 138.607)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2195",
    "data-name": "Path 2195",
    d: "M401.623,209.265l3.383,11.685,2.3-2.613-3.383-11.685Z",
    transform: "translate(-401.623 -206.652)",
    fill: "#1b2c5f"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11615",
    "data-name": "Group 11615",
    transform: "translate(388.732 139.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2196",
    "data-name": "Path 2196",
    d: "M401.349,209.489l3.383,11.685,2.3-2.613-3.383-11.685Z",
    transform: "translate(-401.349 -206.876)",
    fill: "#1b2c5f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11618",
    "data-name": "Group 11618",
    transform: "translate(378.949 142.043)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11617",
    "data-name": "Group 11617",
    transform: "translate(0)",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11616",
    "data-name": "Group 11616",
    transform: "translate(0 -0.823)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2197",
    "data-name": "Path 2197",
    d: "M402.595,208.58l3.382,11.687a6.665,6.665,0,0,0,9.138-.823l-3.382-11.687a6.665,6.665,0,0,1-9.138.823",
    transform: "translate(-402.595 -207.757)",
    fill: "#1c2e61"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11621",
    "data-name": "Group 11621",
    transform: "translate(383.651 141.22)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11620",
    "data-name": "Group 11620",
    transform: "translate(0)",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11619",
    "data-name": "Group 11619",
    transform: "translate(-4.701)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2199",
    "data-name": "Path 2199",
    d: "M402.595,208.58l3.382,11.687a6.665,6.665,0,0,0,9.138-.823l-3.382-11.687a6.665,6.665,0,0,1-9.138.823",
    transform: "translate(-402.595 -207.757)",
    fill: "#1c2e61"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11624",
    "data-name": "Group 11624",
    transform: "translate(402.07 137.124)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11623",
    "data-name": "Group 11623",
    transform: "translate(0)",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11622",
    "data-name": "Group 11622",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2201",
    "data-name": "Path 2201",
    d: "M396.677,206.025l3.384,11.684.01.033-3.384-11.687-.009-.031",
    transform: "translate(-396.677 -206.025)",
    fill: "#747b8c"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2202",
    "data-name": "Path 2202",
    d: "M396.474,206.038l3.384,11.687a2.609,2.609,0,0,0,.48.9l-3.382-11.684a2.686,2.686,0,0,1-.483-.906",
    transform: "translate(-396.465 -206.007)",
    fill: "#6f7687"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2203",
    "data-name": "Path 2203",
    d: "M396.31,206.421l3.382,11.684a2.74,2.74,0,0,0,.388.388L396.7,206.809a2.612,2.612,0,0,1-.388-.388",
    transform: "translate(-395.818 -205.484)",
    fill: "#6c7282"
  }))))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11625",
    "data-name": "Group 11625",
    transform: "translate(352.875 108.274)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2205",
    "data-name": "Path 2205",
    d: "M439.447,214.694l-25.514-20.869-.56.639-10.791,12.261-.56.638,1.726,1.412,23.787,19.458a7.546,7.546,0,0,0,10.344-.932l2.3-2.613A6.918,6.918,0,0,0,439.447,214.694Zm-36.219-7.44,10.791-12.261,24.866,20.34a6.108,6.108,0,0,1,.648,8.825l-2.3,2.613a6.665,6.665,0,0,1-9.138.823l-24.868-20.34",
    transform: "translate(-402.022 -193.825)",
    fill: "#2d4bac"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11626",
    "data-name": "Group 11626",
    transform: "translate(354.081 109.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2206",
    "data-name": "Path 2206",
    d: "M413.174,194.319l-10.79,12.261,24.868,20.34a6.665,6.665,0,0,0,9.138-.823l2.3-2.613a6.108,6.108,0,0,0-.648-8.825Z",
    transform: "translate(-402.384 -194.319)",
    fill: "#2d4bac"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11629",
    "data-name": "Group 11629",
    transform: "translate(378.389 141.75)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11628",
    "data-name": "Group 11628",
    transform: "translate(0)",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11627",
    "data-name": "Group 11627",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2207",
    "data-name": "Path 2207",
    d: "M402.322,208.913,405.7,220.6a7.546,7.546,0,0,0,10.344-.932l-3.382-11.684a7.546,7.546,0,0,1-10.344.932",
    transform: "translate(-402.322 -207.981)",
    fill: "#1c2e61"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11632",
    "data-name": "Group 11632",
    transform: "translate(218.87 195.175)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11631",
    "data-name": "Group 11631",
    transform: "translate(0)",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11630",
    "data-name": "Group 11630",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2209",
    "data-name": "Path 2209",
    d: "M470.546,237.36l3.384,11.685a5.2,5.2,0,0,1,1.13-4.888,5.588,5.588,0,0,1,7.667-.686l-3.382-11.684a5.586,5.586,0,0,0-7.667.686,5.192,5.192,0,0,0-1.133,4.888",
    transform: "translate(-470.346 -230.573)",
    fill: "#828282"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11635",
    "data-name": "Group 11635",
    transform: "translate(219.07 201.962)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11634",
    "data-name": "Group 11634",
    transform: "translate(0)",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11633",
    "data-name": "Group 11633",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    "data-name": "Path 2211",
    d: "M474.059,233.443l3.384,11.685.017.059L474.078,233.5l-.019-.059",
    transform: "translate(-474.059 -233.443)",
    fill: "#56668b"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2212",
    "data-name": "Path 2212",
    d: "M473.672,233.468l3.382,11.684a5.027,5.027,0,0,0,.915,1.722l-3.382-11.684a5.014,5.014,0,0,1-.915-1.722",
    transform: "translate(-473.653 -233.409)",
    fill: "#546286"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2213",
    "data-name": "Path 2213",
    d: "M473.359,234.2l3.382,11.684a5.235,5.235,0,0,0,.74.743L474.1,234.936a5.22,5.22,0,0,1-.74-.74",
    transform: "translate(-472.425 -232.415)",
    fill: "#515f82"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11638",
    "data-name": "Group 11638",
    transform: "translate(277.901 186.052)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11637",
    "data-name": "Group 11637",
    transform: "translate(0)",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11636",
    "data-name": "Group 11636",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2215",
    "data-name": "Path 2215",
    d: "M447.3,230.276l3.382,11.684a2.721,2.721,0,0,1,.6-2.566,2.928,2.928,0,0,1,4.023-.357l-3.382-11.684a2.931,2.931,0,0,0-4.025.357,2.724,2.724,0,0,0-.594,2.566",
    transform: "translate(-447.192 -226.715)",
    fill: "#828282"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11641",
    "data-name": "Group 11641",
    transform: "translate(278.006 189.613)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11640",
    "data-name": "Group 11640",
    transform: "translate(0)",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11639",
    "data-name": "Group 11639",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2217",
    "data-name": "Path 2217",
    d: "M449.141,228.221l3.382,11.684.009.031-3.384-11.684-.007-.031",
    transform: "translate(-449.141 -228.221)",
    fill: "#747b8c"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    "data-name": "Path 2218",
    d: "M448.938,228.234l3.384,11.684a2.6,2.6,0,0,0,.48.9l-3.382-11.684a2.653,2.653,0,0,1-.482-.9",
    transform: "translate(-448.931 -228.203)",
    fill: "#6f7687"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M448.773,228.616l3.382,11.684a2.664,2.664,0,0,0,.39.393l-3.382-11.687a2.646,2.646,0,0,1-.39-.39",
    transform: "translate(-448.284 -227.682)",
    fill: "#6c7282"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11644",
    "data-name": "Group 11644",
    transform: "translate(208.907 210.076)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11643",
    "data-name": "Group 11643",
    transform: "translate(0)",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11642",
    "data-name": "Group 11642",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2221",
    "data-name": "Path 2221",
    d: "M476.471,240.44l3.382,11.684a2.726,2.726,0,0,1,.594-2.566,2.936,2.936,0,0,1,4.027-.364l-3.382-11.684a2.939,2.939,0,0,0-4.03.362,2.729,2.729,0,0,0-.591,2.568",
    transform: "translate(-476.366 -236.874)",
    fill: "#828282"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11647",
    "data-name": "Group 11647",
    transform: "translate(209.011 213.642)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11646",
    "data-name": "Group 11646",
    transform: "translate(0)",
    clipPath: "url(#clip-path-44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11645",
    "data-name": "Group 11645",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    "data-name": "Path 2223",
    d: "M478.316,238.382l3.384,11.687.009.031-3.384-11.687-.009-.031",
    transform: "translate(-478.316 -238.382)",
    fill: "#747b8c"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    d: "M478.113,238.395l3.384,11.687a2.608,2.608,0,0,0,.48.9L478.6,239.3a2.685,2.685,0,0,1-.482-.906",
    transform: "translate(-478.104 -238.364)",
    fill: "#6f7687"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    "data-name": "Path 2225",
    d: "M477.949,238.778l3.382,11.684a2.728,2.728,0,0,0,.388.388l-3.382-11.684a2.613,2.613,0,0,1-.388-.388",
    transform: "translate(-477.457 -237.842)",
    fill: "#6c7282"
  }))))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11648",
    "data-name": "Group 11648",
    transform: "translate(278.955 138.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    "data-name": "Path 2227",
    d: "M426.531,206.536l3.383,11.686,52.527,42.966L479.058,249.5Z",
    transform: "translate(-426.531 -206.536)",
    fill: "#828282"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11651",
    "data-name": "Group 11651",
    transform: "translate(331.483 181.298)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11650",
    "data-name": "Group 11650",
    transform: "translate(0)",
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11649",
    "data-name": "Group 11649",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    "data-name": "Path 2228",
    d: "M426.217,224.7l3.382,11.684a5.246,5.246,0,0,1,.743.743l-3.384-11.684a5.1,5.1,0,0,0-.74-.743",
    transform: "translate(-426.217 -224.705)",
    fill: "#828282"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2229",
    "data-name": "Path 2229",
    d: "M425.83,225.019l3.384,11.684a5.069,5.069,0,0,1,.915,1.722l-3.384-11.685a5.007,5.007,0,0,0-.915-1.722",
    transform: "translate(-425.09 -224.276)",
    fill: "#878787"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    "data-name": "Path 2230",
    d: "M425.823,225.747l3.384,11.684.017.059-3.382-11.684-.019-.059",
    transform: "translate(-424.168 -223.283)",
    fill: "#8c8c8c"
  }))))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11652",
    "data-name": "Group 11652",
    transform: "translate(406.692 134.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2232",
    "data-name": "Path 2232",
    d: "M383.053,204.786l3.383,11.685,27.607,22.582-3.383-11.685Z",
    transform: "translate(-383.053 -204.786)",
    fill: "#233a81"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11653",
    "data-name": "Group 11653",
    transform: "translate(271.831 146.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2233",
    "data-name": "Path 2233",
    d: "M429.544,209.959l3.383,11.685,52.527,42.966-3.383-11.685Z",
    transform: "translate(-429.544 -209.959)",
    fill: "#515f82"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11656",
    "data-name": "Group 11656",
    transform: "translate(434.3 156.775)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11655",
    "data-name": "Group 11655",
    transform: "translate(0)",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11654",
    "data-name": "Group 11654",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2234",
    "data-name": "Path 2234",
    d: "M382.89,214.335l3.382,11.684a2.6,2.6,0,0,1,.385.388l-3.382-11.687a2.821,2.821,0,0,0-.385-.385",
    transform: "translate(-382.89 -214.335)",
    fill: "#233a81"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2235",
    "data-name": "Path 2235",
    d: "M382.688,214.5l3.382,11.687a2.6,2.6,0,0,1,.478.9L383.166,215.4a2.65,2.65,0,0,0-.478-.9",
    transform: "translate(-382.303 -214.113)",
    fill: "#243c86"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2236",
    "data-name": "Path 2236",
    d: "M382.684,214.879l3.382,11.684.009.033-3.382-11.687-.009-.031",
    transform: "translate(-381.821 -213.593)",
    fill: "#253d8a"
  }))))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11657",
    "data-name": "Group 11657",
    transform: "translate(402.949 138.448)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2238",
    "data-name": "Path 2238",
    d: "M384.636,206.585l3.383,11.685,27.607,22.582-3.383-11.685Z",
    transform: "translate(-384.636 -206.585)",
    fill: "#6c7282"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11660",
    "data-name": "Group 11660",
    transform: "translate(324.358 183.822)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11659",
    "data-name": "Group 11659",
    transform: "translate(0)",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11658",
    "data-name": "Group 11658",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2239",
    "data-name": "Path 2239",
    d: "M425.738,231.346l3.382,11.684a5.59,5.59,0,0,0,7.672-.691,5.192,5.192,0,0,0,1.128-4.883l-3.382-11.684a5.193,5.193,0,0,1-1.128,4.881,5.591,5.591,0,0,1-7.671.693",
    transform: "translate(-425.738 -225.772)",
    fill: "#515f82"
  }))))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11661",
    "data-name": "Group 11661",
    transform: "translate(269.957 137.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2241",
    "data-name": "Path 2241",
    d: "M436.166,207.236a5.586,5.586,0,0,0-7.667.686,5.123,5.123,0,0,0,.544,7.409L481.57,258.3a5.591,5.591,0,0,0,7.671-.693,5.121,5.121,0,0,0-.549-7.4Z",
    transform: "translate(-427.169 -206.023)",
    fill: "#8ca6e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11664",
    "data-name": "Group 11664",
    transform: "translate(430.556 158.093)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11663",
    "data-name": "Group 11663",
    transform: "translate(0)",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11662",
    "data-name": "Group 11662",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2242",
    "data-name": "Path 2242",
    d: "M382.639,217.829l3.382,11.687a2.93,2.93,0,0,0,4.022-.369,2.723,2.723,0,0,0,.594-2.568l-3.382-11.687a2.733,2.733,0,0,1-.594,2.571,2.93,2.93,0,0,1-4.023.367",
    transform: "translate(-382.639 -214.892)",
    fill: "#6c7282"
  }))))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11665",
    "data-name": "Group 11665",
    transform: "translate(264.72 152.656)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    "data-name": "Path 2244",
    d: "M431.325,212.593l3.383,11.685,55.426,45.337-3.383-11.686Z",
    transform: "translate(-431.325 -212.593)",
    fill: "#828282"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11668",
    "data-name": "Group 11668",
    transform: "translate(320.146 197.991)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11667",
    "data-name": "Group 11667",
    transform: "translate(0)",
    clipPath: "url(#clip-path-49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11666",
    "data-name": "Group 11666",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    "data-name": "Path 2245",
    d: "M431.16,231.764l3.382,11.687a2.646,2.646,0,0,1,.39.39l-3.382-11.685a2.657,2.657,0,0,0-.39-.392",
    transform: "translate(-431.16 -231.764)",
    fill: "#828282"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    "data-name": "Path 2246",
    d: "M430.956,231.93l3.382,11.684a2.7,2.7,0,0,1,.483.9l-3.384-11.684a2.609,2.609,0,0,0-.48-.9",
    transform: "translate(-430.566 -231.537)",
    fill: "#878787"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    "data-name": "Path 2247",
    d: "M430.953,232.312,434.337,244l.007.031-3.382-11.684-.009-.031",
    transform: "translate(-430.083 -231.016)",
    fill: "#8c8c8c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11671",
    "data-name": "Group 11671",
    transform: "translate(391.979 178.576)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11670",
    "data-name": "Group 11670",
    transform: "translate(0)",
    clipPath: "url(#clip-path-50)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11669",
    "data-name": "Group 11669",
    transform: "translate(-2.542 -0.256)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2249",
    "data-name": "Path 2249",
    d: "M398.294,228.261l3.382,11.684a4.749,4.749,0,0,1,1.2-3.091,5.063,5.063,0,0,1,6.948-.627,4.738,4.738,0,0,1,.672.672l-3.384-11.687a4.587,4.587,0,0,0-.669-.669,5.066,5.066,0,0,0-6.95.624,4.735,4.735,0,0,0-1.2,3.093",
    transform: "translate(-398.294 -223.446)",
    fill: "#1c2e61"
  }))))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11672",
    "data-name": "Group 11672",
    transform: "translate(285.938 79.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2251",
    "data-name": "Path 2251",
    d: "M395.732,181.656l3.383,11.685,118.377,96.831-3.383-11.685Z",
    transform: "translate(-395.732 -181.656)",
    fill: "#233a81"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11673",
    "data-name": "Group 11673",
    transform: "translate(285.376 80.135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2252",
    "data-name": "Path 2252",
    d: "M395.97,181.926l3.383,11.685L517.73,290.442l-3.383-11.685Z",
    transform: "translate(-395.97 -181.926)",
    fill: "#1c2e62"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11676",
    "data-name": "Group 11676",
    transform: "translate(392.869 178.32)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11675",
    "data-name": "Group 11675",
    transform: "translate(0)",
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11674",
    "data-name": "Group 11674",
    transform: "translate(-3.431 0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2253",
    "data-name": "Path 2253",
    d: "M398.294,228.261l3.382,11.684a4.749,4.749,0,0,1,1.2-3.091,5.063,5.063,0,0,1,6.948-.627,4.738,4.738,0,0,1,.672.672l-3.384-11.687a4.587,4.587,0,0,0-.669-.669,5.066,5.066,0,0,0-6.95.624,4.735,4.735,0,0,0-1.2,3.093",
    transform: "translate(-398.294 -223.446)",
    fill: "#1c2e61"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11679",
    "data-name": "Group 11679",
    transform: "translate(395.661 178.461)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11678",
    "data-name": "Group 11678",
    transform: "translate(0)",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11677",
    "data-name": "Group 11677",
    transform: "translate(-6.224 -0.14)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2255",
    "data-name": "Path 2255",
    d: "M398.294,228.261l3.382,11.684a4.749,4.749,0,0,1,1.2-3.091,5.063,5.063,0,0,1,6.948-.627,4.738,4.738,0,0,1,.672.672l-3.384-11.687a4.587,4.587,0,0,0-.669-.669,5.066,5.066,0,0,0-6.95.624,4.735,4.735,0,0,0-1.2,3.093",
    transform: "translate(-398.294 -223.446)",
    fill: "#1c2e61"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11682",
    "data-name": "Group 11682",
    transform: "translate(396.118 178.595)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11681",
    "data-name": "Group 11681",
    transform: "translate(0)",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11680",
    "data-name": "Group 11680",
    transform: "translate(-6.681 -0.275)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2257",
    "data-name": "Path 2257",
    d: "M398.294,228.261l3.382,11.684a4.749,4.749,0,0,1,1.2-3.091,5.063,5.063,0,0,1,6.948-.627,4.738,4.738,0,0,1,.672.672l-3.384-11.687a4.587,4.587,0,0,0-.669-.669,5.066,5.066,0,0,0-6.95.624,4.735,4.735,0,0,0-1.2,3.093",
    transform: "translate(-398.294 -223.446)",
    fill: "#1c2e61"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11685",
    "data-name": "Group 11685",
    transform: "translate(390.133 178.964)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11684",
    "data-name": "Group 11684",
    transform: "translate(0)",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11683",
    "data-name": "Group 11683",
    transform: "translate(-0.695 -0.644)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2259",
    "data-name": "Path 2259",
    d: "M398.294,228.261l3.382,11.684a4.749,4.749,0,0,1,1.2-3.091,5.063,5.063,0,0,1,6.948-.627,4.738,4.738,0,0,1,.672.672l-3.384-11.687a4.587,4.587,0,0,0-.669-.669,5.066,5.066,0,0,0-6.95.624,4.735,4.735,0,0,0-1.2,3.093",
    transform: "translate(-398.294 -223.446)",
    fill: "#1c2e61"
  }))))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11686",
    "data-name": "Group 11686",
    transform: "translate(260.976 156.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2261",
    "data-name": "Path 2261",
    d: "M432.908,214.392l3.383,11.685,55.426,45.337-3.383-11.685Z",
    transform: "translate(-432.908 -214.392)",
    fill: "#6c7282"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11687",
    "data-name": "Group 11687",
    transform: "translate(96.135 266.289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2262",
    "data-name": "Path 2262",
    d: "M525.815,261.283l3.383,11.686.561-.638-3.383-11.685Z",
    transform: "translate(-525.815 -260.645)",
    fill: "#7e7e7e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11690",
    "data-name": "Group 11690",
    transform: "translate(396.579 178.785)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11689",
    "data-name": "Group 11689",
    transform: "translate(0)",
    clipPath: "url(#clip-path-55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11688",
    "data-name": "Group 11688",
    transform: "translate(-7.142 -0.464)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2263",
    "data-name": "Path 2263",
    d: "M398.294,228.261l3.382,11.684a4.749,4.749,0,0,1,1.2-3.091,5.063,5.063,0,0,1,6.948-.627,4.738,4.738,0,0,1,.672.672l-3.384-11.687a4.587,4.587,0,0,0-.669-.669,5.066,5.066,0,0,0-6.95.624,4.735,4.735,0,0,0-1.2,3.093",
    transform: "translate(-398.294 -223.446)",
    fill: "#1c2e61"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11693",
    "data-name": "Group 11693",
    transform: "translate(383.475 183.81)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11692",
    "data-name": "Group 11692",
    transform: "translate(0)",
    clipPath: "url(#clip-path-56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11691",
    "data-name": "Group 11691",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2265",
    "data-name": "Path 2265",
    d: "M404.386,226.23l3.384,11.684a.424.424,0,0,1,.378-.461l-3.382-11.687a.426.426,0,0,0-.381.464",
    transform: "translate(-404.383 -225.767)",
    fill: "#1c2e61"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11696",
    "data-name": "Group 11696",
    transform: "translate(383.478 184.273)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11695",
    "data-name": "Group 11695",
    transform: "translate(0)",
    clipPath: "url(#clip-path-57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11694",
    "data-name": "Group 11694",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2267",
    "data-name": "Path 2267",
    d: "M404.551,226.032l3.384,11.684a.316.316,0,0,1-.014-.069l-3.384-11.684c0,.024.009.045.014.069",
    transform: "translate(-404.537 -225.963)",
    fill: "#1c2e61"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11699",
    "data-name": "Group 11699",
    transform: "translate(316.403 199.318)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11698",
    "data-name": "Group 11698",
    transform: "translate(0)",
    clipPath: "url(#clip-path-58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11697",
    "data-name": "Group 11697",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2269",
    "data-name": "Path 2269",
    d: "M430.909,235.255l3.382,11.684a2.936,2.936,0,0,0,4.03-.362,2.73,2.73,0,0,0,.594-2.568l-3.382-11.685a2.727,2.727,0,0,1-.6,2.566,2.933,2.933,0,0,1-4.027.364",
    transform: "translate(-430.909 -232.325)",
    fill: "#6c7282"
  }))))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11700",
    "data-name": "Group 11700",
    transform: "translate(259.994 152.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2271",
    "data-name": "Path 2271",
    d: "M437.065,212.96a2.939,2.939,0,0,0-4.03.362,2.7,2.7,0,0,0,.286,3.892l55.426,45.338a2.933,2.933,0,0,0,4.027-.364,2.69,2.69,0,0,0-.284-3.892Z",
    transform: "translate(-432.339 -212.324)",
    fill: "#bdcbe9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11703",
    "data-name": "Group 11703",
    transform: "translate(383.492 184.342)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11702",
    "data-name": "Group 11702",
    transform: "translate(0)",
    clipPath: "url(#clip-path-59)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11701",
    "data-name": "Group 11701",
    transform: "translate(0 -0.001)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2272",
    "data-name": "Path 2272",
    d: "M404.537,225.991l3.383,11.685v.005L404.538,226v0",
    transform: "translate(-404.537 -225.991)",
    fill: "#8c8c8c"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2273",
    "data-name": "Path 2273",
    d: "M404.506,225.994l3.382,11.684a.4.4,0,0,0,.073.137l-3.382-11.684a.385.385,0,0,1-.073-.137",
    transform: "translate(-404.504 -225.988)",
    fill: "#878787"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2274",
    "data-name": "Path 2274",
    d: "M404.345,226.052l3.382,11.684a.433.433,0,0,0,.057.057.419.419,0,0,0,.324.09L404.726,226.2a.416.416,0,0,1-.324-.09.323.323,0,0,1-.057-.057",
    transform: "translate(-404.27 -225.909)",
    fill: "#828282"
  }))))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11704",
    "data-name": "Group 11704",
    transform: "translate(383.859 183.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2276",
    "data-name": "Path 2276",
    d: "M402.024,226.157l3.383,11.685,5.578-.675L407.6,225.482Z",
    transform: "translate(-402.024 -225.482)",
    fill: "#1b2c5f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11707",
    "data-name": "Group 11707",
    transform: "translate(389.437 180.728)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11706",
    "data-name": "Group 11706",
    transform: "translate(0)",
    clipPath: "url(#clip-path-60)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11705",
    "data-name": "Group 11705",
    transform: "translate(0 -2.408)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2277",
    "data-name": "Path 2277",
    d: "M398.294,228.261l3.382,11.684a4.749,4.749,0,0,1,1.2-3.091,5.063,5.063,0,0,1,6.948-.627,4.738,4.738,0,0,1,.672.672l-3.384-11.687a4.587,4.587,0,0,0-.669-.669,5.066,5.066,0,0,0-6.95.624,4.735,4.735,0,0,0-1.2,3.093",
    transform: "translate(-398.294 -223.446)",
    fill: "#1c2e61"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11710",
    "data-name": "Group 11710",
    transform: "translate(397.858 179.66)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11709",
    "data-name": "Group 11709",
    transform: "translate(0)",
    clipPath: "url(#clip-path-61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11708",
    "data-name": "Group 11708",
    transform: "translate(-8.421 -1.339)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2279",
    "data-name": "Path 2279",
    d: "M398.294,228.261l3.382,11.684a4.749,4.749,0,0,1,1.2-3.091,5.063,5.063,0,0,1,6.948-.627,4.738,4.738,0,0,1,.672.672l-3.384-11.687a4.587,4.587,0,0,0-.669-.669,5.066,5.066,0,0,0-6.95.624,4.735,4.735,0,0,0-1.2,3.093",
    transform: "translate(-398.294 -223.446)",
    fill: "#1c2e61"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2280",
    "data-name": "Path 2280",
    d: "M397.943,224.193l3.384,11.687a4.581,4.581,0,0,1,.83,1.558l-3.384-11.684a4.551,4.551,0,0,0-.83-1.561",
    transform: "translate(-389.125 -222.426)",
    fill: "#1d2f65"
  }))))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11711",
    "data-name": "Group 11711",
    transform: "translate(389.437 183.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2282",
    "data-name": "Path 2282",
    d: "M401.747,225.528l3.383,11.685.654-.079L402.4,225.449Z",
    transform: "translate(-401.747 -225.449)",
    fill: "#7e7e7e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11714",
    "data-name": "Group 11714",
    transform: "translate(390.09 183.053)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11713",
    "data-name": "Group 11713",
    transform: "translate(0)",
    clipPath: "url(#clip-path-62)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11712",
    "data-name": "Group 11712",
    transform: "translate(0 0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2283",
    "data-name": "Path 2283",
    d: "M401.659,225.452l3.384,11.684a.437.437,0,0,1,.208.024l-3.384-11.687a.4.4,0,0,0-.208-.021",
    transform: "translate(-401.659 -225.447)",
    fill: "#828282"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11717",
    "data-name": "Group 11717",
    transform: "translate(398.601 180.575)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11716",
    "data-name": "Group 11716",
    transform: "translate(0)",
    clipPath: "url(#clip-path-63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11715",
    "data-name": "Group 11715",
    transform: "translate(-0.345 -0.487)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2285",
    "data-name": "Path 2285",
    d: "M397.943,224.193l3.384,11.687a4.581,4.581,0,0,1,.83,1.558l-3.384-11.684a4.551,4.551,0,0,0-.83-1.561",
    transform: "translate(-397.943 -224.193)",
    fill: "#1d2f65"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11720",
    "data-name": "Group 11720",
    transform: "translate(390.298 179.153)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11719",
    "data-name": "Group 11719",
    transform: "translate(0)",
    clipPath: "url(#clip-path-64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11718",
    "data-name": "Group 11718",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2287",
    "data-name": "Path 2287",
    d: "M398.581,227.724l3.384,11.687a3.913,3.913,0,0,1,.991-2.5,4.183,4.183,0,0,1,5.735-.52,3.708,3.708,0,0,1,.553.553l-3.382-11.684a3.967,3.967,0,0,0-.553-.556,4.186,4.186,0,0,0-5.737.523,3.924,3.924,0,0,0-.991,2.5",
    transform: "translate(-398.581 -223.798)",
    fill: "#828282"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2288",
    "data-name": "Path 2288",
    d: "M398.291,224.414l3.382,11.684a3.734,3.734,0,0,1,.686,1.289L398.974,225.7a3.78,3.78,0,0,0-.684-1.286",
    transform: "translate(-391.01 -222.957)",
    fill: "#878787"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2289",
    "data-name": "Path 2289",
    d: "M398.286,224.958l3.384,11.687.012.043L398.3,225l-.014-.045",
    transform: "translate(-390.321 -222.214)",
    fill: "#8c8c8c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11723",
    "data-name": "Group 11723",
    transform: "translate(390.298 183.079)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11722",
    "data-name": "Group 11722",
    transform: "translate(0)",
    clipPath: "url(#clip-path-65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11721",
    "data-name": "Group 11721",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2291",
    "data-name": "Path 2291",
    d: "M401.586,225.458l3.384,11.687a.38.38,0,0,1,.116.066.329.329,0,0,1,.057.057l-3.382-11.684a.481.481,0,0,0-.059-.059.467.467,0,0,0-.116-.066",
    transform: "translate(-401.586 -225.458)",
    fill: "#1c2e61"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2292",
    "data-name": "Path 2292",
    d: "M401.555,225.511l3.382,11.684a.386.386,0,0,1,.073.137l-3.382-11.684a.406.406,0,0,0-.073-.137",
    transform: "translate(-401.38 -225.386)",
    fill: "#1d2f65"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2293",
    "data-name": "Path 2293",
    d: "M401.554,225.569l3.383,11.685v0l-3.382-11.684v0",
    transform: "translate(-401.307 -225.306)",
    fill: "#1e3169"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11726",
    "data-name": "Group 11726",
    transform: "translate(390.546 183.346)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11725",
    "data-name": "Group 11725",
    transform: "translate(0)",
    clipPath: "url(#clip-path-66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11724",
    "data-name": "Group 11724",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2295",
    "data-name": "Path 2295",
    d: "M401.563,225.64l3.382,11.684a.554.554,0,0,0-.012-.066l-3.384-11.687a.325.325,0,0,1,.014.069",
    transform: "translate(-401.549 -225.571)",
    fill: "#828282"
  }))))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11727",
    "data-name": "Group 11727",
    transform: "translate(383.949 183.959)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2297",
    "data-name": "Path 2297",
    d: "M402,226.5l3.383,11.685,5.553-.672-3.383-11.685Z",
    transform: "translate(-401.996 -225.83)",
    fill: "#7e7e7e"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11728",
    "data-name": "Group 11728",
    transform: "translate(389.502 183.876)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2298",
    "data-name": "Path 2298",
    d: "M401.709,225.877l3.383,11.685.679-.082L402.388,225.8Z",
    transform: "translate(-401.709 -225.795)",
    fill: "#7e7e7e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11731",
    "data-name": "Group 11731",
    transform: "translate(390.18 183.415)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11730",
    "data-name": "Group 11730",
    transform: "translate(0)",
    clipPath: "url(#clip-path-67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11729",
    "data-name": "Group 11729",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2299",
    "data-name": "Path 2299",
    d: "M401.548,226.061l3.384,11.687a.441.441,0,0,0,.173-.059.431.431,0,0,0,.206-.4L401.929,225.6a.432.432,0,0,1-.381.461",
    transform: "translate(-401.548 -225.6)",
    fill: "#828282"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11734",
    "data-name": "Group 11734",
    transform: "translate(390.353 183.817)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11733",
    "data-name": "Group 11733",
    transform: "translate(0)",
    clipPath: "url(#clip-path-68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11732",
    "data-name": "Group 11732",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2301",
    "data-name": "Path 2301",
    d: "M401.69,226.184l3.384,11.687a3.6,3.6,0,0,1-.094-.414L401.6,225.77a4.061,4.061,0,0,0,.095.414",
    transform: "translate(-401.596 -225.77)",
    fill: "#828282"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11737",
    "data-name": "Group 11737",
    transform: "translate(390.447 181.942)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11736",
    "data-name": "Group 11736",
    transform: "translate(0)",
    clipPath: "url(#clip-path-69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11735",
    "data-name": "Group 11735",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2303",
    "data-name": "Path 2303",
    d: "M401.591,225.945l3.384,11.687.012.045-3.382-11.684-.014-.047",
    transform: "translate(-401.591 -223.656)",
    fill: "#1e3169"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2304",
    "data-name": "Path 2304",
    d: "M401.3,225.965l3.382,11.684a3.768,3.768,0,0,0,.683,1.284l-3.382-11.687a3.718,3.718,0,0,1-.683-1.282",
    transform: "translate(-401.288 -223.629)",
    fill: "#1d2f65"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2305",
    "data-name": "Path 2305",
    d: "M398.222,228.6l3.382,11.687a3.791,3.791,0,0,0,.551.551,4.184,4.184,0,0,0,5.737-.511,3.889,3.889,0,0,0,.844-3.661l-3.382-11.684a3.885,3.885,0,0,1-.844,3.658,4.187,4.187,0,0,1-5.737.513,3.8,3.8,0,0,1-.551-.553",
    transform: "translate(-397.525 -224.977)",
    fill: "#1c2e61"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11740",
    "data-name": "Group 11740",
    transform: "translate(389.617 181.703)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11739",
    "data-name": "Group 11739",
    transform: "translate(0)",
    clipPath: "url(#clip-path-70)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11738",
    "data-name": "Group 11738",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2307",
    "data-name": "Path 2307",
    d: "M401.94,226.044l3.384,11.687.016.054L401.957,226.1l-.017-.057",
    transform: "translate(-401.94 -223.282)",
    fill: "#8c8c8c"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    d: "M401.59,226.068l3.384,11.685a4.536,4.536,0,0,0,.828,1.558l-3.382-11.687a4.567,4.567,0,0,1-.83-1.556",
    transform: "translate(-401.573 -223.249)",
    fill: "#878787"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    d: "M397.86,229.251l3.382,11.687a4.746,4.746,0,0,0,.672.672,5.061,5.061,0,0,0,6.943-.622,4.7,4.7,0,0,0,1.024-4.427L406.5,224.876a4.705,4.705,0,0,1-1.024,4.427,5.064,5.064,0,0,1-6.945.62,4.606,4.606,0,0,1-.669-.672",
    transform: "translate(-397.014 -224.876)",
    fill: "#828282"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11743",
    "data-name": "Group 11743",
    transform: "translate(398.665 180.679)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11742",
    "data-name": "Group 11742",
    transform: "translate(0)",
    clipPath: "url(#clip-path-71)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11741",
    "data-name": "Group 11741",
    transform: "translate(-0.409 -0.591)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2311",
    "data-name": "Path 2311",
    d: "M397.943,224.193l3.384,11.687a4.581,4.581,0,0,1,.83,1.558l-3.384-11.684a4.551,4.551,0,0,0-.83-1.561",
    transform: "translate(-397.943 -224.193)",
    fill: "#1d2f65"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2312",
    "data-name": "Path 2312",
    d: "M397.937,224.853l3.384,11.685.014.054-3.382-11.684-.016-.054",
    transform: "translate(-397.107 -223.292)",
    fill: "#1e3169"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11746",
    "data-name": "Group 11746",
    transform: "translate(389.501 183.959)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11745",
    "data-name": "Group 11745",
    transform: "translate(0)",
    clipPath: "url(#clip-path-72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11744",
    "data-name": "Group 11744",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2314",
    "data-name": "Path 2314",
    d: "M402.063,226.336l3.384,11.687a4.125,4.125,0,0,1-.116-.508l-3.384-11.684c.031.17.069.341.116.506",
    transform: "translate(-401.947 -225.83)",
    fill: "#1c2e61"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11749",
    "data-name": "Group 11749",
    transform: "translate(404.314 176.328)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11748",
    "data-name": "Group 11748",
    transform: "translate(0)",
    clipPath: "url(#clip-path-73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11747",
    "data-name": "Group 11747",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2316",
    "data-name": "Path 2316",
    d: "M395.24,222.6l3.384,11.687a8.08,8.08,0,0,1,1.163,1.164L396.4,223.769a8.22,8.22,0,0,0-1.164-1.166",
    transform: "translate(-395.24 -222.603)",
    fill: "#233a81"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2317",
    "data-name": "Path 2317",
    d: "M394.63,223.1l3.384,11.684a7.993,7.993,0,0,1,1.443,2.715l-3.382-11.684a7.96,7.96,0,0,0-1.445-2.715",
    transform: "translate(-393.467 -221.93)",
    fill: "#243c86"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2318",
    "data-name": "Path 2318",
    d: "M394.618,224.244,398,235.928l.028.095-3.384-11.687-.026-.092",
    transform: "translate(-392.01 -220.363)",
    fill: "#253d8a"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11752",
    "data-name": "Group 11752",
    transform: "translate(403.754 176.966)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11751",
    "data-name": "Group 11751",
    transform: "translate(0)",
    clipPath: "url(#clip-path-74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11750",
    "data-name": "Group 11750",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2320",
    "data-name": "Path 2320",
    d: "M395.526,222.873l3.382,11.684a7.467,7.467,0,0,1,1.05,1.05l-3.384-11.684a7.209,7.209,0,0,0-1.048-1.05",
    transform: "translate(-395.526 -222.873)",
    fill: "#1c2e61"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2321",
    "data-name": "Path 2321",
    d: "M394.977,223.317,398.361,235a7.167,7.167,0,0,1,1.3,2.445l-3.382-11.687a7.118,7.118,0,0,0-1.3-2.443",
    transform: "translate(-393.929 -222.267)",
    fill: "#1d2f65"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2322",
    "data-name": "Path 2322",
    d: "M394.966,224.35l3.382,11.687.026.083-3.384-11.684-.024-.085",
    transform: "translate(-392.618 -220.857)",
    fill: "#1e3169"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11755",
    "data-name": "Group 11755",
    transform: "translate(404.529 180.544)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11754",
    "data-name": "Group 11754",
    transform: "translate(0)",
    clipPath: "url(#clip-path-75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11753",
    "data-name": "Group 11753",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2324",
    "data-name": "Path 2324",
    d: "M394.846,231.32l3.382,11.687a7.372,7.372,0,0,0,1.6-6.936l-3.384-11.684a7.366,7.366,0,0,1-1.6,6.934",
    transform: "translate(-394.846 -224.386)",
    fill: "#1c2e61"
  }))))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11756",
    "data-name": "Group 11756",
    transform: "translate(269.717 78.416)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2326",
    "data-name": "Path 2326",
    d: "M411.936,182.918a7.936,7.936,0,0,0-10.885.977l-2.9,3.3a7.312,7.312,0,0,0,.655,10.422l116.343,99.142a7.807,7.807,0,0,0,5.642,1.793,7.971,7.971,0,0,0,5.363-2.677l4.935-5.609a7.277,7.277,0,0,0-.776-10.512Zm98.1,104.138a.426.426,0,0,1,.381-.464l5.578-.674a4.735,4.735,0,0,1,1.2-3.093,5.066,5.066,0,0,1,6.95-.624,4.641,4.641,0,0,1,.492,6.711,5.064,5.064,0,0,1-6.945.62,4.589,4.589,0,0,1-1.632-2.79l-5.553.672a.412.412,0,0,1-.471-.357",
    transform: "translate(-396.276 -181.199)",
    fill: "#2d4bac"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11757",
    "data-name": "Group 11757",
    transform: "translate(383.475 183.053)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2327",
    "data-name": "Path 2327",
    d: "M409.917,225.539a.467.467,0,0,0-.116-.066.4.4,0,0,0-.208-.021l-.653.078-5.578.674a.426.426,0,0,0-.381.464.412.412,0,0,0,.471.357l5.553-.672.679-.083a.432.432,0,0,0,.381-.461A.4.4,0,0,0,409.917,225.539Z",
    transform: "translate(-402.978 -225.447)",
    fill: "#e9e9e9"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11758",
    "data-name": "Group 11758",
    transform: "translate(282.624 186.689)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2328",
    "data-name": "Path 2328",
    d: "M435.52,226.984,438.9,238.67l27.6,22.577-3.383-11.685Z",
    transform: "translate(-435.52 -226.984)",
    fill: "#828282"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11761",
    "data-name": "Group 11761",
    transform: "translate(310.226 209.267)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11760",
    "data-name": "Group 11760",
    transform: "translate(0)",
    clipPath: "url(#clip-path-76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11759",
    "data-name": "Group 11759",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2329",
    "data-name": "Path 2329",
    d: "M435.355,236.532l3.382,11.684a2.761,2.761,0,0,1,.39.39l-3.382-11.684a2.649,2.649,0,0,0-.39-.39",
    transform: "translate(-435.355 -236.532)",
    fill: "#828282"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2330",
    "data-name": "Path 2330",
    d: "M435.151,236.7l3.382,11.684a2.686,2.686,0,0,1,.482.906L435.631,237.6a2.638,2.638,0,0,0-.48-.906",
    transform: "translate(-434.761 -236.307)",
    fill: "#878787"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2331",
    "data-name": "Path 2331",
    d: "M435.147,237.08l3.384,11.684.009.031-3.384-11.684-.009-.031",
    transform: "translate(-434.277 -235.784)",
    fill: "#8c8c8c"
  }))))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11762",
    "data-name": "Group 11762",
    transform: "translate(278.885 190.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2333",
    "data-name": "Path 2333",
    d: "M437.1,228.781l3.383,11.685,27.6,22.578L464.7,251.359Z",
    transform: "translate(-437.101 -228.781)",
    fill: "#6c7282"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11765",
    "data-name": "Group 11765",
    transform: "translate(405.175 180.3)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11764",
    "data-name": "Group 11764",
    transform: "translate(0)",
    clipPath: "url(#clip-path-77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11763",
    "data-name": "Group 11763",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2334",
    "data-name": "Path 2334",
    d: "M394.484,231.99l3.384,11.687a8.2,8.2,0,0,0,1.773-7.707l-3.384-11.687a8.185,8.185,0,0,1-1.774,7.707",
    transform: "translate(-394.484 -224.283)",
    fill: "#1c2e61"
  }))))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11766",
    "data-name": "Group 11766",
    transform: "translate(272.245 94.831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2336",
    "data-name": "Path 2336",
    d: "M402.382,188.141l3.383,11.685,116.345,99.141-3.383-11.686Z",
    transform: "translate(-402.382 -188.141)",
    fill: "#1c2e62"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11767",
    "data-name": "Group 11767",
    transform: "translate(399.595 187.479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2337",
    "data-name": "Path 2337",
    d: "M395.642,232.926l3.382,11.685L403.959,239l-3.383-11.685Z",
    transform: "translate(-395.642 -227.319)",
    fill: "#1b2c5f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11770",
    "data-name": "Group 11770",
    transform: "translate(388.588 193.087)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11769",
    "data-name": "Group 11769",
    transform: "translate(0)",
    clipPath: "url(#clip-path-78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11768",
    "data-name": "Group 11768",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2338",
    "data-name": "Path 2338",
    d: "M397.728,230.574l3.384,11.687a7.815,7.815,0,0,0,5.64,1.793,7.994,7.994,0,0,0,5.366-2.679l-3.384-11.684a7.971,7.971,0,0,1-5.363,2.677,7.807,7.807,0,0,1-5.642-1.793",
    transform: "translate(-397.728 -229.69)",
    fill: "#1c2e61"
  }))))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11771",
    "data-name": "Group 11771",
    transform: "translate(268.861 77.589)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2340",
    "data-name": "Path 2340",
    d: "M412.991,182.757a8.822,8.822,0,0,0-12.091,1.085l-2.9,3.3a8.116,8.116,0,0,0,.728,11.578l116.346,99.142a8.622,8.622,0,0,0,6.262,1.986,8.862,8.862,0,0,0,5.962-2.97l4.933-5.609a8.088,8.088,0,0,0-.861-11.68Zm-14.347,4.912,2.9-3.3a7.936,7.936,0,0,1,10.885-.977l118.377,96.831a7.277,7.277,0,0,1,.776,10.512l-4.935,5.609a7.971,7.971,0,0,1-5.363,2.677,7.765,7.765,0,0,1-5.6-1.757L399.3,198.09a7.312,7.312,0,0,1-.655-10.422",
    transform: "translate(-395.915 -180.849)",
    fill: "#2d4bac"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11772",
    "data-name": "Group 11772",
    transform: "translate(390.298 179.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2341",
    "data-name": "Path 2341",
    d: "M406.38,224.7a4.186,4.186,0,0,0-5.737.523,3.924,3.924,0,0,0-.991,2.5.467.467,0,0,1,.116.066.4.4,0,0,1,.147.27.426.426,0,0,1-.208.4,3.777,3.777,0,0,0,1.343,2.3,4.187,4.187,0,0,0,5.737-.513A3.838,3.838,0,0,0,406.38,224.7Z",
    transform: "translate(-399.653 -223.798)",
    fill: "#2d4bac"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11773",
    "data-name": "Group 11773",
    transform: "translate(389.437 178.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2342",
    "data-name": "Path 2342",
    d: "M406.879,225.18a4.186,4.186,0,0,0-5.737.523,3.925,3.925,0,0,0-.991,2.5.38.38,0,0,0-.208-.024l-.653.078a4.726,4.726,0,0,1,1.2-3.093,5.063,5.063,0,0,1,6.948-.624,4.641,4.641,0,0,1,.492,6.711,5.064,5.064,0,0,1-6.945.62,4.589,4.589,0,0,1-1.632-2.79l.679-.083a.418.418,0,0,0,.173-.059,3.777,3.777,0,0,0,1.343,2.3,4.187,4.187,0,0,0,5.737-.513A3.838,3.838,0,0,0,406.879,225.18Z",
    transform: "translate(-399.29 -223.446)",
    fill: "#e9e9e9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11776",
    "data-name": "Group 11776",
    transform: "translate(306.487 210.593)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11775",
    "data-name": "Group 11775",
    transform: "translate(0)",
    clipPath: "url(#clip-path-79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11774",
    "data-name": "Group 11774",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2343",
    "data-name": "Path 2343",
    d: "M435.1,240.016l3.382,11.684a2.933,2.933,0,0,0,4.03-.362,2.732,2.732,0,0,0,.591-2.561l-3.384-11.684a2.716,2.716,0,0,1-.591,2.559,2.931,2.931,0,0,1-4.027.364",
    transform: "translate(-435.103 -237.093)",
    fill: "#6c7282"
  }))))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11777",
    "data-name": "Group 11777",
    transform: "translate(271.673 95.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2345",
    "data-name": "Path 2345",
    d: "M402.624,188.406l3.383,11.685,116.345,99.141-3.383-11.686Z",
    transform: "translate(-402.624 -188.406)",
    fill: "#1c2e62"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11780",
    "data-name": "Group 11780",
    transform: "translate(344.166 199.302)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11779",
    "data-name": "Group 11779",
    transform: "translate(0)",
    clipPath: "url(#clip-path-80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11778",
    "data-name": "Group 11778",
    transform: "translate(-19.105 0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2346",
    "data-name": "Path 2346",
    d: "M415.612,257.985,419,269.67a19.625,19.625,0,0,1,4.273-18.471,21.131,21.131,0,0,1,29-2.613L448.889,236.9a21.134,21.134,0,0,0-29,2.611,19.629,19.629,0,0,0-4.273,18.474",
    transform: "translate(-414.855 -232.318)",
    fill: "#828282"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11783",
    "data-name": "Group 11783",
    transform: "translate(168.157 252.807)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11782",
    "data-name": "Group 11782",
    transform: "translate(0)",
    clipPath: "url(#clip-path-81)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11781",
    "data-name": "Group 11781",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2348",
    "data-name": "Path 2348",
    d: "M491.991,261.731l3.382,11.684a5.2,5.2,0,0,1,1.13-4.888,5.593,5.593,0,0,1,7.669-.686l-3.384-11.684a5.586,5.586,0,0,0-7.667.686,5.2,5.2,0,0,0-1.13,4.888",
    transform: "translate(-491.791 -254.944)",
    fill: "#828282"
  }))))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11784",
    "data-name": "Group 11784",
    transform: "translate(400.241 188.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2350",
    "data-name": "Path 2350",
    d: "M395.368,233.15l3.383,11.685,4.935-5.608L400.3,227.542Z",
    transform: "translate(-395.368 -227.542)",
    fill: "#1b2c5f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11787",
    "data-name": "Group 11787",
    transform: "translate(168.357 259.594)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11786",
    "data-name": "Group 11786",
    transform: "translate(0)",
    clipPath: "url(#clip-path-82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11785",
    "data-name": "Group 11785",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2351",
    "data-name": "Path 2351",
    d: "M495.5,257.814l3.382,11.684.019.059-3.384-11.685-.016-.059",
    transform: "translate(-495.504 -257.814)",
    fill: "#56668b"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2352",
    "data-name": "Path 2352",
    d: "M495.117,257.839l3.384,11.684a4.965,4.965,0,0,0,.915,1.721l-3.384-11.684a5.03,5.03,0,0,1-.915-1.722",
    transform: "translate(-495.1 -257.78)",
    fill: "#546286"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2353",
    "data-name": "Path 2353",
    d: "M494.8,258.567l3.384,11.684a5.1,5.1,0,0,0,.74.743l-3.382-11.687a5.248,5.248,0,0,1-.743-.74",
    transform: "translate(-493.872 -256.786)",
    fill: "#515f82"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11790",
    "data-name": "Group 11790",
    transform: "translate(388.018 193.617)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11789",
    "data-name": "Group 11789",
    clipPath: "url(#clip-path-83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11788",
    "data-name": "Group 11788",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2355",
    "data-name": "Path 2355",
    d: "M397.455,230.9l3.382,11.687a8.628,8.628,0,0,0,6.264,1.986,8.868,8.868,0,0,0,5.959-2.973l-3.382-11.684a8.862,8.862,0,0,1-5.962,2.97,8.622,8.622,0,0,1-6.262-1.986",
    transform: "translate(-397.455 -229.914)",
    fill: "#1c2e61"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11793",
    "data-name": "Group 11793",
    transform: "translate(226.814 244.107)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11792",
    "data-name": "Group 11792",
    transform: "translate(0)",
    clipPath: "url(#clip-path-84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11791",
    "data-name": "Group 11791",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2357",
    "data-name": "Path 2357",
    d: "M468.9,254.827l3.382,11.684a2.722,2.722,0,0,1,.6-2.566,2.928,2.928,0,0,1,4.022-.357L473.518,251.9a2.934,2.934,0,0,0-4.025.359,2.725,2.725,0,0,0-.594,2.566",
    transform: "translate(-468.795 -251.265)",
    fill: "#828282"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11796",
    "data-name": "Group 11796",
    transform: "translate(226.917 247.669)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11795",
    "data-name": "Group 11795",
    transform: "translate(0)",
    clipPath: "url(#clip-path-85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11794",
    "data-name": "Group 11794",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2359",
    "data-name": "Path 2359",
    d: "M470.744,252.771l3.384,11.684.009.031L470.753,252.8l-.01-.031",
    transform: "translate(-470.744 -252.771)",
    fill: "#747b8c"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2360",
    "data-name": "Path 2360",
    d: "M470.541,252.784l3.384,11.685a2.636,2.636,0,0,0,.48.906l-3.382-11.687a2.652,2.652,0,0,1-.482-.9",
    transform: "translate(-470.531 -252.753)",
    fill: "#6f7687"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2361",
    "data-name": "Path 2361",
    d: "M470.376,253.166l3.382,11.687a2.774,2.774,0,0,0,.39.39l-3.382-11.687a2.645,2.645,0,0,1-.39-.39",
    transform: "translate(-469.884 -252.232)",
    fill: "#6c7282"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11799",
    "data-name": "Group 11799",
    transform: "translate(158.195 267.708)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11798",
    "data-name": "Group 11798",
    transform: "translate(0)",
    clipPath: "url(#clip-path-86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11797",
    "data-name": "Group 11797",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2363",
    "data-name": "Path 2363",
    d: "M497.916,264.813,501.3,276.5a2.725,2.725,0,0,1,.589-2.568,2.939,2.939,0,0,1,4.03-.364l-3.382-11.684a2.938,2.938,0,0,0-4.03.362,2.737,2.737,0,0,0-.591,2.571",
    transform: "translate(-497.811 -261.245)",
    fill: "#828282"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11802",
    "data-name": "Group 11802",
    transform: "translate(158.3 271.276)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11801",
    "data-name": "Group 11801",
    clipPath: "url(#clip-path-87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11800",
    "data-name": "Group 11800",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2365",
    "data-name": "Path 2365",
    d: "M499.761,262.754l3.382,11.684.01.033-3.382-11.687-.009-.031",
    transform: "translate(-499.761 -262.754)",
    fill: "#747b8c"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2366",
    "data-name": "Path 2366",
    d: "M499.557,262.767l3.382,11.687a2.655,2.655,0,0,0,.482.9l-3.384-11.687a2.608,2.608,0,0,1-.48-.9",
    transform: "translate(-499.547 -262.736)",
    fill: "#6f7687"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2367",
    "data-name": "Path 2367",
    d: "M499.394,263.149l3.384,11.687a2.7,2.7,0,0,0,.386.385l-3.384-11.684a2.714,2.714,0,0,1-.385-.388",
    transform: "translate(-498.904 -262.215)",
    fill: "#6c7282"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11805",
    "data-name": "Group 11805",
    transform: "translate(359.095 203.885)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11804",
    "data-name": "Group 11804",
    clipPath: "url(#clip-path-88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11803",
    "data-name": "Group 11803",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2369",
    "data-name": "Path 2369",
    d: "M413.67,234.256l3.382,11.684a19.629,19.629,0,0,1,2.8,2.8l-3.384-11.684a19.608,19.608,0,0,0-2.8-2.8",
    transform: "translate(-413.67 -234.256)",
    fill: "#828282"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2370",
    "data-name": "Path 2370",
    d: "M412.208,235.442l3.384,11.684a19.028,19.028,0,0,1,3.457,6.5l-3.382-11.687a19,19,0,0,0-3.46-6.5",
    transform: "translate(-409.408 -232.637)",
    fill: "#878787"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2371",
    "data-name": "Path 2371",
    d: "M412.18,238.191l3.382,11.687c.024.073.045.149.066.222l-3.382-11.684c-.021-.076-.045-.149-.066-.225",
    transform: "translate(-405.92 -228.886)",
    fill: "#8c8c8c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11808",
    "data-name": "Group 11808",
    transform: "translate(325.061 199.389)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11807",
    "data-name": "Group 11807",
    transform: "translate(0)",
    clipPath: "url(#clip-path-89)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11806",
    "data-name": "Group 11806",
    transform: "translate(0 -0.087)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2373",
    "data-name": "Path 2373",
    d: "M415.612,257.985,419,269.67a19.625,19.625,0,0,1,4.273-18.471,21.131,21.131,0,0,1,29-2.613L448.889,236.9a21.134,21.134,0,0,0-29,2.611,19.629,19.629,0,0,0-4.273,18.474",
    transform: "translate(-414.855 -232.318)",
    fill: "#828282"
  }))))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11809",
    "data-name": "Group 11809",
    transform: "translate(227.869 196.388)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2375",
    "data-name": "Path 2375",
    d: "M448.134,231.086l3.383,11.685,52.527,42.966-3.383-11.685Z",
    transform: "translate(-448.134 -231.086)",
    fill: "#828282"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11812",
    "data-name": "Group 11812",
    transform: "translate(280.397 239.354)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11811",
    "data-name": "Group 11811",
    transform: "translate(0)",
    clipPath: "url(#clip-path-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11810",
    "data-name": "Group 11810",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2376",
    "data-name": "Path 2376",
    d: "M447.82,249.255l3.382,11.684a5.377,5.377,0,0,1,.742.742L448.56,250a5.1,5.1,0,0,0-.74-.742",
    transform: "translate(-447.82 -249.255)",
    fill: "#828282"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2377",
    "data-name": "Path 2377",
    d: "M447.433,249.569l3.384,11.685a5.075,5.075,0,0,1,.915,1.724l-3.384-11.687a4.986,4.986,0,0,0-.915-1.722",
    transform: "translate(-446.693 -248.826)",
    fill: "#878787"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2378",
    "data-name": "Path 2378",
    d: "M447.426,250.3l3.384,11.687.017.059-3.382-11.687-.019-.059",
    transform: "translate(-445.771 -247.833)",
    fill: "#8c8c8c"
  }))))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11813",
    "data-name": "Group 11813",
    transform: "translate(220.745 204.484)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2380",
    "data-name": "Path 2380",
    d: "M451.147,234.509l3.383,11.685,52.527,42.966-3.383-11.686Z",
    transform: "translate(-451.147 -234.509)",
    fill: "#515f82"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11814",
    "data-name": "Group 11814",
    transform: "translate(396.881 158.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2381",
    "data-name": "Path 2381",
    d: "M378.327,270.079l3.383,11.685L430.3,226.541l-3.383-11.685Z",
    transform: "translate(-378.327 -214.856)",
    fill: "#22387d"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11815",
    "data-name": "Group 11815",
    transform: "translate(249.386 92.582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2382",
    "data-name": "Path 2382",
    d: "M398.876,187.19l3.383,11.685L549.753,319.523l-3.383-11.685Z",
    transform: "translate(-398.876 -187.19)",
    fill: "#233a81"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11818",
    "data-name": "Group 11818",
    transform: "translate(273.272 241.877)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11817",
    "data-name": "Group 11817",
    transform: "translate(0)",
    clipPath: "url(#clip-path-91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11816",
    "data-name": "Group 11816",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2383",
    "data-name": "Path 2383",
    d: "M447.341,255.893l3.382,11.687a5.591,5.591,0,0,0,7.674-.69,5.19,5.19,0,0,0,1.126-4.883l-3.382-11.684a5.185,5.185,0,0,1-1.128,4.881,5.588,5.588,0,0,1-7.671.69",
    transform: "translate(-447.341 -250.322)",
    fill: "#515f82"
  }))))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11819",
    "data-name": "Group 11819",
    transform: "translate(51.008 283.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2385",
    "data-name": "Path 2385",
    d: "M532.758,300.987l3.383,11.686L565.41,279.41l-3.383-11.685Z",
    transform: "translate(-532.758 -267.725)",
    fill: "#686e7e"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11820",
    "data-name": "Group 11820",
    transform: "translate(213.634 210.711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2386",
    "data-name": "Path 2386",
    d: "M452.928,237.143l3.383,11.685,55.426,45.337-3.383-11.685Z",
    transform: "translate(-452.928 -237.143)",
    fill: "#828282"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11823",
    "data-name": "Group 11823",
    transform: "translate(269.06 256.049)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11822",
    "data-name": "Group 11822",
    transform: "translate(0)",
    clipPath: "url(#clip-path-92)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11821",
    "data-name": "Group 11821",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2387",
    "data-name": "Path 2387",
    d: "M452.763,256.315,456.145,268a2.758,2.758,0,0,1,.39.39l-3.382-11.684a2.65,2.65,0,0,0-.39-.39",
    transform: "translate(-452.763 -256.315)",
    fill: "#828282"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2388",
    "data-name": "Path 2388",
    d: "M452.559,256.48l3.381,11.684a2.7,2.7,0,0,1,.483.9l-3.384-11.684a2.608,2.608,0,0,0-.48-.9",
    transform: "translate(-452.169 -256.09)",
    fill: "#878787"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2389",
    "data-name": "Path 2389",
    d: "M452.555,256.862l3.384,11.684.009.033-3.384-11.687-.009-.031",
    transform: "translate(-451.685 -255.568)",
    fill: "#8c8c8c"
  }))))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11824",
    "data-name": "Group 11824",
    transform: "translate(209.89 214.966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2391",
    "data-name": "Path 2391",
    d: "M454.511,238.942l3.383,11.685,55.426,45.337-3.383-11.685Z",
    transform: "translate(-454.511 -238.942)",
    fill: "#6c7282"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11827",
    "data-name": "Group 11827",
    transform: "translate(92.109 308.009)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11826",
    "data-name": "Group 11826",
    transform: "translate(0)",
    clipPath: "url(#clip-path-93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11825",
    "data-name": "Group 11825",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2392",
    "data-name": "Path 2392",
    d: "M524.282,280.32,527.666,292a5.982,5.982,0,0,1,8.211-.733l-3.382-11.687a5.987,5.987,0,0,0-8.213.735",
    transform: "translate(-524.282 -278.287)",
    fill: "#515f82"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11830",
    "data-name": "Group 11830",
    transform: "translate(265.316 257.374)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11829",
    "data-name": "Group 11829",
    transform: "translate(0)",
    clipPath: "url(#clip-path-94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11828",
    "data-name": "Group 11828",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2394",
    "data-name": "Path 2394",
    d: "M452.512,259.8l3.382,11.684a2.934,2.934,0,0,0,4.03-.362,2.727,2.727,0,0,0,.594-2.566l-3.382-11.687a2.725,2.725,0,0,1-.6,2.566,2.931,2.931,0,0,1-4.027.364",
    transform: "translate(-452.512 -256.875)",
    fill: "#6c7282"
  }))))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11831",
    "data-name": "Group 11831",
    transform: "translate(208.907 210.076)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2396",
    "data-name": "Path 2396",
    d: "M458.668,237.51a2.939,2.939,0,0,0-4.03.362,2.7,2.7,0,0,0,.286,3.892L510.351,287.1a2.931,2.931,0,0,0,4.027-.364,2.687,2.687,0,0,0-.284-3.89Z",
    transform: "translate(-453.942 -236.874)",
    fill: "#bdcbe9"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11832",
    "data-name": "Group 11832",
    transform: "translate(86.27 310.043)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2397",
    "data-name": "Path 2397",
    d: "M527.754,285.784l3.383,11.685,5.841-6.637-3.383-11.685Z",
    transform: "translate(-527.754 -279.147)",
    fill: "#4e5b7e"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11833",
    "data-name": "Group 11833",
    transform: "translate(231.537 244.745)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2398",
    "data-name": "Path 2398",
    d: "M457.123,251.535l3.383,11.686,27.6,22.577-3.383-11.685Z",
    transform: "translate(-457.123 -251.535)",
    fill: "#828282"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11836",
    "data-name": "Group 11836",
    transform: "translate(325.817 213.415)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11835",
    "data-name": "Group 11835",
    transform: "translate(0)",
    clipPath: "url(#clip-path-95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11834",
    "data-name": "Group 11834",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2399",
    "data-name": "Path 2399",
    d: "M428.9,243.172l3.382,11.684c.024.076.045.149.066.225l-3.382-11.687c-.024-.073-.045-.149-.066-.222",
    transform: "translate(-428.899 -231.618)",
    fill: "#7e4131"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2400",
    "data-name": "Path 2400",
    d: "M427.435,243.266l3.382,11.687a19.083,19.083,0,0,0,3.462,6.508L430.9,249.774a19,19,0,0,1-3.462-6.508",
    transform: "translate(-427.369 -231.489)",
    fill: "#793e30"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2401",
    "data-name": "Path 2401",
    d: "M411.86,256.571l3.382,11.687a19.8,19.8,0,0,0,2.8,2.807,21.119,21.119,0,0,0,28.992-2.611,19.644,19.644,0,0,0,4.278-18.483l-3.382-11.684a19.645,19.645,0,0,1-4.278,18.481,21.122,21.122,0,0,1-28.995,2.611,19.527,19.527,0,0,1-2.8-2.807",
    transform: "translate(-408.332 -238.286)",
    fill: "#753d2e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11839",
    "data-name": "Group 11839",
    transform: "translate(259.139 267.322)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11838",
    "data-name": "Group 11838",
    transform: "translate(0)",
    clipPath: "url(#clip-path-96)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11837",
    "data-name": "Group 11837",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2403",
    "data-name": "Path 2403",
    d: "M456.958,261.082l3.382,11.684a2.666,2.666,0,0,1,.39.393l-3.382-11.687a2.643,2.643,0,0,0-.39-.39",
    transform: "translate(-456.958 -261.082)",
    fill: "#828282"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2404",
    "data-name": "Path 2404",
    d: "M456.754,261.247l3.382,11.687a2.655,2.655,0,0,1,.482.9l-3.384-11.684a2.639,2.639,0,0,0-.48-.906",
    transform: "translate(-456.364 -260.857)",
    fill: "#878787"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2405",
    "data-name": "Path 2405",
    d: "M456.75,261.63l3.384,11.684.009.031-3.384-11.684-.01-.031",
    transform: "translate(-455.88 -260.334)",
    fill: "#8c8c8c"
  }))))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11840",
    "data-name": "Group 11840",
    transform: "translate(227.798 248.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2407",
    "data-name": "Path 2407",
    d: "M458.7,253.331l3.383,11.685,27.6,22.578-3.383-11.685Z",
    transform: "translate(-458.704 -253.331)",
    fill: "#6c7282"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11841",
    "data-name": "Group 11841",
    transform: "translate(100.322 309.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2408",
    "data-name": "Path 2408",
    d: "M521.435,278.836l3.383,11.685,6.731,5.506-3.383-11.685Z",
    transform: "translate(-521.435 -278.836)",
    fill: "#515f82"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11844",
    "data-name": "Group 11844",
    transform: "translate(84.843 316.68)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11843",
    "data-name": "Group 11843",
    transform: "translate(0)",
    clipPath: "url(#clip-path-97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11842",
    "data-name": "Group 11842",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2409",
    "data-name": "Path 2409",
    d: "M530.438,287.187l3.384,11.687a5.565,5.565,0,0,1,1.211-5.236l-3.382-11.684a5.556,5.556,0,0,0-1.213,5.233",
    transform: "translate(-530.224 -281.954)",
    fill: "#515f82"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11847",
    "data-name": "Group 11847",
    transform: "translate(255.401 268.649)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11846",
    "data-name": "Group 11846",
    transform: "translate(0)",
    clipPath: "url(#clip-path-98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11845",
    "data-name": "Group 11845",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2411",
    "data-name": "Path 2411",
    d: "M456.706,264.566l3.382,11.684a2.934,2.934,0,0,0,4.03-.362,2.726,2.726,0,0,0,.591-2.561l-3.384-11.684a2.716,2.716,0,0,1-.591,2.559,2.931,2.931,0,0,1-4.027.364",
    transform: "translate(-456.706 -261.643)",
    fill: "#6c7282"
  }))))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11848",
    "data-name": "Group 11848",
    transform: "translate(226.812 244.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2413",
    "data-name": "Path 2413",
    d: "M462.862,251.9a2.934,2.934,0,0,0-4.025.359,2.685,2.685,0,0,0,.286,3.89l27.6,22.579a2.931,2.931,0,0,0,4.027-.364,2.686,2.686,0,0,0-.289-3.885Z",
    transform: "translate(-458.136 -251.265)",
    fill: "#bdcbe9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11851",
    "data-name": "Group 11851",
    transform: "translate(304.603 259.691)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11850",
    "data-name": "Group 11850",
    transform: "translate(0)",
    clipPath: "url(#clip-path-99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11849",
    "data-name": "Group 11849",
    transform: "translate(-30.629 -2.333)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2414",
    "data-name": "Path 2414",
    d: "M436.029,282.535l3.384,11.684a19.627,19.627,0,0,1,4.273-18.471,21.131,21.131,0,0,1,29-2.613,19.623,19.623,0,0,1,2.8,2.8l-3.384-11.684a19.726,19.726,0,0,0-2.8-2.8,21.134,21.134,0,0,0-29,2.611,19.63,19.63,0,0,0-4.273,18.474",
    transform: "translate(-435.273 -256.868)",
    fill: "#828282"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11854",
    "data-name": "Group 11854",
    transform: "translate(107.052 314.812)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11853",
    "data-name": "Group 11853",
    transform: "translate(0)",
    clipPath: "url(#clip-path-100)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11852",
    "data-name": "Group 11852",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2416",
    "data-name": "Path 2416",
    d: "M521.1,281.164l3.384,11.687a5.6,5.6,0,0,1,.792.795l-3.382-11.684a5.488,5.488,0,0,0-.794-.8",
    transform: "translate(-521.1 -281.164)",
    fill: "#515f82"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2417",
    "data-name": "Path 2417",
    d: "M520.685,281.5l3.382,11.684a5.356,5.356,0,0,1,.981,1.845l-3.382-11.684a5.373,5.373,0,0,0-.981-1.845",
    transform: "translate(-519.891 -280.704)",
    fill: "#546286"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2418",
    "data-name": "Path 2418",
    d: "M520.677,282.281l3.382,11.684.019.064L520.7,282.343l-.019-.062",
    transform: "translate(-518.901 -279.639)",
    fill: "#56668b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11857",
    "data-name": "Group 11857",
    transform: "translate(85.057 321.914)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11856",
    "data-name": "Group 11856",
    transform: "translate(0)",
    clipPath: "url(#clip-path-101)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11855",
    "data-name": "Group 11855",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2420",
    "data-name": "Path 2420",
    d: "M530.728,284.167l3.384,11.687.019.064-3.384-11.687-.019-.064",
    transform: "translate(-530.728 -284.167)",
    fill: "#747b8c"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2421",
    "data-name": "Path 2421",
    d: "M530.314,284.194l3.384,11.687a5.382,5.382,0,0,0,.979,1.842L531.3,286.039a5.419,5.419,0,0,1-.981-1.845",
    transform: "translate(-530.295 -284.13)",
    fill: "#6f7687"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2422",
    "data-name": "Path 2422",
    d: "M529.978,284.974l3.382,11.684a5.493,5.493,0,0,0,.795.795l-3.382-11.685a5.618,5.618,0,0,1-.795-.794",
    transform: "translate(-528.978 -283.066)",
    fill: "#6c7282"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11860",
    "data-name": "Group 11860",
    transform: "translate(304.837 259.814)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11859",
    "data-name": "Group 11859",
    transform: "translate(0)",
    clipPath: "url(#clip-path-102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11858",
    "data-name": "Group 11858",
    transform: "translate(-30.863 -2.456)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2424",
    "data-name": "Path 2424",
    d: "M436.029,282.535l3.384,11.684a19.627,19.627,0,0,1,4.273-18.471,21.131,21.131,0,0,1,29-2.613,19.623,19.623,0,0,1,2.8,2.8l-3.384-11.684a19.726,19.726,0,0,0-2.8-2.8,21.134,21.134,0,0,0-29,2.611,19.63,19.63,0,0,0-4.273,18.474",
    transform: "translate(-435.273 -256.868)",
    fill: "#828282"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11863",
    "data-name": "Group 11863",
    transform: "translate(107.639 317.515)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11862",
    "data-name": "Group 11862",
    transform: "translate(0)",
    clipPath: "url(#clip-path-103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11861",
    "data-name": "Group 11861",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2426",
    "data-name": "Path 2426",
    d: "M520.586,287.536l3.382,11.687a5.556,5.556,0,0,0,1.208-5.229l-3.382-11.687a5.555,5.555,0,0,1-1.208,5.229",
    transform: "translate(-520.586 -282.307)",
    fill: "#6c7282"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11866",
    "data-name": "Group 11866",
    transform: "translate(176.099 301.737)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11865",
    "data-name": "Group 11865",
    transform: "translate(0)",
    clipPath: "url(#clip-path-104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11864",
    "data-name": "Group 11864",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2428",
    "data-name": "Path 2428",
    d: "M490.343,279.2l3.384,11.684a2.727,2.727,0,0,1,.594-2.566,2.938,2.938,0,0,1,4.03-.362l-3.382-11.687a2.94,2.94,0,0,0-4.03.364,2.726,2.726,0,0,0-.6,2.566",
    transform: "translate(-490.238 -275.635)",
    fill: "#828282"
  }))))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11867",
    "data-name": "Group 11867",
    transform: "translate(86.851 324.616)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2430",
    "data-name": "Path 2430",
    d: "M527.132,285.31,530.514,297l6.731,5.506-3.383-11.685Z",
    transform: "translate(-527.132 -285.31)",
    fill: "#6c7282"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11870",
    "data-name": "Group 11870",
    transform: "translate(176.204 305.301)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11869",
    "data-name": "Group 11869",
    transform: "translate(0)",
    clipPath: "url(#clip-path-105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11868",
    "data-name": "Group 11868",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2431",
    "data-name": "Path 2431",
    d: "M492.19,277.142l3.384,11.684.007.031L492.2,277.173l-.009-.031",
    transform: "translate(-492.19 -277.142)",
    fill: "#747b8c"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2432",
    "data-name": "Path 2432",
    d: "M491.986,277.155l3.382,11.684a2.687,2.687,0,0,0,.482.906l-3.384-11.687a2.606,2.606,0,0,1-.48-.9",
    transform: "translate(-491.977 -277.124)",
    fill: "#6f7687"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2433",
    "data-name": "Path 2433",
    d: "M491.821,277.537l3.384,11.687a2.781,2.781,0,0,0,.39.39l-3.384-11.687a2.761,2.761,0,0,1-.39-.39",
    transform: "translate(-491.331 -276.603)",
    fill: "#6c7282"
  }))))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11871",
    "data-name": "Group 11871",
    transform: "translate(101.798 322.745)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2435",
    "data-name": "Path 2435",
    d: "M521.188,291.156l3.383,11.685,5.841-6.638-3.383-11.685Z",
    transform: "translate(-521.188 -284.518)",
    fill: "#686e7e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11874",
    "data-name": "Group 11874",
    transform: "translate(93.582 329.382)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11873",
    "data-name": "Group 11873",
    transform: "translate(0)",
    clipPath: "url(#clip-path-106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11872",
    "data-name": "Group 11872",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2436",
    "data-name": "Path 2436",
    d: "M523.657,288.065l3.382,11.684a5.985,5.985,0,0,0,8.218-.74l-3.384-11.684a5.982,5.982,0,0,1-8.215.74",
    transform: "translate(-523.657 -287.325)",
    fill: "#6c7282"
  }))))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11875",
    "data-name": "Group 11875",
    transform: "translate(84.844 308.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2438",
    "data-name": "Path 2438",
    d: "M537.495,279.585a5.987,5.987,0,0,0-8.213.735l-5.839,6.638a5.485,5.485,0,0,0,.582,7.936l6.73,5.505a5.982,5.982,0,0,0,8.215-.74l5.841-6.638a5.484,5.484,0,0,0-.587-7.932Z",
    transform: "translate(-522.016 -278.287)",
    fill: "#bdcbe9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11878",
    "data-name": "Group 11878",
    transform: "translate(308.006 261.938)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11877",
    "data-name": "Group 11877",
    transform: "translate(0)",
    clipPath: "url(#clip-path-107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11876",
    "data-name": "Group 11876",
    transform: "translate(-34.032 -4.58)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2439",
    "data-name": "Path 2439",
    d: "M436.029,282.535l3.384,11.684a19.627,19.627,0,0,1,4.273-18.471,21.131,21.131,0,0,1,29-2.613,19.623,19.623,0,0,1,2.8,2.8l-3.384-11.684a19.726,19.726,0,0,0-2.8-2.8,21.134,21.134,0,0,0-29,2.611,19.63,19.63,0,0,0-4.273,18.474",
    transform: "translate(-435.273 -256.868)",
    fill: "#828282"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2440",
    "data-name": "Path 2440",
    d: "M433.811,259.992l3.384,11.684a19.027,19.027,0,0,1,3.457,6.5L437.271,266.5a18.993,18.993,0,0,0-3.46-6.5",
    transform: "translate(-396.977 -252.605)",
    fill: "#878787"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2441",
    "data-name": "Path 2441",
    d: "M433.783,262.742l3.382,11.685.066.225-3.382-11.687c-.021-.073-.043-.149-.066-.222",
    transform: "translate(-393.489 -248.852)",
    fill: "#8c8c8c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11881",
    "data-name": "Group 11881",
    transform: "translate(273.974 257.359)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11880",
    "data-name": "Group 11880",
    transform: "translate(0)",
    clipPath: "url(#clip-path-108)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11879",
    "data-name": "Group 11879",
    transform: "translate(0 -0.001)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2443",
    "data-name": "Path 2443",
    d: "M436.029,282.535l3.384,11.684a19.627,19.627,0,0,1,4.273-18.471,21.131,21.131,0,0,1,29-2.613,19.623,19.623,0,0,1,2.8,2.8l-3.384-11.684a19.726,19.726,0,0,0-2.8-2.8,21.134,21.134,0,0,0-29,2.611,19.63,19.63,0,0,0-4.273,18.474",
    transform: "translate(-435.273 -256.868)",
    fill: "#828282"
  }))))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11882",
    "data-name": "Group 11882",
    transform: "translate(177.155 254.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2445",
    "data-name": "Path 2445",
    d: "M469.579,255.457l3.383,11.685,52.527,42.966-3.383-11.685Z",
    transform: "translate(-469.579 -255.457)",
    fill: "#828282"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11885",
    "data-name": "Group 11885",
    transform: "translate(229.681 296.986)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11884",
    "data-name": "Group 11884",
    transform: "translate(0)",
    clipPath: "url(#clip-path-109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11883",
    "data-name": "Group 11883",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2446",
    "data-name": "Path 2446",
    d: "M469.266,273.626l3.384,11.684a5.362,5.362,0,0,1,.74.743l-3.382-11.684a5.244,5.244,0,0,0-.742-.743",
    transform: "translate(-469.266 -273.626)",
    fill: "#828282"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2447",
    "data-name": "Path 2447",
    d: "M468.879,273.94l3.382,11.684a5.05,5.05,0,0,1,.915,1.722l-3.382-11.684a5.027,5.027,0,0,0-.915-1.722",
    transform: "translate(-468.136 -273.197)",
    fill: "#878787"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2448",
    "data-name": "Path 2448",
    d: "M468.871,274.668l3.382,11.684.019.062-3.384-11.687-.017-.059",
    transform: "translate(-467.213 -272.204)",
    fill: "#8c8c8c"
  }))))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11886",
    "data-name": "Group 11886",
    transform: "translate(170.031 262.116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2450",
    "data-name": "Path 2450",
    d: "M472.592,258.88l3.383,11.686L528.5,313.532l-3.383-11.685Z",
    transform: "translate(-472.592 -258.88)",
    fill: "#515f82"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11889",
    "data-name": "Group 11889",
    transform: "translate(121.222 331.823)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11888",
    "data-name": "Group 11888",
    transform: "translate(0)",
    clipPath: "url(#clip-path-110)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11887",
    "data-name": "Group 11887",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2451",
    "data-name": "Path 2451",
    d: "M511.971,290.391l3.382,11.684a5.987,5.987,0,0,1,8.213-.735l-3.382-11.684a5.987,5.987,0,0,0-8.213.736",
    transform: "translate(-511.971 -288.357)",
    fill: "#515f82"
  }))))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11890",
    "data-name": "Group 11890",
    transform: "translate(198.496 150.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2453",
    "data-name": "Path 2453",
    d: "M420.577,211.724l3.383,11.685,147.066,120.3-3.383-11.685Z",
    transform: "translate(-420.577 -211.724)",
    fill: "#828282"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11891",
    "data-name": "Group 11891",
    transform: "translate(345 270.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2454",
    "data-name": "Path 2454",
    d: "M420.577,263.232l3.383,11.685.561-.638-3.383-11.686Z",
    transform: "translate(-420.577 -262.594)",
    fill: "#686e7e"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11892",
    "data-name": "Group 11892",
    transform: "translate(197.935 151.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2455",
    "data-name": "Path 2455",
    d: "M420.814,211.994l3.383,11.685,147.066,120.3-3.383-11.686Z",
    transform: "translate(-420.814 -211.994)",
    fill: "#6c7282"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11893",
    "data-name": "Group 11893",
    transform: "translate(197.935 150.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2456",
    "data-name": "Path 2456",
    d: "M422.569,211.724l-.561.638,147.066,120.3.561-.638Z",
    transform: "translate(-422.008 -211.724)",
    fill: "#bdcbe9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11896",
    "data-name": "Group 11896",
    transform: "translate(222.558 299.51)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11895",
    "data-name": "Group 11895",
    transform: "translate(0)",
    clipPath: "url(#clip-path-111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11894",
    "data-name": "Group 11894",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2457",
    "data-name": "Path 2457",
    d: "M468.787,280.264l3.382,11.687a5.591,5.591,0,0,0,7.671-.69,5.2,5.2,0,0,0,1.128-4.883l-3.384-11.685a5.186,5.186,0,0,1-1.126,4.881,5.588,5.588,0,0,1-7.671.691",
    transform: "translate(-468.787 -274.693)",
    fill: "#515f82"
  }))))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11897",
    "data-name": "Group 11897",
    transform: "translate(115.382 333.855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2459",
    "data-name": "Path 2459",
    d: "M515.443,295.854l3.382,11.685,5.841-6.637-3.382-11.686Z",
    transform: "translate(-515.443 -289.217)",
    fill: "#4e5b7e"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11898",
    "data-name": "Group 11898",
    transform: "translate(162.92 268.344)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2460",
    "data-name": "Path 2460",
    d: "M474.373,261.514l3.383,11.685,55.426,45.337L529.8,306.851Z",
    transform: "translate(-474.373 -261.514)",
    fill: "#828282"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11899",
    "data-name": "Group 11899",
    transform: "translate(129.434 333.121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2461",
    "data-name": "Path 2461",
    d: "M509.125,288.906l3.383,11.685,6.731,5.506-3.383-11.685Z",
    transform: "translate(-509.125 -288.906)",
    fill: "#515f82"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11902",
    "data-name": "Group 11902",
    transform: "translate(218.344 313.682)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11901",
    "data-name": "Group 11901",
    transform: "translate(0)",
    clipPath: "url(#clip-path-112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11900",
    "data-name": "Group 11900",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2462",
    "data-name": "Path 2462",
    d: "M474.208,280.686l3.384,11.684a2.649,2.649,0,0,1,.39.39L474.6,281.076a2.529,2.529,0,0,0-.39-.39",
    transform: "translate(-474.208 -280.686)",
    fill: "#828282"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2463",
    "data-name": "Path 2463",
    d: "M474,280.851l3.384,11.684a2.65,2.65,0,0,1,.48.9l-3.382-11.684a2.653,2.653,0,0,0-.482-.9",
    transform: "translate(-473.615 -280.461)",
    fill: "#878787"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2464",
    "data-name": "Path 2464",
    d: "M474,281.233l3.382,11.684.009.033-3.382-11.687-.01-.031",
    transform: "translate(-473.128 -279.939)",
    fill: "#8c8c8c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11905",
    "data-name": "Group 11905",
    transform: "translate(113.956 340.494)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11904",
    "data-name": "Group 11904",
    transform: "translate(0)",
    clipPath: "url(#clip-path-113)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11903",
    "data-name": "Group 11903",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2466",
    "data-name": "Path 2466",
    d: "M518.127,297.257l3.382,11.687a5.56,5.56,0,0,1,1.213-5.236l-3.384-11.684a5.561,5.561,0,0,0-1.211,5.233",
    transform: "translate(-517.913 -292.024)",
    fill: "#515f82"
  }))))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11906",
    "data-name": "Group 11906",
    transform: "translate(159.176 272.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2468",
    "data-name": "Path 2468",
    d: "M475.956,263.313,479.339,275l55.426,45.337-3.383-11.685Z",
    transform: "translate(-475.956 -263.313)",
    fill: "#6c7282"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11909",
    "data-name": "Group 11909",
    transform: "translate(136.165 338.626)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11908",
    "data-name": "Group 11908",
    transform: "translate(0)",
    clipPath: "url(#clip-path-114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11907",
    "data-name": "Group 11907",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2469",
    "data-name": "Path 2469",
    d: "M508.789,291.234l3.382,11.687a5.479,5.479,0,0,1,.795.795l-3.382-11.687a5.864,5.864,0,0,0-.795-.795",
    transform: "translate(-508.789 -291.234)",
    fill: "#515f82"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2470",
    "data-name": "Path 2470",
    d: "M508.374,291.57l3.382,11.687a5.4,5.4,0,0,1,.981,1.844l-3.384-11.687a5.413,5.413,0,0,0-.979-1.845",
    transform: "translate(-507.579 -290.775)",
    fill: "#546286"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2471",
    "data-name": "Path 2471",
    d: "M508.366,292.35l3.384,11.687.019.064-3.384-11.687-.019-.064",
    transform: "translate(-506.592 -289.711)",
    fill: "#56668b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11912",
    "data-name": "Group 11912",
    transform: "translate(214.601 315.006)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11911",
    "data-name": "Group 11911",
    transform: "translate(0)",
    clipPath: "url(#clip-path-115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11910",
    "data-name": "Group 11910",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2473",
    "data-name": "Path 2473",
    d: "M473.957,284.176l3.384,11.684a2.935,2.935,0,0,0,4.027-.362,2.728,2.728,0,0,0,.6-2.566l-3.384-11.687a2.726,2.726,0,0,1-.594,2.566,2.941,2.941,0,0,1-4.03.364",
    transform: "translate(-473.957 -281.246)",
    fill: "#6c7282"
  }))))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11913",
    "data-name": "Group 11913",
    transform: "translate(158.194 267.708)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2475",
    "data-name": "Path 2475",
    d: "M480.112,261.881a2.935,2.935,0,0,0-4.027.362,2.7,2.7,0,0,0,.284,3.892l55.426,45.338a2.941,2.941,0,0,0,4.03-.364,2.689,2.689,0,0,0-.286-3.89Z",
    transform: "translate(-475.388 -261.245)",
    fill: "#bdcbe9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11916",
    "data-name": "Group 11916",
    transform: "translate(114.17 345.727)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11915",
    "data-name": "Group 11915",
    transform: "translate(0)",
    clipPath: "url(#clip-path-116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11914",
    "data-name": "Group 11914",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2476",
    "data-name": "Path 2476",
    d: "M518.418,294.237l3.382,11.687.019.062L518.437,294.3l-.019-.064",
    transform: "translate(-518.418 -294.237)",
    fill: "#747b8c"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2477",
    "data-name": "Path 2477",
    d: "M518,294.264l3.382,11.684a5.374,5.374,0,0,0,.981,1.845l-3.384-11.684a5.412,5.412,0,0,1-.979-1.845",
    transform: "translate(-517.984 -294.2)",
    fill: "#6f7687"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2478",
    "data-name": "Path 2478",
    d: "M517.667,295.044l3.384,11.684a5.6,5.6,0,0,0,.795.795l-3.384-11.685a5.6,5.6,0,0,1-.794-.794",
    transform: "translate(-516.669 -293.136)",
    fill: "#6c7282"
  }))))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11917",
    "data-name": "Group 11917",
    transform: "translate(180.828 302.372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2480",
    "data-name": "Path 2480",
    d: "M478.566,275.9l3.383,11.686,27.6,22.577-3.383-11.685Z",
    transform: "translate(-478.566 -275.903)",
    fill: "#828282"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11920",
    "data-name": "Group 11920",
    transform: "translate(136.752 341.329)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11919",
    "data-name": "Group 11919",
    transform: "translate(0)",
    clipPath: "url(#clip-path-117)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11918",
    "data-name": "Group 11918",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2481",
    "data-name": "Path 2481",
    d: "M508.275,297.606l3.382,11.687a5.556,5.556,0,0,0,1.209-5.229l-3.384-11.687a5.559,5.559,0,0,1-1.206,5.229",
    transform: "translate(-508.275 -292.377)",
    fill: "#6c7282"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11923",
    "data-name": "Group 11923",
    transform: "translate(274.731 271.47)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11922",
    "data-name": "Group 11922",
    transform: "translate(0)",
    clipPath: "url(#clip-path-118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11921",
    "data-name": "Group 11921",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2483",
    "data-name": "Path 2483",
    d: "M450.5,267.722l3.382,11.684.066.225-3.382-11.684c-.021-.076-.045-.149-.066-.225",
    transform: "translate(-450.502 -256.168)",
    fill: "#253d8a"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2484",
    "data-name": "Path 2484",
    d: "M449.038,267.817,452.42,279.5a19.084,19.084,0,0,0,3.462,6.508L452.5,274.323a19.01,19.01,0,0,1-3.462-6.506",
    transform: "translate(-448.972 -256.038)",
    fill: "#243c86"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2485",
    "data-name": "Path 2485",
    d: "M433.463,281.121l3.382,11.687a19.779,19.779,0,0,0,2.8,2.807A21.119,21.119,0,0,0,468.642,293a19.644,19.644,0,0,0,4.278-18.483l-3.382-11.684a19.644,19.644,0,0,1-4.278,18.481,21.122,21.122,0,0,1-28.995,2.611,19.53,19.53,0,0,1-2.8-2.807",
    transform: "translate(-429.935 -262.836)",
    fill: "#233a81"
  }))))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11924",
    "data-name": "Group 11924",
    transform: "translate(273.974 257.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2487",
    "data-name": "Path 2487",
    d: "M468.927,261.451a21.134,21.134,0,0,0-29,2.611,19.368,19.368,0,0,0,2.057,28.011,21.122,21.122,0,0,0,28.995-2.611A19.367,19.367,0,0,0,468.927,261.451Z",
    transform: "translate(-434.893 -256.868)",
    fill: "#3a62e7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11927",
    "data-name": "Group 11927",
    transform: "translate(208.429 324.95)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11926",
    "data-name": "Group 11926",
    transform: "translate(0)",
    clipPath: "url(#clip-path-119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11925",
    "data-name": "Group 11925",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2488",
    "data-name": "Path 2488",
    d: "M478.4,285.451l3.384,11.684a2.726,2.726,0,0,1,.388.388l-3.382-11.684a2.629,2.629,0,0,0-.39-.388",
    transform: "translate(-478.402 -285.451)",
    fill: "#828282"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2489",
    "data-name": "Path 2489",
    d: "M478.2,285.615l3.382,11.684a2.651,2.651,0,0,1,.48.9l-3.382-11.684a2.646,2.646,0,0,0-.48-.9",
    transform: "translate(-477.809 -285.227)",
    fill: "#878787"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2490",
    "data-name": "Path 2490",
    d: "M478.195,286l3.382,11.684.009.033L478.2,286.028l-.009-.031",
    transform: "translate(-477.325 -284.706)",
    fill: "#8c8c8c"
  }))))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11928",
    "data-name": "Group 11928",
    transform: "translate(177.084 306.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2492",
    "data-name": "Path 2492",
    d: "M480.149,277.7l3.383,11.685,27.6,22.578-3.383-11.685Z",
    transform: "translate(-480.149 -277.702)",
    fill: "#6c7282"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11929",
    "data-name": "Group 11929",
    transform: "translate(115.963 348.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2493",
    "data-name": "Path 2493",
    d: "M514.821,295.38l3.383,11.685,6.731,5.506-3.383-11.685Z",
    transform: "translate(-514.821 -295.38)",
    fill: "#6c7282"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11932",
    "data-name": "Group 11932",
    transform: "translate(204.685 326.272)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11931",
    "data-name": "Group 11931",
    clipPath: "url(#clip-path-120)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11930",
    "data-name": "Group 11930",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2494",
    "data-name": "Path 2494",
    d: "M478.151,288.942l3.384,11.685a2.93,2.93,0,0,0,4.027-.362,2.729,2.729,0,0,0,.594-2.568l-3.382-11.687a2.733,2.733,0,0,1-.594,2.568,2.934,2.934,0,0,1-4.03.364",
    transform: "translate(-478.151 -286.01)",
    fill: "#6c7282"
  }))))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11933",
    "data-name": "Group 11933",
    transform: "translate(176.099 301.737)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2496",
    "data-name": "Path 2496",
    d: "M484.309,276.269a2.937,2.937,0,0,0-4.027.364,2.687,2.687,0,0,0,.284,3.89l27.6,22.579a2.934,2.934,0,0,0,4.03-.364,2.689,2.689,0,0,0-.286-3.89Z",
    transform: "translate(-479.581 -275.635)",
    fill: "#bdcbe9"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11934",
    "data-name": "Group 11934",
    transform: "translate(130.91 346.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2497",
    "data-name": "Path 2497",
    d: "M508.877,301.225l3.383,11.686,5.841-6.638-3.383-11.685Z",
    transform: "translate(-508.877 -294.588)",
    fill: "#686e7e"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11935",
    "data-name": "Group 11935",
    transform: "translate(113.955 331.823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2498",
    "data-name": "Path 2498",
    d: "M525.186,289.655a5.987,5.987,0,0,0-8.213.736l-5.841,6.638a5.487,5.487,0,0,0,.582,7.936l6.73,5.505a5.989,5.989,0,0,0,8.218-.74l5.841-6.638a5.488,5.488,0,0,0-.586-7.931Z",
    transform: "translate(-509.706 -288.357)",
    fill: "#bdcbe9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11938",
    "data-name": "Group 11938",
    transform: "translate(122.693 353.195)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11937",
    "data-name": "Group 11937",
    transform: "translate(0)",
    clipPath: "url(#clip-path-121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11936",
    "data-name": "Group 11936",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2499",
    "data-name": "Path 2499",
    d: "M511.347,298.135l3.384,11.684a5.982,5.982,0,0,0,8.215-.74l-3.382-11.684a5.99,5.99,0,0,1-8.218.74",
    transform: "translate(-511.347 -297.395)",
    fill: "#6c7282"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11941",
    "data-name": "Group 11941",
    transform: "translate(149.687 355.106)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11940",
    "data-name": "Group 11940",
    transform: "translate(0)",
    clipPath: "url(#clip-path-122)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11939",
    "data-name": "Group 11939",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2501",
    "data-name": "Path 2501",
    d: "M499.934,300.236l3.384,11.687a5.98,5.98,0,0,1,8.211-.735L508.147,299.5a5.987,5.987,0,0,0-8.213.735",
    transform: "translate(-499.934 -298.203)",
    fill: "#515f82"
  }))))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11942",
    "data-name": "Group 11942",
    transform: "translate(143.847 357.14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2503",
    "data-name": "Path 2503",
    d: "M503.406,305.7l3.383,11.686,5.841-6.638-3.383-11.685Z",
    transform: "translate(-503.406 -299.063)",
    fill: "#4e5b7e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11945",
    "data-name": "Group 11945",
    transform: "translate(246.263 315.082)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11944",
    "data-name": "Group 11944",
    transform: "translate(0)",
    clipPath: "url(#clip-path-123)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11943",
    "data-name": "Group 11943",
    transform: "translate(-23 -0.093)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2504",
    "data-name": "Path 2504",
    d: "M457.474,306.909l3.382,11.684a19.632,19.632,0,0,1,4.271-18.474,21.127,21.127,0,0,1,29-2.611,19.39,19.39,0,0,1,2.8,2.8l-3.382-11.687a19.76,19.76,0,0,0-2.8-2.8,21.129,21.129,0,0,0-29,2.611,19.637,19.637,0,0,0-4.271,18.476",
    transform: "translate(-456.718 -281.239)",
    fill: "#828282"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2505",
    "data-name": "Path 2505",
    d: "M455.255,284.363l3.382,11.687a19,19,0,0,1,3.46,6.5l-3.382-11.687a19.117,19.117,0,0,0-3.46-6.5",
    transform: "translate(-418.421 -276.974)",
    fill: "#878787"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2506",
    "data-name": "Path 2506",
    d: "M455.227,287.113l3.382,11.687c.024.073.045.149.066.222l-3.382-11.684c-.024-.076-.045-.149-.066-.225",
    transform: "translate(-414.933 -273.221)",
    fill: "#8c8c8c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11948",
    "data-name": "Group 11948",
    transform: "translate(223.263 314.99)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11947",
    "data-name": "Group 11947",
    transform: "translate(0)",
    clipPath: "url(#clip-path-124)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11946",
    "data-name": "Group 11946",
    transform: "translate(0 -0.001)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2508",
    "data-name": "Path 2508",
    d: "M457.474,306.909l3.382,11.684a19.632,19.632,0,0,1,4.271-18.474,21.127,21.127,0,0,1,29-2.611,19.39,19.39,0,0,1,2.8,2.8l-3.382-11.687a19.76,19.76,0,0,0-2.8-2.8,21.129,21.129,0,0,0-29,2.611,19.637,19.637,0,0,0-4.271,18.476",
    transform: "translate(-456.718 -281.239)",
    fill: "#828282"
  }))))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11949",
    "data-name": "Group 11949",
    transform: "translate(157.9 356.405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2510",
    "data-name": "Path 2510",
    d: "M497.088,298.752l3.383,11.685,6.731,5.506-3.383-11.685Z",
    transform: "translate(-497.088 -298.752)",
    fill: "#515f82"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11952",
    "data-name": "Group 11952",
    transform: "translate(142.421 363.778)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11951",
    "data-name": "Group 11951",
    transform: "translate(0)",
    clipPath: "url(#clip-path-125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11950",
    "data-name": "Group 11950",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2511",
    "data-name": "Path 2511",
    d: "M506.09,307.1l3.382,11.687a5.566,5.566,0,0,1,1.213-5.236L507.3,301.87a5.561,5.561,0,0,0-1.211,5.233",
    transform: "translate(-505.876 -301.87)",
    fill: "#515f82"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11955",
    "data-name": "Group 11955",
    transform: "translate(164.63 361.912)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11954",
    "data-name": "Group 11954",
    transform: "translate(0)",
    clipPath: "url(#clip-path-126)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11953",
    "data-name": "Group 11953",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2513",
    "data-name": "Path 2513",
    d: "M496.752,301.081l3.382,11.685a5.607,5.607,0,0,1,.795.794l-3.382-11.684a5.372,5.372,0,0,0-.794-.795",
    transform: "translate(-496.752 -301.081)",
    fill: "#515f82"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2514",
    "data-name": "Path 2514",
    d: "M496.337,301.417l3.382,11.684a5.416,5.416,0,0,1,.981,1.845l-3.382-11.684a5.414,5.414,0,0,0-.981-1.845",
    transform: "translate(-495.542 -300.622)",
    fill: "#546286"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2515",
    "data-name": "Path 2515",
    d: "M496.329,302.2l3.382,11.684.019.064-3.382-11.684-.019-.064",
    transform: "translate(-494.553 -299.558)",
    fill: "#56668b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11958",
    "data-name": "Group 11958",
    transform: "translate(142.635 369.011)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11957",
    "data-name": "Group 11957",
    transform: "translate(0)",
    clipPath: "url(#clip-path-127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11956",
    "data-name": "Group 11956",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2517",
    "data-name": "Path 2517",
    d: "M506.381,304.083l3.382,11.687.019.064L506.4,304.147l-.019-.064",
    transform: "translate(-506.381 -304.083)",
    fill: "#747b8c"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2518",
    "data-name": "Path 2518",
    d: "M505.966,304.11l3.382,11.687a5.388,5.388,0,0,0,.981,1.842l-3.381-11.684a5.355,5.355,0,0,1-.982-1.845",
    transform: "translate(-505.947 -304.046)",
    fill: "#6f7687"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2519",
    "data-name": "Path 2519",
    d: "M505.63,304.89l3.382,11.684a5.368,5.368,0,0,0,.795.795l-3.384-11.684a5.717,5.717,0,0,1-.792-.795",
    transform: "translate(-504.63 -302.982)",
    fill: "#6c7282"
  }))))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11959",
    "data-name": "Group 11959",
    transform: "translate(147.41 208.657)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2521",
    "data-name": "Path 2521",
    d: "M442.18,236.274l3.383,11.685,147.065,120.3-3.383-11.686Z",
    transform: "translate(-442.18 -236.274)",
    fill: "#828282"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11960",
    "data-name": "Group 11960",
    transform: "translate(293.914 328.954)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2522",
    "data-name": "Path 2522",
    d: "M442.18,287.782l3.383,11.685.561-.638-3.383-11.685Z",
    transform: "translate(-442.18 -287.144)",
    fill: "#686e7e"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11961",
    "data-name": "Group 11961",
    transform: "translate(146.849 209.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2523",
    "data-name": "Path 2523",
    d: "M442.417,236.544l3.383,11.685,147.066,120.3-3.383-11.685Z",
    transform: "translate(-442.417 -236.544)",
    fill: "#6c7282"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11964",
    "data-name": "Group 11964",
    transform: "translate(165.217 364.615)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11963",
    "data-name": "Group 11963",
    transform: "translate(0)",
    clipPath: "url(#clip-path-128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11962",
    "data-name": "Group 11962",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2524",
    "data-name": "Path 2524",
    d: "M496.238,307.45l3.382,11.687a5.556,5.556,0,0,0,1.208-5.229l-3.382-11.684a5.558,5.558,0,0,1-1.208,5.226",
    transform: "translate(-496.238 -302.224)",
    fill: "#6c7282"
  }))))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11965",
    "data-name": "Group 11965",
    transform: "translate(144.429 371.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2526",
    "data-name": "Path 2526",
    d: "M502.784,305.226l3.383,11.685,6.731,5.506-3.383-11.686Z",
    transform: "translate(-502.784 -305.226)",
    fill: "#6c7282"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11966",
    "data-name": "Group 11966",
    transform: "translate(80.923 283.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2527",
    "data-name": "Path 2527",
    d: "M488.869,267.949l3.383,11.685L595.393,364l-3.383-11.685Z",
    transform: "translate(-488.869 -267.949)",
    fill: "#828282"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11967",
    "data-name": "Group 11967",
    transform: "translate(159.376 369.842)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2528",
    "data-name": "Path 2528",
    d: "M496.84,311.072l3.383,11.685,5.841-6.637-3.383-11.685Z",
    transform: "translate(-496.84 -304.434)",
    fill: "#686e7e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11970",
    "data-name": "Group 11970",
    transform: "translate(196.435 365.977)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11969",
    "data-name": "Group 11969",
    transform: "translate(0)",
    clipPath: "url(#clip-path-129)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11968",
    "data-name": "Group 11968",
    transform: "translate(-12.37 -1.846)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2529",
    "data-name": "Path 2529",
    d: "M483.161,305.819l3.384,11.684a8.493,8.493,0,0,1,12.37-1.951,7.835,7.835,0,0,1,1.128,1.13L496.662,305a7.983,7.983,0,0,0-1.13-1.13,8.507,8.507,0,0,0-11.68,1.052,8.2,8.2,0,0,0-.691.9",
    transform: "translate(-483.161 -302.019)",
    fill: "#828282"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11973",
    "data-name": "Group 11973",
    transform: "translate(184.064 364.13)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11972",
    "data-name": "Group 11972",
    transform: "translate(0)",
    clipPath: "url(#clip-path-130)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11971",
    "data-name": "Group 11971",
    transform: "translate(0 0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2531",
    "data-name": "Path 2531",
    d: "M483.161,305.819l3.384,11.684a8.493,8.493,0,0,1,12.37-1.951,7.835,7.835,0,0,1,1.128,1.13L496.662,305a7.983,7.983,0,0,0-1.13-1.13,8.507,8.507,0,0,0-11.68,1.052,8.2,8.2,0,0,0-.691.9",
    transform: "translate(-483.161 -302.019)",
    fill: "#828282"
  }))))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11974",
    "data-name": "Group 11974",
    transform: "translate(142.421 355.106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2533",
    "data-name": "Path 2533",
    d: "M513.147,299.5a5.987,5.987,0,0,0-8.213.735l-5.841,6.638a5.489,5.489,0,0,0,.582,7.936l6.733,5.505a5.982,5.982,0,0,0,8.215-.74l5.841-6.638a5.483,5.483,0,0,0-.586-7.929Z",
    transform: "translate(-497.669 -298.203)",
    fill: "#bdcbe9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11977",
    "data-name": "Group 11977",
    transform: "translate(151.16 376.479)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11976",
    "data-name": "Group 11976",
    transform: "translate(0)",
    clipPath: "url(#clip-path-131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11975",
    "data-name": "Group 11975",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2534",
    "data-name": "Path 2534",
    d: "M499.31,307.981l3.382,11.685a5.984,5.984,0,0,0,8.215-.738l-3.382-11.687a5.982,5.982,0,0,1-8.215.74",
    transform: "translate(-499.31 -307.241)",
    fill: "#6c7282"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11980",
    "data-name": "Group 11980",
    transform: "translate(88.431 381.726)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11979",
    "data-name": "Group 11979",
    clipPath: "url(#clip-path-132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11978",
    "data-name": "Group 11978",
    transform: "translate(0 -2.259)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2536",
    "data-name": "Path 2536",
    d: "M514.446,329.321,517.827,341c-.771-10.474,7.4-19.76,18.245-20.732a19.707,19.707,0,0,1,14.3,4.3,18.816,18.816,0,0,1,2.682,2.686l-3.382-11.684a18.7,18.7,0,0,0-2.682-2.686,19.7,19.7,0,0,0-14.3-4.3c-10.845.972-19.018,10.258-18.244,20.732",
    transform: "translate(-514.395 -308.505)",
    fill: "#6c7282"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11983",
    "data-name": "Group 11983",
    transform: "translate(182.726 367.93)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11982",
    "data-name": "Group 11982",
    transform: "translate(0)",
    clipPath: "url(#clip-path-133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11981",
    "data-name": "Group 11981",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2538",
    "data-name": "Path 2538",
    d: "M488.9,308.646l3.384,11.687a7.92,7.92,0,0,1,1.31-5.023l-3.382-11.684a7.9,7.9,0,0,0-1.313,5.02",
    transform: "translate(-488.87 -303.626)",
    fill: "#515f82"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11986",
    "data-name": "Group 11986",
    transform: "translate(182.059 372.951)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11985",
    "data-name": "Group 11985",
    transform: "translate(0)",
    clipPath: "url(#clip-path-134)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11984",
    "data-name": "Group 11984",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2540",
    "data-name": "Path 2540",
    d: "M489.424,306.475l3.382,11.684c.222-.253.456-.494.7-.724l-3.384-11.687q-.358.348-.693.726",
    transform: "translate(-489.424 -305.749)",
    fill: "#515f82"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11989",
    "data-name": "Group 11989",
    transform: "translate(196.435 365.977)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11988",
    "data-name": "Group 11988",
    transform: "translate(0)",
    clipPath: "url(#clip-path-135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11987",
    "data-name": "Group 11987",
    transform: "translate(-12.37 -1.846)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2542",
    "data-name": "Path 2542",
    d: "M483.161,305.819l3.384,11.684a8.493,8.493,0,0,1,12.37-1.951,7.835,7.835,0,0,1,1.128,1.13L496.662,305a7.983,7.983,0,0,0-1.13-1.13,8.507,8.507,0,0,0-11.68,1.052,8.2,8.2,0,0,0-.691.9",
    transform: "translate(-483.161 -302.019)",
    fill: "#828282"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2543",
    "data-name": "Path 2543",
    d: "M482.573,303.278l3.382,11.687a7.643,7.643,0,0,1,1.39,2.615l-3.382-11.687a7.684,7.684,0,0,0-1.39-2.615",
    transform: "translate(-469.072 -300.301)",
    fill: "#878787"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11992",
    "data-name": "Group 11992",
    transform: "translate(198.743 369.115)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11991",
    "data-name": "Group 11991",
    transform: "translate(0)",
    clipPath: "url(#clip-path-136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11990",
    "data-name": "Group 11990",
    transform: "translate(-1.178 -2.008)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2545",
    "data-name": "Path 2545",
    d: "M482.573,303.278l3.382,11.687a7.643,7.643,0,0,1,1.39,2.615l-3.382-11.687a7.684,7.684,0,0,0-1.39-2.615",
    transform: "translate(-482.573 -303.278)",
    fill: "#878787"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11995",
    "data-name": "Group 11995",
    transform: "translate(182.752 372.951)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11994",
    "data-name": "Group 11994",
    transform: "translate(0)",
    clipPath: "url(#clip-path-137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11993",
    "data-name": "Group 11993",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2547",
    "data-name": "Path 2547",
    d: "M489.514,306.773l3.382,11.684a7.836,7.836,0,0,1-.151-1.022l-3.384-11.687a7.889,7.889,0,0,0,.154,1.024",
    transform: "translate(-489.36 -305.749)",
    fill: "#1c2e61"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11998",
    "data-name": "Group 11998",
    transform: "translate(182.7 373.975)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11997",
    "data-name": "Group 11997",
    transform: "translate(0)",
    clipPath: "url(#clip-path-138)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11996",
    "data-name": "Group 11996",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2549",
    "data-name": "Path 2549",
    d: "M489.36,306.409l3.382,11.684.206-.227-3.382-11.684c-.068.073-.139.149-.206.227",
    transform: "translate(-489.36 -306.182)",
    fill: "#1c2e61"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12001",
    "data-name": "Group 12001",
    transform: "translate(198.743 369.117)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12000",
    "data-name": "Group 12000",
    transform: "translate(0)",
    clipPath: "url(#clip-path-139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11999",
    "data-name": "Group 11999",
    transform: "translate(-1.178 -2.01)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2551",
    "data-name": "Path 2551",
    d: "M482.573,303.278l3.382,11.687a7.643,7.643,0,0,1,1.39,2.615l-3.382-11.687a7.684,7.684,0,0,0-1.39-2.615",
    transform: "translate(-482.573 -303.278)",
    fill: "#878787"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2552",
    "data-name": "Path 2552",
    d: "M482.561,304.384l3.382,11.687.028.092-3.382-11.684-.028-.095",
    transform: "translate(-481.171 -301.769)",
    fill: "#8c8c8c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12004",
    "data-name": "Group 12004",
    transform: "translate(182.905 373.975)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12003",
    "data-name": "Group 12003",
    transform: "translate(0)",
    clipPath: "url(#clip-path-140)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12002",
    "data-name": "Group 12002",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2554",
    "data-name": "Path 2554",
    d: "M489.431,306.679l3.384,11.685q-.071-.245-.128-.5l-3.382-11.684c.036.165.078.331.125.5",
    transform: "translate(-489.306 -306.182)",
    fill: "#1c2e61"
  }))))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12005",
    "data-name": "Group 12005",
    transform: "translate(223.263 314.989)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2556",
    "data-name": "Path 2556",
    d: "M490.368,285.822a21.127,21.127,0,0,0-29,2.611,19.372,19.372,0,0,0,2.057,28.011,21.126,21.126,0,0,0,28.995-2.611A19.363,19.363,0,0,0,490.368,285.822Z",
    transform: "translate(-456.338 -281.239)",
    fill: "#e6dad6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12008",
    "data-name": "Group 12008",
    transform: "translate(224.02 329.105)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12007",
    "data-name": "Group 12007",
    transform: "translate(0)",
    clipPath: "url(#clip-path-141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12006",
    "data-name": "Group 12006",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2557",
    "data-name": "Path 2557",
    d: "M471.946,292.094l3.382,11.684c.021.076.043.151.066.225l-3.382-11.684c-.024-.076-.045-.149-.066-.225",
    transform: "translate(-471.946 -280.54)",
    fill: "#8a8380"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2558",
    "data-name": "Path 2558",
    d: "M470.483,292.189l3.382,11.684a19.036,19.036,0,0,0,3.46,6.508l-3.382-11.687a19,19,0,0,1-3.46-6.506",
    transform: "translate(-470.417 -280.41)",
    fill: "#857f7d"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2559",
    "data-name": "Path 2559",
    d: "M454.908,305.493l3.382,11.687a19.888,19.888,0,0,0,2.8,2.8,21.129,21.129,0,0,0,28.995-2.611,19.643,19.643,0,0,0,4.28-18.481l-3.384-11.684a19.637,19.637,0,0,1-4.278,18.478A21.126,21.126,0,0,1,457.71,308.3a19.517,19.517,0,0,1-2.8-2.8",
    transform: "translate(-451.382 -287.208)",
    fill: "#807a78"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12011",
    "data-name": "Group 12011",
    transform: "translate(99.192 379.467)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12010",
    "data-name": "Group 12010",
    transform: "translate(0)",
    clipPath: "url(#clip-path-142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12009",
    "data-name": "Group 12009",
    transform: "translate(-10.761)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2561",
    "data-name": "Path 2561",
    d: "M514.446,329.321,517.827,341c-.771-10.474,7.4-19.76,18.245-20.732a19.707,19.707,0,0,1,14.3,4.3,18.816,18.816,0,0,1,2.682,2.686l-3.382-11.684a18.7,18.7,0,0,0-2.682-2.686,19.7,19.7,0,0,0-14.3-4.3c-10.845.972-19.018,10.258-18.244,20.732",
    transform: "translate(-514.395 -308.505)",
    fill: "#6c7282"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2562",
    "data-name": "Path 2562",
    d: "M513,311.5l3.382,11.684a18.244,18.244,0,0,1,3.308,6.212L516.3,317.706A18.214,18.214,0,0,0,513,311.5",
    transform: "translate(-477.724 -304.422)",
    fill: "#6f7687"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2563",
    "data-name": "Path 2563",
    d: "M512.968,314.122l3.382,11.687.066.22-3.382-11.684c-.021-.076-.045-.149-.066-.222",
    transform: "translate(-474.388 -300.838)",
    fill: "#747b8c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12014",
    "data-name": "Group 12014",
    transform: "translate(103.328 380.694)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12013",
    "data-name": "Group 12013",
    transform: "translate(0)",
    clipPath: "url(#clip-path-143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12012",
    "data-name": "Group 12012",
    transform: "translate(-13.629 0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2565",
    "data-name": "Path 2565",
    d: "M515.5,332.02l3.382,11.685a17.592,17.592,0,0,1,3.828-16.549,18.926,18.926,0,0,1,25.984-2.339,17.6,17.6,0,0,1,2.509,2.509l-3.382-11.684a17.614,17.614,0,0,0-2.509-2.511,18.931,18.931,0,0,0-25.984,2.339A17.591,17.591,0,0,0,515.5,332.02",
    transform: "translate(-514.82 -309.024)",
    fill: "#515f82"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2566",
    "data-name": "Path 2566",
    d: "M513.51,311.822l3.382,11.684a17.061,17.061,0,0,1,3.1,5.827l-3.382-11.684a17.06,17.06,0,0,0-3.1-5.827",
    transform: "translate(-480.511 -305.204)",
    fill: "#546286"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2567",
    "data-name": "Path 2567",
    d: "M513.485,314.286l3.382,11.684c.021.066.04.132.059.2l-3.382-11.687-.059-.2",
    transform: "translate(-477.388 -301.841)",
    fill: "#56668b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12017",
    "data-name": "Group 12017",
    transform: "translate(89.699 381.412)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12016",
    "data-name": "Group 12016",
    transform: "translate(0)",
    clipPath: "url(#clip-path-144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12015",
    "data-name": "Group 12015",
    transform: "translate(0 -0.718)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2569",
    "data-name": "Path 2569",
    d: "M515.5,332.02l3.382,11.685a17.592,17.592,0,0,1,3.828-16.549,18.926,18.926,0,0,1,25.984-2.339,17.6,17.6,0,0,1,2.509,2.509l-3.382-11.684a17.614,17.614,0,0,0-2.509-2.511,18.931,18.931,0,0,0-25.984,2.339A17.591,17.591,0,0,0,515.5,332.02",
    transform: "translate(-514.82 -309.024)",
    fill: "#515f82"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12020",
    "data-name": "Group 12020",
    transform: "translate(88.482 400.283)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12019",
    "data-name": "Group 12019",
    transform: "translate(0)",
    clipPath: "url(#clip-path-145)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12018",
    "data-name": "Group 12018",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2571",
    "data-name": "Path 2571",
    d: "M529.677,321.079l3.384,11.684a18.407,18.407,0,0,1-.677-3.772L529,317.307a18.307,18.307,0,0,0,.674,3.772",
    transform: "translate(-529.003 -317.307)",
    fill: "#6c7282"
  }))))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12021",
    "data-name": "Group 12021",
    transform: "translate(175.394 373.677)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2573",
    "data-name": "Path 2573",
    d: "M489.718,313.629l3.383,11.685,6.664-7.573-3.383-11.685Z",
    transform: "translate(-489.718 -306.056)",
    fill: "#4e5b7e"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12022",
    "data-name": "Group 12022",
    transform: "translate(176.035 374.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2574",
    "data-name": "Path 2574",
    d: "M489.447,313.851l3.383,11.686,6.664-7.573-3.383-11.685Z",
    transform: "translate(-489.447 -306.278)",
    fill: "#1b2c5f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12025",
    "data-name": "Group 12025",
    transform: "translate(173.212 381.249)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12024",
    "data-name": "Group 12024",
    transform: "translate(0)",
    clipPath: "url(#clip-path-146)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12023",
    "data-name": "Group 12023",
    transform: "translate(-0.657)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2575",
    "data-name": "Path 2575",
    d: "M492.963,319.7l3.384,11.687a11.1,11.1,0,0,1,2.41-10.443l-3.382-11.687a11.1,11.1,0,0,0-2.412,10.443",
    transform: "translate(-492.536 -309.258)",
    fill: "#515f82"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12028",
    "data-name": "Group 12028",
    transform: "translate(173.158 384.921)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12027",
    "data-name": "Group 12027",
    transform: "translate(0)",
    clipPath: "url(#clip-path-147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12026",
    "data-name": "Group 12026",
    transform: "translate(-0.602 -3.673)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2577",
    "data-name": "Path 2577",
    d: "M492.963,319.7l3.384,11.687a11.1,11.1,0,0,1,2.41-10.443l-3.382-11.687a11.1,11.1,0,0,0-2.412,10.443",
    transform: "translate(-492.536 -309.258)",
    fill: "#515f82"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12031",
    "data-name": "Group 12031",
    transform: "translate(173.099 385.08)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12030",
    "data-name": "Group 12030",
    transform: "translate(0)",
    clipPath: "url(#clip-path-148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12029",
    "data-name": "Group 12029",
    transform: "translate(-0.543 -3.831)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2579",
    "data-name": "Path 2579",
    d: "M492.963,319.7l3.384,11.687a11.1,11.1,0,0,1,2.41-10.443l-3.382-11.687a11.1,11.1,0,0,0-2.412,10.443",
    transform: "translate(-492.536 -309.258)",
    fill: "#515f82"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12034",
    "data-name": "Group 12034",
    transform: "translate(173.051 385.252)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12033",
    "data-name": "Group 12033",
    transform: "translate(0)",
    clipPath: "url(#clip-path-149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12032",
    "data-name": "Group 12032",
    transform: "translate(-0.496 -4.004)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2581",
    "data-name": "Path 2581",
    d: "M492.963,319.7l3.384,11.687a11.1,11.1,0,0,1,2.41-10.443l-3.382-11.687a11.1,11.1,0,0,0-2.412,10.443",
    transform: "translate(-492.536 -309.258)",
    fill: "#515f82"
  }))))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12035",
    "data-name": "Group 12035",
    transform: "translate(182.726 364.131)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2583",
    "data-name": "Path 2583",
    d: "M497.571,303.865a8.507,8.507,0,0,0-11.68,1.052,8.06,8.06,0,0,0-2,5.921,7.889,7.889,0,0,0,.154,1.024,7.718,7.718,0,0,0,2.677,4.337,8.21,8.21,0,0,0,4.741,1.83,8.668,8.668,0,0,0,4.552-1,8.5,8.5,0,0,0,2.386-1.887,8.073,8.073,0,0,0,1.807-3.455,7.926,7.926,0,0,0,.17-.96A7.715,7.715,0,0,0,497.571,303.865Z",
    transform: "translate(-483.862 -302.019)",
    fill: "#cf684c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12038",
    "data-name": "Group 12038",
    transform: "translate(183.031 369.817)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12037",
    "data-name": "Group 12037",
    transform: "translate(0)",
    clipPath: "url(#clip-path-150)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12036",
    "data-name": "Group 12036",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2584",
    "data-name": "Path 2584",
    d: "M489.294,306.392l3.384,11.685.028.094-3.384-11.684-.028-.095",
    transform: "translate(-489.294 -301.738)",
    fill: "#7e4131"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2585",
    "data-name": "Path 2585",
    d: "M488.706,306.432l3.384,11.684a7.614,7.614,0,0,0,1.391,2.613L490.1,309.045a7.7,7.7,0,0,1-1.391-2.613",
    transform: "translate(-488.678 -301.684)",
    fill: "#793e30"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2586",
    "data-name": "Path 2586",
    d: "M482.432,311.786l3.384,11.684a7.75,7.75,0,0,0,1.13,1.133,8.2,8.2,0,0,0,4.741,1.83,8.644,8.644,0,0,0,4.552-1,8.485,8.485,0,0,0,2.386-1.885,8.113,8.113,0,0,0,1.809-3.457,7.9,7.9,0,0,0,.168-.958,7.747,7.747,0,0,0-.255-3.029l-3.382-11.684a7.827,7.827,0,0,1,.255,3.027,7.94,7.94,0,0,1-.17.96,8.073,8.073,0,0,1-1.807,3.455,8.5,8.5,0,0,1-2.386,1.887,8.668,8.668,0,0,1-4.552,1,8.209,8.209,0,0,1-4.741-1.83,7.882,7.882,0,0,1-1.133-1.133",
    transform: "translate(-481.013 -304.424)",
    fill: "#753d2e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12041",
    "data-name": "Group 12041",
    transform: "translate(184.792 382.114)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12040",
    "data-name": "Group 12040",
    transform: "translate(0)",
    clipPath: "url(#clip-path-151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12039",
    "data-name": "Group 12039",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2588",
    "data-name": "Path 2588",
    d: "M487.349,311.909l3.382,11.684a1.754,1.754,0,0,1,.381-1.648,1.879,1.879,0,0,1,2.58-.227l-3.384-11.684a1.876,1.876,0,0,0-2.578.227,1.755,1.755,0,0,0-.381,1.648",
    transform: "translate(-487.282 -309.624)",
    fill: "#1c2e61"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12044",
    "data-name": "Group 12044",
    transform: "translate(184.859 384.396)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12043",
    "data-name": "Group 12043",
    clipPath: "url(#clip-path-152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12042",
    "data-name": "Group 12042",
    transform: "translate(0 0.001)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2590",
    "data-name": "Path 2590",
    d: "M488.531,310.589l3.383,11.686.006.02-3.383-11.685-.006-.02",
    transform: "translate(-488.531 -310.589)",
    fill: "#8c8c8c"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2591",
    "data-name": "Path 2591",
    d: "M488.4,310.6l3.384,11.684a1.676,1.676,0,0,0,.307.579l-3.382-11.685a1.72,1.72,0,0,1-.31-.579",
    transform: "translate(-488.396 -310.578)",
    fill: "#878787"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2592",
    "data-name": "Path 2592",
    d: "M488.3,310.843l3.382,11.684a1.682,1.682,0,0,0,.251.251l-3.384-11.687a1.759,1.759,0,0,1-.248-.248",
    transform: "translate(-487.981 -310.243)",
    fill: "#828282"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12047",
    "data-name": "Group 12047",
    transform: "translate(172.555 385.406)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12046",
    "data-name": "Group 12046",
    transform: "translate(0)",
    clipPath: "url(#clip-path-153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12045",
    "data-name": "Group 12045",
    transform: "translate(0 -4.157)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2594",
    "data-name": "Path 2594",
    d: "M492.963,319.7l3.384,11.687a11.1,11.1,0,0,1,2.41-10.443l-3.382-11.687a11.1,11.1,0,0,0-2.412,10.443",
    transform: "translate(-492.536 -309.258)",
    fill: "#515f82"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12050",
    "data-name": "Group 12050",
    transform: "translate(173.411 381.774)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12049",
    "data-name": "Group 12049",
    transform: "translate(0)",
    clipPath: "url(#clip-path-154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12048",
    "data-name": "Group 12048",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2596",
    "data-name": "Path 2596",
    d: "M492.662,319.157l3.382,11.684a10.287,10.287,0,0,1,2.228-9.674L494.89,309.48a10.285,10.285,0,0,0-2.228,9.677",
    transform: "translate(-492.265 -309.48)",
    fill: "#1c2e61"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12053",
    "data-name": "Group 12053",
    transform: "translate(179.951 387.614)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12052",
    "data-name": "Group 12052",
    transform: "translate(0)",
    clipPath: "url(#clip-path-155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12051",
    "data-name": "Group 12051",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2598",
    "data-name": "Path 2598",
    d: "M489.4,314.228l3.382,11.685a1.739,1.739,0,0,1,.378-1.636,1.886,1.886,0,0,1,2.585-.234l-3.384-11.684a1.883,1.883,0,0,0-2.582.232,1.743,1.743,0,0,0-.378,1.639",
    transform: "translate(-489.328 -311.949)",
    fill: "#1c2e61"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12056",
    "data-name": "Group 12056",
    transform: "translate(180.018 389.892)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12055",
    "data-name": "Group 12055",
    transform: "translate(0)",
    clipPath: "url(#clip-path-156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12054",
    "data-name": "Group 12054",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2600",
    "data-name": "Path 2600",
    d: "M490.578,312.913l3.383,11.685.006.02-3.383-11.685-.006-.02",
    transform: "translate(-490.578 -312.913)",
    fill: "#8c8c8c"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2601",
    "data-name": "Path 2601",
    d: "M490.447,312.921l3.384,11.687a1.672,1.672,0,0,0,.31.582L490.757,313.5a1.729,1.729,0,0,1-.31-.582",
    transform: "translate(-490.442 -312.902)",
    fill: "#878787"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2602",
    "data-name": "Path 2602",
    d: "M490.341,313.167l3.384,11.687a1.8,1.8,0,0,0,.251.251l-3.384-11.687a1.672,1.672,0,0,1-.251-.251",
    transform: "translate(-490.026 -312.566)",
    fill: "#828282"
  }))))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12057",
    "data-name": "Group 12057",
    transform: "translate(199.239 372.845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2604",
    "data-name": "Path 2604",
    d: "M476.076,305.7l3.383,11.685,15.08,12.335-3.383-11.685Z",
    transform: "translate(-476.076 -305.704)",
    fill: "#828282"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12060",
    "data-name": "Group 12060",
    transform: "translate(173.808 391.451)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12059",
    "data-name": "Group 12059",
    transform: "translate(0)",
    clipPath: "url(#clip-path-157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12058",
    "data-name": "Group 12058",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2605",
    "data-name": "Path 2605",
    d: "M493.192,313.572l3.382,11.684.035.118-3.382-11.687-.035-.116",
    transform: "translate(-493.192 -313.572)",
    fill: "#1e3169"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2606",
    "data-name": "Path 2606",
    d: "M492.426,313.621l3.382,11.687a10.039,10.039,0,0,0,1.811,3.408l-3.382-11.684a9.947,9.947,0,0,1-1.811-3.41",
    transform: "translate(-492.391 -313.505)",
    fill: "#1d2f65"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2607",
    "data-name": "Path 2607",
    d: "M491.808,315.063l3.382,11.685a10.3,10.3,0,0,0,1.461,1.461l-3.384-11.685a10.257,10.257,0,0,1-1.459-1.461",
    transform: "translate(-489.961 -311.537)",
    fill: "#1c2e61"
  }))))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12061",
    "data-name": "Group 12061",
    transform: "translate(199.07 373.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2609",
    "data-name": "Path 2609",
    d: "M476.313,306.11l3.383,11.685,14.688,12.015L491,318.124Z",
    transform: "translate(-476.313 -306.11)",
    fill: "#1c2e62"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12064",
    "data-name": "Group 12064",
    transform: "translate(172.983 391.692)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12063",
    "data-name": "Group 12063",
    transform: "translate(0)",
    clipPath: "url(#clip-path-158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12062",
    "data-name": "Group 12062",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2610",
    "data-name": "Path 2610",
    d: "M493.539,313.674l3.384,11.687.038.125L493.577,313.8l-.038-.128",
    transform: "translate(-493.539 -313.674)",
    fill: "#1e3169"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2611",
    "data-name": "Path 2611",
    d: "M492.713,313.728l3.384,11.684a10.68,10.68,0,0,0,1.953,3.675L494.666,317.4a10.81,10.81,0,0,1-1.953-3.675",
    transform: "translate(-492.675 -313.6)",
    fill: "#1d2f65"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2612",
    "data-name": "Path 2612",
    d: "M492.046,315.282l3.384,11.684a11.2,11.2,0,0,0,1.577,1.582l-3.382-11.687a11.077,11.077,0,0,1-1.58-1.58",
    transform: "translate(-490.055 -311.479)",
    fill: "#1c2e61"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12067",
    "data-name": "Group 12067",
    transform: "translate(214.319 385.179)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12066",
    "data-name": "Group 12066",
    transform: "translate(0)",
    clipPath: "url(#clip-path-159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12065",
    "data-name": "Group 12065",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2614",
    "data-name": "Path 2614",
    d: "M475.408,310.92l3.382,11.687a11.084,11.084,0,0,1,1.58,1.58L476.985,312.5a11.08,11.08,0,0,0-1.577-1.582",
    transform: "translate(-475.408 -310.92)",
    fill: "#828282"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2615",
    "data-name": "Path 2615",
    d: "M474.582,311.589l3.384,11.684a10.8,10.8,0,0,1,1.953,3.673l-3.384-11.684a10.737,10.737,0,0,0-1.953-3.673",
    transform: "translate(-473.005 -310.007)",
    fill: "#878787"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12070",
    "data-name": "Group 12070",
    transform: "translate(216.147 387.08)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12069",
    "data-name": "Group 12069",
    transform: "translate(0)",
    clipPath: "url(#clip-path-160)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12068",
    "data-name": "Group 12068",
    transform: "translate(-0.251 -0.319)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2617",
    "data-name": "Path 2617",
    d: "M474.582,311.589l3.384,11.684a10.8,10.8,0,0,1,1.953,3.673l-3.384-11.684a10.737,10.737,0,0,0-1.953-3.673",
    transform: "translate(-474.582 -311.589)",
    fill: "#878787"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12073",
    "data-name": "Group 12073",
    transform: "translate(90.376 393.338)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12072",
    "data-name": "Group 12072",
    clipPath: "url(#clip-path-161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12071",
    "data-name": "Group 12071",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2619",
    "data-name": "Path 2619",
    d: "M528.462,318.748l3.382,11.685c.021.066.04.135.061.2l-3.384-11.684c-.019-.069-.04-.135-.059-.2",
    transform: "translate(-528.462 -308.395)",
    fill: "#8c8c8c"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2620",
    "data-name": "Path 2620",
    d: "M527.151,318.833l3.384,11.684a17.014,17.014,0,0,0,3.1,5.829l-3.384-11.684a17.075,17.075,0,0,1-3.1-5.829",
    transform: "translate(-527.092 -308.279)",
    fill: "#878787"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2621",
    "data-name": "Path 2621",
    d: "M513.2,330.753l3.384,11.685a17.528,17.528,0,0,0,2.511,2.514,18.926,18.926,0,0,0,25.975-2.336,17.6,17.6,0,0,0,3.831-16.558l-3.382-11.687a17.6,17.6,0,0,1-3.834,16.558,18.923,18.923,0,0,1-25.972,2.339,17.648,17.648,0,0,1-2.514-2.514",
    transform: "translate(-510.039 -314.37)",
    fill: "#828282"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12076",
    "data-name": "Group 12076",
    transform: "translate(89.155 392.973)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12075",
    "data-name": "Group 12075",
    clipPath: "url(#clip-path-162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12074",
    "data-name": "Group 12074",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2623",
    "data-name": "Path 2623",
    d: "M528.976,318.9l3.382,11.684.066.222-3.382-11.687c-.024-.073-.045-.147-.066-.22",
    transform: "translate(-528.976 -307.821)",
    fill: "#56668b"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2624",
    "data-name": "Path 2624",
    d: "M527.576,318.995l3.382,11.687a18.249,18.249,0,0,0,3.311,6.217l-3.382-11.687a18.188,18.188,0,0,1-3.311-6.217",
    transform: "translate(-527.51 -307.694)",
    fill: "#546286"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2625",
    "data-name": "Path 2625",
    d: "M512.662,331.734l3.382,11.687a18.963,18.963,0,0,0,2.684,2.686,19.685,19.685,0,0,0,14.29,4.3c10.845-.972,19.018-10.258,18.244-20.732a18.276,18.276,0,0,0-.674-3.774L547.2,314.216a18.293,18.293,0,0,1,.674,3.774c.773,10.474-7.4,19.763-18.244,20.734a19.689,19.689,0,0,1-14.291-4.3,18.707,18.707,0,0,1-2.682-2.689",
    transform: "translate(-509.284 -314.216)",
    fill: "#515f82"
  }))))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12077",
    "data-name": "Group 12077",
    transform: "translate(194.876 379.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2627",
    "data-name": "Path 2627",
    d: "M477.868,308.369l3.383,11.685,15.2,12.437-3.383-11.685Z",
    transform: "translate(-477.868 -308.369)",
    fill: "#1c2e62"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12080",
    "data-name": "Group 12080",
    transform: "translate(210.079 391.583)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12079",
    "data-name": "Group 12079",
    transform: "translate(0)",
    clipPath: "url(#clip-path-163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12078",
    "data-name": "Group 12078",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2628",
    "data-name": "Path 2628",
    d: "M477.763,313.628l3.382,11.685a1.791,1.791,0,0,1,.251.251l-3.382-11.684a1.666,1.666,0,0,0-.251-.251",
    transform: "translate(-477.763 -313.628)",
    fill: "#1c2e61"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2629",
    "data-name": "Path 2629",
    d: "M477.632,313.734l3.382,11.684a1.744,1.744,0,0,1,.31.579l-3.384-11.685a1.671,1.671,0,0,0-.307-.579",
    transform: "translate(-477.381 -313.483)",
    fill: "#1d2f65"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2630",
    "data-name": "Path 2630",
    d: "M477.63,313.979l3.383,11.685.006.02L477.636,314l-.006-.02",
    transform: "translate(-477.071 -313.149)",
    fill: "#1e3169"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12083",
    "data-name": "Group 12083",
    transform: "translate(216.216 387.173)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12082",
    "data-name": "Group 12082",
    transform: "translate(0)",
    clipPath: "url(#clip-path-164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12081",
    "data-name": "Group 12081",
    transform: "translate(-0.319 -0.412)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2632",
    "data-name": "Path 2632",
    d: "M474.582,311.589l3.384,11.684a10.8,10.8,0,0,1,1.953,3.673l-3.384-11.684a10.737,10.737,0,0,0-1.953-3.673",
    transform: "translate(-474.582 -311.589)",
    fill: "#878787"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2633",
    "data-name": "Path 2633",
    d: "M474.566,313.142l3.384,11.684.038.13L474.6,313.272l-.038-.13",
    transform: "translate(-472.613 -309.469)",
    fill: "#8c8c8c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12086",
    "data-name": "Group 12086",
    transform: "translate(213.757 385.818)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12085",
    "data-name": "Group 12085",
    transform: "translate(0)",
    clipPath: "url(#clip-path-165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12084",
    "data-name": "Group 12084",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2635",
    "data-name": "Path 2635",
    d: "M475.7,311.19l3.384,11.687a10.3,10.3,0,0,1,1.461,1.464l-3.382-11.687a10.316,10.316,0,0,0-1.464-1.464",
    transform: "translate(-475.695 -311.19)",
    fill: "#1c2e61"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2636",
    "data-name": "Path 2636",
    d: "M474.929,311.809l3.382,11.687a9.926,9.926,0,0,1,1.812,3.405l-3.382-11.684a10.036,10.036,0,0,0-1.811-3.408",
    transform: "translate(-473.465 -310.345)",
    fill: "#1d2f65"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2637",
    "data-name": "Path 2637",
    d: "M474.914,313.25l3.382,11.685.035.118-3.384-11.687-.033-.116",
    transform: "translate(-471.639 -308.379)",
    fill: "#1e3169"
  }))))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12087",
    "data-name": "Group 12087",
    transform: "translate(190.324 380.142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2639",
    "data-name": "Path 2639",
    d: "M478.89,308.79l3.383,11.685,17.341,14.185-3.383-11.685Z",
    transform: "translate(-478.89 -308.79)",
    fill: "#828282"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12088",
    "data-name": "Group 12088",
    transform: "translate(190.324 379.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2640",
    "data-name": "Path 2640",
    d: "M483.584,308.369a8.668,8.668,0,0,1-4.552,1l17.341,14.184a1.886,1.886,0,0,0,2.594-.234,1.734,1.734,0,0,0-.18-2.509Z",
    transform: "translate(-479.032 -308.369)",
    fill: "#e9e9e9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12091",
    "data-name": "Group 12091",
    transform: "translate(207.665 392.432)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12090",
    "data-name": "Group 12090",
    transform: "translate(0)",
    clipPath: "url(#clip-path-166)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12089",
    "data-name": "Group 12089",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2641",
    "data-name": "Path 2641",
    d: "M477.6,315.881l3.382,11.684a1.888,1.888,0,0,0,2.594-.232,1.763,1.763,0,0,0,.385-1.66l-3.382-11.687a1.766,1.766,0,0,1-.385,1.66,1.886,1.886,0,0,1-2.594.234",
    transform: "translate(-477.601 -313.987)",
    fill: "#828282"
  }))))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12092",
    "data-name": "Group 12092",
    transform: "translate(187.818 382.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2643",
    "data-name": "Path 2643",
    d: "M479.878,309.8l3.383,11.685,17.511,14.323-3.383-11.686Z",
    transform: "translate(-479.878 -309.797)",
    fill: "#1c2e62"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12093",
    "data-name": "Group 12093",
    transform: "translate(96.696 266.289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2644",
    "data-name": "Path 2644",
    d: "M463.625,260.645l3.383,11.685,147.066,120.3-3.383-11.685Z",
    transform: "translate(-463.625 -260.645)",
    fill: "#828282"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12096",
    "data-name": "Group 12096",
    transform: "translate(205.328 396.847)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12095",
    "data-name": "Group 12095",
    transform: "translate(0)",
    clipPath: "url(#clip-path-167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12094",
    "data-name": "Group 12094",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2645",
    "data-name": "Path 2645",
    d: "M479.773,315.854l3.382,11.684a1.644,1.644,0,0,1,.248.248L480.021,316.1a1.756,1.756,0,0,0-.248-.248",
    transform: "translate(-479.773 -315.854)",
    fill: "#1c2e61"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2646",
    "data-name": "Path 2646",
    d: "M479.643,315.959l3.382,11.684a1.673,1.673,0,0,1,.307.579l-3.382-11.687a1.7,1.7,0,0,0-.307-.577",
    transform: "translate(-479.395 -315.711)",
    fill: "#1d2f65"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2647",
    "data-name": "Path 2647",
    d: "M479.64,316.2l3.383,11.685.006.02-3.383-11.685-.006-.02",
    transform: "translate(-479.084 -315.377)",
    fill: "#1e3169"
  }))))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12097",
    "data-name": "Group 12097",
    transform: "translate(185.422 385.246)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2649",
    "data-name": "Path 2649",
    d: "M480.891,310.948l3.383,11.685,17.511,14.323L498.4,325.272Z",
    transform: "translate(-480.891 -310.948)",
    fill: "#828282"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12098",
    "data-name": "Group 12098",
    transform: "translate(182.98 388.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2650",
    "data-name": "Path 2650",
    d: "M481.923,312.122l3.383,11.685,17.511,14.324-3.383-11.685Z",
    transform: "translate(-481.923 -312.122)",
    fill: "#1c2e62"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12099",
    "data-name": "Group 12099",
    transform: "translate(180.584 390.744)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2651",
    "data-name": "Path 2651",
    d: "M482.937,313.273l3.383,11.685,17.511,14.323L500.447,327.6Z",
    transform: "translate(-482.937 -313.273)",
    fill: "#828282"
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12100",
    "data-name": "Group 12100",
    transform: "translate(177.115 396.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2652",
    "data-name": "Path 2652",
    d: "M488.133,315.681l3.383,11.685,8.691,7.109-3.383-11.685Z",
    transform: "translate(-488.133 -315.681)",
    fill: "#1c2e62"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12101",
    "data-name": "Group 12101",
    transform: "translate(185.178 400.74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2653",
    "data-name": "Path 2653",
    d: "M488.762,320.306l3.383,11.685-.629-2.806L488.133,317.5Z",
    transform: "translate(-488.133 -317.5)",
    fill: "#1b2c5f"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12102",
    "data-name": "Group 12102",
    transform: "translate(243.2 386.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2654",
    "data-name": "Path 2654",
    d: "M463.625,312.152l3.383,11.686.561-.638-3.383-11.685Z",
    transform: "translate(-463.625 -311.515)",
    fill: "#686e7e"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12103",
    "data-name": "Group 12103",
    transform: "translate(96.135 266.289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2655",
    "data-name": "Path 2655",
    d: "M465.617,260.645l-.561.638,147.066,120.3.561-.638Z",
    transform: "translate(-465.056 -260.645)",
    fill: "#bdcbe9"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12104",
    "data-name": "Group 12104",
    transform: "translate(96.135 266.927)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2656",
    "data-name": "Path 2656",
    d: "M463.863,260.915l3.383,11.685L614.311,392.9l-3.383-11.686Z",
    transform: "translate(-463.863 -260.915)",
    fill: "#6c7282"
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12105",
    "data-name": "Group 12105",
    transform: "translate(176.554 397.075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2657",
    "data-name": "Path 2657",
    d: "M488.006,315.95l3.383,11.685,9.553,7.814-3.383-11.686Z",
    transform: "translate(-488.006 -315.95)",
    fill: "#1c2e62"
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12106",
    "data-name": "Group 12106",
    transform: "translate(185.806 403.546)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2658",
    "data-name": "Path 2658",
    d: "M488.307,320.029l3.383,11.686-.3-1.343-3.383-11.685Z",
    transform: "translate(-488.006 -318.687)",
    fill: "#1b2c5f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12109",
    "data-name": "Group 12109",
    transform: "translate(202.933 397.694)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12108",
    "data-name": "Group 12108",
    transform: "translate(0)",
    clipPath: "url(#clip-path-168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12107",
    "data-name": "Group 12107",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2659",
    "data-name": "Path 2659",
    d: "M479.612,318.087l3.382,11.687a1.883,1.883,0,0,0,2.58-.239,1.742,1.742,0,0,0,.378-1.639l-3.384-11.685a1.738,1.738,0,0,1-.378,1.639,1.883,1.883,0,0,1-2.578.237",
    transform: "translate(-479.612 -316.212)",
    fill: "#828282"
  }))))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12110",
    "data-name": "Group 12110",
    transform: "translate(184.791 382.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2661",
    "data-name": "Path 2661",
    d: "M484.068,310.034a1.876,1.876,0,0,0-2.578.227,1.726,1.726,0,0,0,.182,2.495l17.511,14.324a1.883,1.883,0,0,0,2.578-.237,1.718,1.718,0,0,0-.182-2.485Z",
    transform: "translate(-481.042 -309.624)",
    fill: "#e9e9e9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12113",
    "data-name": "Group 12113",
    transform: "translate(200.49 402.345)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12112",
    "data-name": "Group 12112",
    transform: "translate(0)",
    clipPath: "url(#clip-path-169)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12111",
    "data-name": "Group 12111",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2662",
    "data-name": "Path 2662",
    d: "M481.819,318.179l3.384,11.684a1.75,1.75,0,0,1,.246.248l-3.384-11.687a1.728,1.728,0,0,0-.246-.246",
    transform: "translate(-481.819 -318.179)",
    fill: "#1c2e61"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2663",
    "data-name": "Path 2663",
    d: "M481.69,318.283l3.384,11.687a1.689,1.689,0,0,1,.305.575L482,318.86a1.682,1.682,0,0,0-.307-.577",
    transform: "translate(-481.444 -318.037)",
    fill: "#1d2f65"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2664",
    "data-name": "Path 2664",
    d: "M481.687,318.527l3.383,11.685.006.02-3.383-11.686-.006-.02",
    transform: "translate(-481.134 -317.704)",
    fill: "#1e3169"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12116",
    "data-name": "Group 12116",
    transform: "translate(214.833 390.805)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12115",
    "data-name": "Group 12115",
    transform: "translate(0)",
    clipPath: "url(#clip-path-170)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12114",
    "data-name": "Group 12114",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2666",
    "data-name": "Path 2666",
    d: "M474.746,322.98l3.382,11.685a10.291,10.291,0,0,0,2.235-9.679L476.979,313.3a10.293,10.293,0,0,1-2.232,9.681",
    transform: "translate(-474.746 -313.299)",
    fill: "#1c2e61"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12119",
    "data-name": "Group 12119",
    transform: "translate(215.478 390.564)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12118",
    "data-name": "Group 12118",
    clipPath: "url(#clip-path-171)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12117",
    "data-name": "Group 12117",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2668",
    "data-name": "Path 2668",
    d: "M474.385,323.647l3.384,11.687a11.336,11.336,0,0,0,2.62-5.245,10.953,10.953,0,0,0-.211-5.207L476.795,313.2a10.913,10.913,0,0,1,.211,5.2,11.279,11.279,0,0,1-2.62,5.245",
    transform: "translate(-474.385 -313.197)",
    fill: "#1c2e61"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12122",
    "data-name": "Group 12122",
    transform: "translate(198.095 403.187)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12121",
    "data-name": "Group 12121",
    transform: "translate(0)",
    clipPath: "url(#clip-path-172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12120",
    "data-name": "Group 12120",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2670",
    "data-name": "Path 2670",
    d: "M481.659,320.415,485.04,332.1a1.879,1.879,0,0,0,2.575-.232,1.757,1.757,0,0,0,.381-1.648l-3.384-11.687a1.748,1.748,0,0,1-.381,1.648,1.871,1.871,0,0,1-2.573.232",
    transform: "translate(-481.659 -318.535)",
    fill: "#828282"
  }))))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12123",
    "data-name": "Group 12123",
    transform: "translate(185.178 400.74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2672",
    "data-name": "Path 2672",
    d: "M484.771,317.5l3.383,11.685,8.578,7.871-3.383-11.685Z",
    transform: "translate(-484.771 -317.5)",
    fill: "#1c2e62"
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12124",
    "data-name": "Group 12124",
    transform: "translate(186.614 403.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2673",
    "data-name": "Path 2673",
    d: "M485.173,318.544l3.383,11.685,6.191,5.684-3.383-11.685Z",
    transform: "translate(-485.173 -318.544)",
    fill: "#1c2e62"
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12125",
    "data-name": "Group 12125",
    transform: "translate(193.449 408.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2674",
    "data-name": "Path 2674",
    d: "M484.771,321.995l3.383,11.685.307-1.166-3.383-11.685Z",
    transform: "translate(-484.771 -320.828)",
    fill: "#1b2c5f"
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12126",
    "data-name": "Group 12126",
    transform: "translate(190.564 408.893)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2675",
    "data-name": "Path 2675",
    d: "M485.173,329.461l3.383,11.685,2.241-8.513-3.383-11.685Z",
    transform: "translate(-485.173 -320.948)",
    fill: "#1b2c5f"
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12127",
    "data-name": "Group 12127",
    transform: "translate(193.219 409.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2676",
    "data-name": "Path 2676",
    d: "M484.9,322.2l3.383,11.685.23-.874-3.383-11.685Z",
    transform: "translate(-484.901 -321.322)",
    fill: "#1b2c5f"
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12128",
    "data-name": "Group 12128",
    transform: "translate(208.168 400.486)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2677",
    "data-name": "Path 2677",
    d: "M475.859,324.966l3.383,11.685,6.664-7.573-3.383-11.685Z",
    transform: "translate(-475.859 -317.393)",
    fill: "#1b2c5f"
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12129",
    "data-name": "Group 12129",
    transform: "translate(208.815 401.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2678",
    "data-name": "Path 2678",
    d: "M475.585,325.189l3.383,11.685,6.664-7.573-3.383-11.685Z",
    transform: "translate(-475.585 -317.616)",
    fill: "#1b2c5f"
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12130",
    "data-name": "Group 12130",
    transform: "translate(228.656 213.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2679",
    "data-name": "Path 2679",
    d: "M398.876,429.383l3.383,11.685L570.483,249.893,567.1,238.208Z",
    transform: "translate(-398.876 -238.208)",
    fill: "#7e7e7e"
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12131",
    "data-name": "Group 12131",
    transform: "translate(218.1 395.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2680",
    "data-name": "Path 2680",
    d: "M470.013,315.4l3.383,11.685,10.556,8.635-3.383-11.685Z",
    transform: "translate(-470.013 -315.398)",
    fill: "#828282"
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12132",
    "data-name": "Group 12132",
    transform: "translate(173.411 373.804)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2681",
    "data-name": "Path 2681",
    d: "M485.672,306.28c-.068.073-.139.149-.206.227l-6.664,7.572a10.157,10.157,0,0,0,1.078,14.664l8.693,7.109-.629-2.807,8.577,7.87-.307,1.168a11.094,11.094,0,0,0,14.721-1.719l6.664-7.572a10.154,10.154,0,0,0-1.076-14.669L501.835,306.11a8.073,8.073,0,0,1-1.807,3.455,8.5,8.5,0,0,1-2.386,1.887l15.2,12.436a1.734,1.734,0,0,1,.18,2.509,1.886,1.886,0,0,1-2.594.234L493.09,312.448a8.21,8.21,0,0,1-4.741-1.83A7.718,7.718,0,0,1,485.672,306.28Zm2.516,11.271a1.725,1.725,0,0,1-.182-2.495,1.876,1.876,0,0,1,2.578-.227l17.511,14.324a1.718,1.718,0,0,1,.182,2.485,1.883,1.883,0,0,1-2.578.237l-17.511-14.324m-4.838,5.5a1.72,1.72,0,0,1-.187-2.49,1.883,1.883,0,0,1,2.582-.232l17.511,14.324a1.723,1.723,0,0,1,.177,2.49,1.871,1.871,0,0,1-2.573.232L483.35,323.049",
    transform: "translate(-476.177 -306.11)",
    fill: "#2d4bac"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12135",
    "data-name": "Group 12135",
    transform: "translate(193.448 408.058)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12134",
    "data-name": "Group 12134",
    transform: "translate(0)",
    clipPath: "url(#clip-path-173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12133",
    "data-name": "Group 12133",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2682",
    "data-name": "Path 2682",
    d: "M478.677,322.314,482.061,334a11.093,11.093,0,0,0,14.718-1.717L493.4,320.595a11.094,11.094,0,0,1-14.721,1.719",
    transform: "translate(-478.677 -320.595)",
    fill: "#1c2e61"
  }))))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12136",
    "data-name": "Group 12136",
    transform: "translate(186.107 404.889)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2684",
    "data-name": "Path 2684",
    d: "M489.649,331.965l3.383,11.685-2.847-12.711L486.8,319.255Z",
    transform: "translate(-486.802 -319.255)",
    fill: "#4e5b7e"
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12137",
    "data-name": "Group 12137",
    transform: "translate(186.614 403.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2685",
    "data-name": "Path 2685",
    d: "M489.628,332.743l3.383,11.685-3.183-14.2-3.383-11.685Z",
    transform: "translate(-486.445 -318.544)",
    fill: "#1b2c5f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12140",
    "data-name": "Group 12140",
    transform: "translate(189.796 417.409)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12139",
    "data-name": "Group 12139",
    transform: "translate(0)",
    clipPath: "url(#clip-path-174)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12138",
    "data-name": "Group 12138",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2686",
    "data-name": "Path 2686",
    d: "M486.451,324.58l3.382,11.684-.007-.031-3.384-11.684.009.031",
    transform: "translate(-486.442 -324.549)",
    fill: "#1c2e61"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12143",
    "data-name": "Group 12143",
    transform: "translate(189.804 417.44)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12142",
    "data-name": "Group 12142",
    transform: "translate(0)",
    clipPath: "url(#clip-path-175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12141",
    "data-name": "Group 12141",
    transform: "translate(0.001 -0.001)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2688",
    "data-name": "Path 2688",
    d: "M486.442,324.562l3.383,11.685v0l-3.382-11.684v0",
    transform: "translate(-486.442 -324.562)",
    fill: "#1e3169"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2689",
    "data-name": "Path 2689",
    d: "M486.414,324.564l3.384,11.685a.36.36,0,0,0,.064.128l-3.382-11.687a.35.35,0,0,1-.066-.125",
    transform: "translate(-486.413 -324.559)",
    fill: "#1d2f65"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2690",
    "data-name": "Path 2690",
    d: "M486.287,324.617l3.382,11.687c.014.017.031.031.045.045a.391.391,0,0,0,.255.08l-3.382-11.684a.41.41,0,0,1-.255-.083.2.2,0,0,1-.045-.045",
    transform: "translate(-486.219 -324.486)",
    fill: "#1c2e61"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12146",
    "data-name": "Group 12146",
    transform: "translate(190.172 417.406)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12145",
    "data-name": "Group 12145",
    transform: "translate(0)",
    clipPath: "url(#clip-path-176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12144",
    "data-name": "Group 12144",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2692",
    "data-name": "Path 2692",
    d: "M486.121,324.839l3.382,11.684a.387.387,0,0,0,.392-.291l-3.382-11.684a.389.389,0,0,1-.393.291",
    transform: "translate(-486.121 -324.548)",
    fill: "#1c2e61"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12149",
    "data-name": "Group 12149",
    transform: "translate(188.969 417.591)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12148",
    "data-name": "Group 12148",
    transform: "translate(0)",
    clipPath: "url(#clip-path-177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12147",
    "data-name": "Group 12147",
    transform: "translate(0.001)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2694",
    "data-name": "Path 2694",
    d: "M486.793,324.654l3.383,11.685,0,.016L486.8,324.67l0-.016",
    transform: "translate(-486.793 -324.587)",
    fill: "#1e3169"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2695",
    "data-name": "Path 2695",
    d: "M486.7,324.661l3.384,11.687a1.205,1.205,0,0,0,.217.411l-3.384-11.684a1.236,1.236,0,0,1-.218-.414",
    transform: "translate(-486.697 -324.578)",
    fill: "#1d2f65"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2696",
    "data-name": "Path 2696",
    d: "M485.77,325.123l3.384,11.684a1.076,1.076,0,0,0,.163.165,1.286,1.286,0,0,0,2.038-.662l-3.382-11.684a1.266,1.266,0,0,1-1.237.939,1.245,1.245,0,0,1-.8-.279,1.078,1.078,0,0,1-.166-.163",
    transform: "translate(-485.548 -324.626)",
    fill: "#1c2e61"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12152",
    "data-name": "Group 12152",
    transform: "translate(188.955 417.6)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12151",
    "data-name": "Group 12151",
    transform: "translate(0)",
    clipPath: "url(#clip-path-178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12150",
    "data-name": "Group 12150",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2698",
    "data-name": "Path 2698",
    d: "M486.809,324.687l3.384,11.687-.017-.059L486.8,324.63l.014.057",
    transform: "translate(-486.795 -324.63)",
    fill: "#515f82"
  }))))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12153",
    "data-name": "Group 12153",
    transform: "translate(193.218 372.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2700",
    "data-name": "Path 2700",
    d: "M496.354,318.677a10.154,10.154,0,0,1,1.076,14.669l-6.664,7.572a11.094,11.094,0,0,1-14.721,1.719l-.229.873a11.986,11.986,0,0,0,15.6-2.062l6.664-7.574a11.279,11.279,0,0,0,2.62-5.245,10.833,10.833,0,0,0-3.779-10.587L481.837,305.7a7.942,7.942,0,0,1-.17.96Z",
    transform: "translate(-475.816 -305.704)",
    fill: "#2d4bac"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12156",
    "data-name": "Group 12156",
    transform: "translate(193.218 408.588)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12155",
    "data-name": "Group 12155",
    transform: "translate(0)",
    clipPath: "url(#clip-path-179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12154",
    "data-name": "Group 12154",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2701",
    "data-name": "Path 2701",
    d: "M478.4,322.881l3.384,11.687a11.987,11.987,0,0,0,15.6-2.064L494,320.819a11.986,11.986,0,0,1-15.6,2.062",
    transform: "translate(-478.403 -320.819)",
    fill: "#1c2e61"
  }))))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12157",
    "data-name": "Group 12157",
    transform: "translate(191.395 410.651)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2703",
    "data-name": "Path 2703",
    d: "M485,328.632l3.383,11.685,1.825-6.94-3.383-11.685Z",
    transform: "translate(-484.998 -321.691)",
    fill: "#1b2c5f"
  }))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12158",
    "data-name": "Group 12158",
    transform: "translate(185.178 400.739)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2704",
    "data-name": "Path 2704",
    d: "M494.779,325.37,486.2,317.5l.629,2.807.3,1.343,2.847,12.711a1.187,1.187,0,0,0,.4.65,1.246,1.246,0,0,0,.8.279,1.266,1.266,0,0,0,1.237-.939l1.823-6.941.229-.873Zm-3.959,8.8-3.183-14.2,6.191,5.685-2.239,8.513a.389.389,0,0,1-.393.291.411.411,0,0,1-.255-.083.351.351,0,0,1-.121-.206",
    transform: "translate(-486.202 -317.5)",
    fill: "#2d4bac"
  }))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12159",
    "data-name": "Group 12159",
    transform: "translate(51.008 316.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2705",
    "data-name": "Path 2705",
    d: "M482.213,281.79l3.383,11.685,148.8,121.715-3.383-11.685Z",
    transform: "translate(-482.213 -281.79)",
    fill: "#515f82"
  }))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12160",
    "data-name": "Group 12160",
    transform: "translate(199.806 404.747)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2706",
    "data-name": "Path 2706",
    d: "M469.836,352.456l3.383,11.685,29.268-33.261L499.1,319.195Z",
    transform: "translate(-469.836 -319.195)",
    fill: "#4e5b7e"
  }))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12161",
    "data-name": "Group 12161",
    transform: "translate(51.007 283.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2707",
    "data-name": "Path 2707",
    d: "M501.183,268.255l-.648-.53-29.269,33.263L620.066,422.7l29.269-33.261-.421-.343-10.556-8.636a11.277,11.277,0,0,1-2.62,5.245l-6.664,7.574a11.986,11.986,0,0,1-15.6,2.062l-1.823,6.941a1.266,1.266,0,0,1-1.237.939,1.246,1.246,0,0,1-.8-.279,1.187,1.187,0,0,1-.4-.65l-2.847-12.711-9.554-7.816a10.951,10.951,0,0,1-1.159-15.825l6.664-7.572q.334-.38.693-.726a7.9,7.9,0,0,1,1.313-5.02Zm62.922,80.216,5.841-6.638a5.987,5.987,0,0,1,8.213-.735l6.73,5.508a5.483,5.483,0,0,1,.586,7.929l-5.841,6.638a5.982,5.982,0,0,1-8.215.74l-6.733-5.505a5.489,5.489,0,0,1-.582-7.936M535.64,325.187l5.841-6.638a5.987,5.987,0,0,1,8.213-.736l6.73,5.505a5.488,5.488,0,0,1,.586,7.931l-5.841,6.638a5.989,5.989,0,0,1-8.218.74l-6.73-5.505a5.487,5.487,0,0,1-.582-7.936M506.53,301.374l5.839-6.638a5.987,5.987,0,0,1,8.213-.736l6.73,5.505a5.484,5.484,0,0,1,.587,7.932l-5.841,6.638a5.982,5.982,0,0,1-8.215.74l-6.73-5.505a5.485,5.485,0,0,1-.582-7.936",
    transform: "translate(-471.266 -267.725)",
    fill: "#8ca6e8"
  }))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12162",
    "data-name": "Group 12162"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2708",
    "data-name": "Path 2708",
    d: "M365.967,485.546l293.8-333.883a10.649,10.649,0,0,1,14.612-1.317l169.568,138.7a9.764,9.764,0,0,1,1.036,14.115l-293.8,333.881a10.649,10.649,0,0,1-14.617,1.322L367,499.664A9.76,9.76,0,0,1,365.967,485.546Zm85.946,62.776a18.3,18.3,0,0,0,6.733,12.9,19.685,19.685,0,0,0,14.29,4.3c10.845-.972,19.018-10.258,18.244-20.732a18.287,18.287,0,0,0-6.73-12.893,19.7,19.7,0,0,0-14.3-4.306c-10.845.972-19.015,10.261-18.242,20.732m111.323,37.726,28.85-33.6L808.9,306.047,661.171,185.2,443.707,431.074l-29.269,33.261,148.8,121.714",
    transform: "translate(-363.429 -148.039)",
    fill: "url(#linear-gradient-2)"
  }))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12163",
    "data-name": "Group 12163",
    transform: "translate(325.911 86.779)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2709",
    "data-name": "Path 2709",
    d: "M427.134,186.177A6.665,6.665,0,0,0,418,187l-2.3,2.613a6.108,6.108,0,0,0,.646,8.825l25.3,20.692,10.791-12.261Zm-2.923,10.831a2.685,2.685,0,0,1-.286-3.89,2.938,2.938,0,0,1,4.03-.364l14.659,11.992a2.694,2.694,0,0,1,.284,3.892,2.933,2.933,0,0,1-4.027.362l-14.659-11.992",
    transform: "translate(-414.115 -184.736)",
    fill: "#3a62e7"
  }))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12164",
    "data-name": "Group 12164",
    transform: "translate(401.966 133.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2710",
    "data-name": "Path 2710",
    d: "M388.8,205.152a2.943,2.943,0,0,0-4.03.362,2.693,2.693,0,0,0,.286,3.892l27.607,22.581a2.931,2.931,0,0,0,4.023-.367,2.692,2.692,0,0,0-.279-3.888Z",
    transform: "translate(-384.069 -204.518)",
    fill: "#bdcbe9"
  }))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12165",
    "data-name": "Group 12165",
    transform: "translate(249.387 37.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2711",
    "data-name": "Path 2711",
    d: "M575.845,284.486,428.35,163.837l-48.592,55.225L527.253,339.709ZM401.315,210.36l2.9-3.3a8.822,8.822,0,0,1,12.091-1.085l118.377,96.831a8.088,8.088,0,0,1,.861,11.68l-4.933,5.609a8.861,8.861,0,0,1-5.962,2.97,8.528,8.528,0,0,1-6.137-1.882L402.044,221.938a8.117,8.117,0,0,1-.728-11.578M521.4,265.615l-2.3,2.613a7.546,7.546,0,0,1-10.344.932L484.973,249.7,457.95,227.6a6.92,6.92,0,0,1-.733-9.994l2.3-2.613a7.546,7.546,0,0,1,10.344-.932l25.3,20.692,25.514,20.869a6.918,6.918,0,0,1,.731,9.994m43.548,21.527a2.93,2.93,0,0,1-4.023.367l-27.607-22.581a2.693,2.693,0,0,1-.286-3.892,2.943,2.943,0,0,1,4.03-.362l27.607,22.582a2.692,2.692,0,0,1,.279,3.888M430.672,180.963a2.693,2.693,0,0,1-.286-3.89,2.941,2.941,0,0,1,4.03-.364l27.607,22.581a2.694,2.694,0,0,1,.281,3.888,2.933,2.933,0,0,1-4.025.367l-27.607-22.581",
    transform: "translate(-379.758 -163.837)",
    fill: "#3a62e7"
  }))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12166",
    "data-name": "Group 12166",
    transform: "translate(335.021 94.161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2712",
    "data-name": "Path 2712",
    d: "M418.551,188.857a2.938,2.938,0,0,1,4.03-.364l14.659,11.992a2.694,2.694,0,0,1,.284,3.892,2.933,2.933,0,0,1-4.027.362l-14.659-11.992A2.685,2.685,0,0,1,418.551,188.857Z",
    transform: "translate(-417.851 -187.857)",
    fill: "#7898e8"
  }))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12167",
    "data-name": "Group 12167",
    transform: "translate(325.056 85.952)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2713",
    "data-name": "Path 2713",
    d: "M428.313,186.015a7.549,7.549,0,0,0-10.344.932l-2.3,2.613a6.92,6.92,0,0,0,.733,9.994l27.023,22.1-1.726-1.412.56-.638-25.3-20.692a6.108,6.108,0,0,1-.646-8.825l2.3-2.613a6.665,6.665,0,0,1,9.138-.823l25.3,20.692.56-.639Z",
    transform: "translate(-413.878 -184.386)",
    fill: "#2d4bac"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12170",
    "data-name": "Group 12170",
    transform: "translate(481.553 145.815)"
  }, _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2714",
    "data-name": "Path 2714",
    d: "M367.535,221.384,364.153,209.7A9.892,9.892,0,0,1,362,219.01l3.384,11.685A9.9,9.9,0,0,0,367.535,221.384Z",
    transform: "translate(-361.999 -209.7)",
    fill: "#cddbfd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12169",
    "data-name": "Group 12169",
    transform: "translate(0)",
    clipPath: "url(#clip-path-180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12168",
    "data-name": "Group 12168",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2715",
    "data-name": "Path 2715",
    d: "M362,219.01l3.384,11.685a9.9,9.9,0,0,0,2.152-9.31L364.153,209.7A9.892,9.892,0,0,1,362,219.01",
    transform: "translate(-361.999 -209.7)",
    fill: "#cddbfd"
  }))))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12171",
    "data-name": "Group 12171",
    transform: "translate(277.899 186.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2717",
    "data-name": "Path 2717",
    d: "M441.259,227.351a2.934,2.934,0,0,0-4.025.359,2.685,2.685,0,0,0,.286,3.89l27.6,22.579a2.931,2.931,0,0,0,4.027-.364,2.686,2.686,0,0,0-.289-3.885Z",
    transform: "translate(-436.533 -226.715)",
    fill: "#bdcbe9"
  }))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12172",
    "data-name": "Group 12172",
    transform: "translate(218.871 195.175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2718",
    "data-name": "Path 2718",
    d: "M457.768,231.786a5.586,5.586,0,0,0-7.667.686,5.123,5.123,0,0,0,.544,7.409l52.527,42.966a5.588,5.588,0,0,0,7.671-.69,5.121,5.121,0,0,0-.546-7.4Z",
    transform: "translate(-448.771 -230.573)",
    fill: "#8ca6e8"
  }))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12173",
    "data-name": "Group 12173",
    transform: "translate(325.061 199.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2719",
    "data-name": "Path 2719",
    d: "M447.324,236.9a21.134,21.134,0,0,0-29,2.611,19.367,19.367,0,0,0,2.057,28.011,21.122,21.122,0,0,0,28.995-2.611A19.367,19.367,0,0,0,447.324,236.9Z",
    transform: "translate(-413.29 -232.318)",
    fill: "#cf684c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12176",
    "data-name": "Group 12176",
    transform: "translate(0.381 346.824)"
  }, _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2720",
    "data-name": "Path 2720",
    d: "M565.2,294.7l3.382,11.684a9.656,9.656,0,0,0,3.188,4.8L568.381,299.5A9.652,9.652,0,0,1,565.2,294.7Z",
    transform: "translate(-565.196 -294.701)",
    fill: "#cddbfd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12175",
    "data-name": "Group 12175",
    clipPath: "url(#clip-path-181)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12174",
    "data-name": "Group 12174",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2721",
    "data-name": "Path 2721",
    d: "M566.53,294.7l3.382,11.684.033.113-3.381-11.687-.033-.111",
    transform: "translate(-566.53 -294.701)",
    fill: "#cddbfd"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2722",
    "data-name": "Path 2722",
    d: "M565.793,294.748l3.382,11.687a9.587,9.587,0,0,0,1.743,3.275l-3.382-11.684a9.557,9.557,0,0,1-1.743-3.278",
    transform: "translate(-565.76 -294.637)",
    fill: "#cddbfd"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2723",
    "data-name": "Path 2723",
    d: "M565.2,296.134l3.382,11.684a9.72,9.72,0,0,0,1.412,1.412l-3.384-11.685a9.939,9.939,0,0,1-1.409-1.412",
    transform: "translate(-563.42 -292.745)",
    fill: "#cddbfd"
  }))))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12177",
    "data-name": "Group 12177",
    transform: "translate(168.157 252.807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2725",
    "data-name": "Path 2725",
    d: "M479.215,256.157a5.586,5.586,0,0,0-7.667.686,5.121,5.121,0,0,0,.544,7.409l52.527,42.966a5.588,5.588,0,0,0,7.671-.691,5.123,5.123,0,0,0-.549-7.4Z",
    transform: "translate(-470.217 -254.944)",
    fill: "#8ca6e8"
  }))), _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12178",
    "data-name": "Group 12178",
    transform: "translate(80.924 37.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2726",
    "data-name": "Path 2726",
    d: "M617.364,163.837,400.306,410.04l103.141,84.369a8.2,8.2,0,0,1,.691-.9,8.507,8.507,0,0,1,11.68-1.052,7.714,7.714,0,0,1,2.8,6.867l15.08,12.335a10.844,10.844,0,0,1,3.781,10.59l10.557,8.636L716.264,339.709,568.769,219.062ZM578.725,474.062a21.124,21.124,0,0,1-28.995,2.611,19.372,19.372,0,0,1-2.057-28.011,21.129,21.129,0,0,1,29-2.611,19.364,19.364,0,0,1,2.048,28.011m99.752-143.7a19.367,19.367,0,0,1,2.048,28.011,21.122,21.122,0,0,1-28.995,2.611,19.369,19.369,0,0,1-2.057-28.011,21.134,21.134,0,0,1,29-2.611M629.438,416.43a21.122,21.122,0,0,1-28.995,2.611,19.367,19.367,0,0,1-2.057-28.011,21.134,21.134,0,0,1,29-2.611,19.367,19.367,0,0,1,2.048,28.011m21.427-108.653a5.12,5.12,0,0,1,.546,7.4,5.588,5.588,0,0,1-7.671.691l-52.527-42.966a5.124,5.124,0,0,1-.544-7.409,5.589,5.589,0,0,1,7.669-.686l52.527,42.966m-50.541,65.46a5.588,5.588,0,0,1-7.671.69l-52.527-42.966a5.121,5.121,0,0,1-.542-7.409,5.586,5.586,0,0,1,7.667-.686l52.527,42.966a5.121,5.121,0,0,1,.546,7.4m-50.713,57.632a5.588,5.588,0,0,1-7.671.691l-52.527-42.966a5.123,5.123,0,0,1-.544-7.409,5.586,5.586,0,0,1,7.667-.686l52.527,42.966a5.123,5.123,0,0,1,.549,7.4m38.83-48.341a2.687,2.687,0,0,1,.284,3.89,2.931,2.931,0,0,1-4.027.364l-55.426-45.338a2.7,2.7,0,0,1-.286-3.892,2.939,2.939,0,0,1,4.03-.362l55.426,45.338m51.087-58.058a2.692,2.692,0,0,1,.286,3.892,2.936,2.936,0,0,1-4.03.364l-55.426-45.338a2.7,2.7,0,0,1-.286-3.892,2.939,2.939,0,0,1,4.03-.362l55.426,45.336m-101.8,115.69a2.685,2.685,0,0,1,.286,3.89,2.94,2.94,0,0,1-4.03.364l-55.424-45.338a2.7,2.7,0,0,1-.286-3.892,2.938,2.938,0,0,1,4.03-.362l55.424,45.338m-9.916,11.268a2.689,2.689,0,0,1,.286,3.89,2.934,2.934,0,0,1-4.03.364l-27.6-22.579a2.687,2.687,0,0,1-.284-3.89,2.94,2.94,0,0,1,4.03-.364l27.6,22.579M578.522,393.8a2.688,2.688,0,0,1,.291,3.885,2.934,2.934,0,0,1-4.03.364l-27.6-22.579a2.689,2.689,0,0,1-.286-3.89,2.934,2.934,0,0,1,4.025-.359l27.6,22.579m51.087-58.056a2.686,2.686,0,0,1,.289,3.885,2.931,2.931,0,0,1-4.027.364l-27.6-22.579a2.689,2.689,0,0,1-.286-3.89,2.931,2.931,0,0,1,4.025-.357l27.6,22.577M415.516,393.406l.563-.639,147.064,120.3-.56.638-147.067-120.3m50.715-57.632.56-.639,147.067,120.3-.563.639-147.064-120.3m51.087-58.056.56-.639,147.064,120.3-.56.639-147.064-120.3",
    transform: "translate(-400.306 -163.837)",
    fill: "#fff"
  }))), _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12179",
    "data-name": "Group 12179",
    transform: "translate(146.848 208.657)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2727",
    "data-name": "Path 2727",
    d: "M444.172,236.274l-.561.638,147.065,120.3.561-.638Z",
    transform: "translate(-443.611 -236.274)",
    fill: "#bdcbe9"
  }))), _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12180",
    "data-name": "Group 12180",
    transform: "translate(89.699 380.694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2728",
    "data-name": "Path 2728",
    d: "M545.118,313.13a18.931,18.931,0,0,0-25.984,2.339,17.352,17.352,0,0,0,1.845,25.1,18.923,18.923,0,0,0,25.973-2.339A17.352,17.352,0,0,0,545.118,313.13Z",
    transform: "translate(-514.629 -309.024)",
    fill: "#e9e9e9"
  }))), _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12181",
    "data-name": "Group 12181",
    transform: "translate(88.431 379.467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2729",
    "data-name": "Path 2729",
    d: "M532.388,308.588c-10.845.972-19.018,10.258-18.244,20.732a18.308,18.308,0,0,0,6.733,12.9,19.689,19.689,0,0,0,14.291,4.3c10.845-.972,19.018-10.261,18.244-20.734a18.3,18.3,0,0,0-6.728-12.893A19.7,19.7,0,0,0,532.388,308.588Zm-10.677,32.684a17.352,17.352,0,0,1-1.845-25.1,18.931,18.931,0,0,1,25.984-2.339,17.352,17.352,0,0,1,1.833,25.1,18.923,18.923,0,0,1-25.972,2.339",
    transform: "translate(-514.093 -308.505)",
    fill: "#8ca6e8"
  }))), _g159 || (_g159 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12182",
    "data-name": "Group 12182",
    transform: "translate(172.556 372.951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2730",
    "data-name": "Path 2730",
    d: "M499.632,305.749q-.358.348-.693.726l-6.664,7.572a10.951,10.951,0,0,0,1.159,15.825l9.554,7.816-.3-1.343-8.693-7.109a10.156,10.156,0,0,1-1.078-14.664L499.58,307c.066-.078.137-.154.206-.227A7.9,7.9,0,0,1,499.632,305.749Z",
    transform: "translate(-489.436 -305.749)",
    fill: "#2d4bac"
  }))), _g160 || (_g160 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12183",
    "data-name": "Group 12183",
    transform: "translate(179.95 387.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2731",
    "data-name": "Path 2731",
    d: "M486.118,312.357a1.883,1.883,0,0,0-2.582.232,1.72,1.72,0,0,0,.187,2.49L501.234,329.4a1.871,1.871,0,0,0,2.573-.232,1.723,1.723,0,0,0-.177-2.49Z",
    transform: "translate(-483.089 -311.949)",
    fill: "#e9e9e9"
  }))), _g161 || (_g161 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12184",
    "data-name": "Group 12184",
    transform: "translate(186.614 403.208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2732",
    "data-name": "Path 2732",
    d: "M486.6,318.544l3.183,14.2a.35.35,0,0,0,.121.206.411.411,0,0,0,.255.083.389.389,0,0,0,.393-.291l2.24-8.513Z",
    transform: "translate(-486.604 -318.544)",
    fill: "#2d4bac"
  }))), _g162 || (_g162 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12185",
    "data-name": "Group 12185",
    transform: "translate(3.567 351.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2733",
    "data-name": "Path 2733",
    d: "M493.491,296.731l3.383,11.685,169.569,138.7-3.383-11.685Z",
    transform: "translate(-493.491 -296.731)",
    fill: "#cddbfd"
  }))), _g163 || (_g163 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12186",
    "data-name": "Group 12186",
    transform: "translate(187.751 155.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2734",
    "data-name": "Path 2734",
    d: "M363.07,547.52l3.383,11.686,293.8-333.884-3.383-11.685Z",
    transform: "translate(-363.07 -213.637)",
    fill: "#cddbfd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12189",
    "data-name": "Group 12189",
    transform: "translate(173.136 489.008)"
  }, _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2735",
    "data-name": "Path 2735",
    d: "M487.31,356.148l3.382,11.684a10.651,10.651,0,0,0,14.617-1.32l-3.384-11.687A10.646,10.646,0,0,1,487.31,356.148Z",
    transform: "translate(-487.31 -354.826)",
    fill: "#cddbfd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12188",
    "data-name": "Group 12188",
    transform: "translate(0)",
    clipPath: "url(#clip-path-182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12187",
    "data-name": "Group 12187",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2736",
    "data-name": "Path 2736",
    d: "M487.31,356.148l3.382,11.684a10.651,10.651,0,0,0,14.617-1.32l-3.384-11.687a10.646,10.646,0,0,1-14.615,1.322",
    transform: "translate(-487.31 -354.826)",
    fill: "#cddbfd"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12194",
    "data-name": "Group 12194",
    transform: "translate(352.983 125.572)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12192",
    "data-name": "Group 12192",
    transform: "translate(0)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2738",
    "data-name": "Path 2738",
    d: "M508.254,240.252c-10.25-8.386-25.773-6.994-34.674,3.121a23.159,23.159,0,0,0,2.46,33.487c10.252,8.386,25.773,6.983,34.664-3.121A23.148,23.148,0,0,0,508.254,240.252Z",
    transform: "translate(-467.57 -234.772)",
    fill: "#dbe6f6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12193",
    "data-name": "Group 12193",
    transform: "translate(6.782 2.722)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2739",
    "data-name": "Path 2739",
    d: "M501.711,240.62a18.287,18.287,0,0,0-25.105,2.26,16.769,16.769,0,0,0,1.781,24.247,18.289,18.289,0,0,0,25.1-2.26A16.761,16.761,0,0,0,501.711,240.62Z",
    transform: "translate(-472.254 -236.652)",
    fill: "#dbe6f6"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12212",
    "data-name": "Group 12212",
    transform: "translate(166.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12204",
    "data-name": "Group 12204",
    transform: "translate(0 10.83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12201",
    "data-name": "Group 12201",
    transform: "translate(0 2.204)"
  }, _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2747",
    "data-name": "Path 2747",
    d: "M580.067,206.21a1.709,1.709,0,0,1-1.8-1.607l-2.912-49.373a1.7,1.7,0,0,1,1.6-1.8L649.99,149.1a1.7,1.7,0,0,1,1.792,1.6l2.912,49.378a1.708,1.708,0,0,1-1.593,1.8Z",
    transform: "translate(-575.353 -123.518)",
    fill: "#97b4fb"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2748",
    "data-name": "Path 2748",
    d: "M578.49,160.328c-.711.614-.531,1.068.41,1.013l73.032-4.325c.935-.056,1.064-.528.284-1.055l-35-23.65a5.865,5.865,0,0,0-6.747.4Z",
    transform: "translate(-577.295 -131.431)",
    fill: "#fff"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2749",
    "data-name": "Path 2749",
    d: "M609.612,134.895a5.864,5.864,0,0,1,6.747-.4l32.091,21.685-68.162,4.037Z",
    transform: "translate(-576.251 -130.452)",
    fill: "#97b4fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12200",
    "data-name": "Group 12200",
    transform: "translate(13.64 8.35)"
  }, _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2750",
    "data-name": "Path 2750",
    d: "M622.533,139.2l-9.564-.566L588.682,137.2l-1.448,24.567-1.448,24.566,24.288,1.437,24.285,1.438,1.448-24.565.578-9.817Z",
    transform: "translate(-585.786 -137.198)",
    fill: "#3e6afa"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "@",
    transform: "translate(6.388 36.463)",
    fill: "#0a0940",
    fontSize: 42,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "@"))), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2751",
    "data-name": "Path 2751",
    d: "M610.567,153.333l.869-14.75L625.287,154.2Z",
    transform: "translate(-574.689 -136.578)",
    fill: "#eebe2d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2752",
    "data-name": "Path 2752",
    d: "M624.418,164.395,610.567,148.77l14.721.872Z",
    transform: "translate(-574.689 -132.016)",
    fill: "#babcbe",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2753",
    "data-name": "Path 2753",
    d: "M576.358,153.551c-.359.21-.31.6.214,1.031l29.454,24.244,18.083-1.07,26.4-27.552c.469-.489.47-.883.09-1.045a1.7,1.7,0,0,1,1.184,1.52l2.912,49.378a1.708,1.708,0,0,1-1.593,1.8l-73.034,4.325a1.709,1.709,0,0,1-1.8-1.607L575.356,155.2A1.7,1.7,0,0,1,576.358,153.551Z",
    transform: "translate(-575.353 -123.492)",
    fill: "#cddbfd"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2754",
    "data-name": "Path 2754",
    d: "M621.3,168.91l30.482,20.6.1,1.7a1.708,1.708,0,0,1-1.593,1.8l-73.034,4.325a1.709,1.709,0,0,1-1.8-1.607l-.1-1.7,27.86-24.053Z",
    transform: "translate(-572.54 -114.647)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12203",
    "data-name": "Group 12203",
    transform: "translate(157.948)"
  }, _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2755",
    "data-name": "Path 2755",
    d: "M475.24,173.282a1.288,1.288,0,0,1-.705-1.674l13.921-34.493a1.278,1.278,0,0,1,1.666-.705l51.02,20.686a1.281,1.281,0,0,1,.7,1.668l-13.922,34.494a1.282,1.282,0,0,1-1.662.711Z",
    transform: "translate(-474.44 -127.039)",
    fill: "#97b4fb"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2756",
    "data-name": "Path 2756",
    d: "M475.032,138.459c-.679.187-.7.555-.048.821L526,159.966c.654.265.893-.014.533-.624L510.37,131.948a4.417,4.417,0,0,0-4.714-1.911Z",
    transform: "translate(-459.302 -129.908)",
    fill: "#fff"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2757",
    "data-name": "Path 2757",
    d: "M504.249,131.563a4.416,4.416,0,0,1,4.713,1.913l14.823,25.117-47.617-19.307Z",
    transform: "translate(-458.786 -129.225)",
    fill: "#97b4fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12202",
    "data-name": "Group 12202",
    transform: "translate(15.434 3.714)"
  }, _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2758",
    "data-name": "Path 2758",
    d: "M501.534,132.986l6.681,2.709,16.967,6.88-6.927,17.162L511.328,176.9l-16.966-6.881L477.4,163.14l6.926-17.161,2.768-6.858Z",
    transform: "translate(-477.397 -132.244)",
    fill: "#3e6afa"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2767",
    "data-name": "Path 2767",
    d: "M16.5,9.926a2.723,2.723,0,0,0-.669-1.8,2.278,2.278,0,0,0-1.845-.8A3.808,3.808,0,0,0,10.8,9.5a8.125,8.125,0,0,0-1.345,4.31,3.67,3.67,0,0,0,.693,2.409,2.174,2.174,0,0,0,1.74.83q2.175,0,3.392-2.538A10.773,10.773,0,0,0,16.5,9.926ZM13.293,25.008q-6.735,0-10.377-4.206A11.534,11.534,0,0,1,0,13.02,12.38,12.38,0,0,1,3.545,4.093Q7.477,0,14.1,0q5.736,0,9.023,2.9A9.07,9.07,0,0,1,26.2,10.006,9.4,9.4,0,0,1,24,16.282a6.383,6.383,0,0,1-4.923,2.6,3.187,3.187,0,0,1-2.353-.765,2.528,2.528,0,0,1-.757-1.845A2.256,2.256,0,0,1,16,15.9q.032-.193.081-.4a5.632,5.632,0,0,1-2.159,2.618,5.253,5.253,0,0,1-2.691.765,4.037,4.037,0,0,1-3.215-1.434,5.46,5.46,0,0,1-1.233-3.69,8.425,8.425,0,0,1,2.1-5.656,5.986,5.986,0,0,1,4.52-2.449,3.939,3.939,0,0,1,2.715.951,3.171,3.171,0,0,1,1.136,2.288l.806-2.707h2.369l-2.143,7.058q-.242.822-.354,1.321a4.079,4.079,0,0,0-.113.886,1.23,1.23,0,0,0,.443,1.055,1.642,1.642,0,0,0,1.007.33,4.14,4.14,0,0,0,3.3-1.917A8.058,8.058,0,0,0,24.025,9.91a7.176,7.176,0,0,0-2.61-5.873A10.764,10.764,0,0,0,14.389,1.9q-6.123,0-9.362,3.577a10.94,10.94,0,0,0-2.771,7.654A9.37,9.37,0,0,0,4.9,19.9q3.094,3.239,8.814,3.239a14.337,14.337,0,0,0,4.979-.846,16.5,16.5,0,0,0,4.222-2.28l1.063,1.45a14.578,14.578,0,0,1-4.334,2.417A17.29,17.29,0,0,1,13.293,25.008Z",
    transform: "translate(14.787 2.681) rotate(14)",
    fill: "#0a0940"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2759",
    "data-name": "Path 2759",
    d: "M504.014,143.291l4.159-10.3-14.443,6.135Z",
    transform: "translate(-484.036 -132.244)",
    fill: "#eebe2d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2760",
    "data-name": "Path 2760",
    d: "M496.6,147.529l14.443-6.136-10.284-4.17Z",
    transform: "translate(-491.068 -130.346)",
    fill: "#babcbe",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2761",
    "data-name": "Path 2761",
    d: "M489.669,136.316c-.313.028-.4.308-.187.77l12.206,26,12.634,5.122,26.811-10.182c.475-.181.6-.447.4-.68a1.283,1.283,0,0,1,.316,1.416l-13.922,34.494a1.282,1.282,0,0,1-1.662.711L475.24,173.282a1.288,1.288,0,0,1-.705-1.674l13.921-34.493A1.278,1.278,0,0,1,489.669,136.316Z",
    transform: "translate(-474.441 -127.039)",
    fill: "#cddbfd"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2762",
    "data-name": "Path 2762",
    d: "M523.672,159.93l14.08,23.859-.479,1.189a1.282,1.282,0,0,1-1.662.711L484.59,165a1.288,1.288,0,0,1-.705-1.674l.479-1.187,26.674-7.332Z",
    transform: "translate(-483.79 -118.758)",
    fill: "#fff"
  })))), _g164 || (_g164 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12211",
    "data-name": "Group 12211",
    transform: "translate(82.055)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12207",
    "data-name": "Group 12207",
    transform: "translate(0 91.075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12205",
    "data-name": "Group 12205"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1237",
    "data-name": "Ellipse 1237",
    cx: 27.651,
    cy: 27.715,
    rx: 27.651,
    ry: 27.715,
    fill: "#cddbfd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12206",
    "data-name": "Group 12206",
    transform: "translate(11.193 16.864)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2763",
    "data-name": "Path 2763",
    d: "M542.731,204.293l0,0a7.22,7.22,0,1,1,7.214,7.4c-.093,0-.182-.01-.274-.013l.434,5.47a69.083,69.083,0,0,1-5.775-7.55C542.25,206.223,542.731,204.293,542.731,204.293Z",
    transform: "translate(-523.777 -196.876)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2764",
    "data-name": "Path 2764",
    d: "M555.789,204.061l0,0a7.221,7.221,0,1,1,7.216,7.4c-.093,0-.182-.01-.275-.014l.436,5.471a68.889,68.889,0,0,1-5.775-7.55C555.307,205.989,555.789,204.061,555.789,204.061Z",
    transform: "translate(-555.741 -196.981)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12210",
    "data-name": "Group 12210",
    transform: "translate(18.514)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12208",
    "data-name": "Group 12208"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1238",
    "data-name": "Ellipse 1238",
    cx: 17.497,
    cy: 17.537,
    rx: 17.497,
    ry: 17.537,
    fill: "#cddbfd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12209",
    "data-name": "Group 12209",
    transform: "translate(7.578 9.636)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2765",
    "data-name": "Path 2765",
    d: "M541.165,134.393l0,0a4.569,4.569,0,1,1,3.628,5.442c-.058-.012-.113-.027-.169-.041l-.365,3.453a43.705,43.705,0,0,1-2.715-5.371C540.641,135.536,541.165,134.393,541.165,134.393Z",
    transform: "translate(-529.295 -128.336)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2766",
    "data-name": "Path 2766",
    d: "M549.26,132.723l0,0a4.569,4.569,0,1,1,3.627,5.442c-.056-.01-.111-.028-.168-.041l-.366,3.453a43.509,43.509,0,0,1-2.713-5.37C548.737,133.866,549.26,132.723,549.26,132.723Z",
    transform: "translate(-549.109 -129.084)",
    fill: "#fff"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.c22f37b692fab3374d415639bbf13ee5.svg";
export { ForwardRef as ReactComponent };